export const shopee_category_list = {
    "error": 0,
    "message": "L\u1ea5y th\u00e0nh c\u00f4ng d\u1eef li\u1ec7u",
    "data": {
        "data": [{
            "main": {
                "catid": 11035567,
                "display_name": "Th\u1eddi Trang Nam",
                "name": "Men Clothes",
                "image": "687f3967b7c2fe6a134a2c11894eea4b",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1550,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035568,
                "display_name": "\u00c1o Kho\u00e1c",
                "name": "Jackets, Coats & Vests",
                "image": "9251aba9f04e2f2407578c8bf1764666",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1549,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035569,
                    "display_name": "\u00c1o Kho\u00e1c M\u00f9a \u0110\u00f4ng & \u00c1o Cho\u00e0ng",
                    "image": "a4fbc05e2702a441e91b9167dc46ad22",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035570,
                    "display_name": "\u00c1o Kho\u00e1c",
                    "image": "97673cdbbcda5281c5519d54b439c3d7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035571,
                    "display_name": "Kh\u00e1c",
                    "image": "3dfc1d979d4eda6b292e67cbdf6da51d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035572,
                "display_name": "\u00c1o Vest v\u00e0 Blazer",
                "name": "Suit Jackets & Blazers",
                "image": "0f42e45eb51e8e25e160eaab370b3477",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1545,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035573,
                    "display_name": "\u00c1o Vest",
                    "image": "b2a1eebb37811dfc1263ddacad3b8761",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035574,
                    "display_name": "\u00c1o Blazer",
                    "image": "185c0dc2d292a6a02e662827ccb915d7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035575,
                    "display_name": "\u00c1o Gi L\u00ea",
                    "image": "077d77538dc429faaceecb7959499379",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035576,
                    "display_name": "B\u1ed9 Com L\u00ea",
                    "image": "03bf3df66a21f5652eca7a8726b4eb5b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035577,
                    "display_name": "Kh\u00e1c",
                    "image": "7b79f53a710f9274854e8a748e329023",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035578,
                "display_name": "\u00c1o Hoodie, \u00c1o Len & \u00c1o N\u1ec9",
                "name": "Hoodies & Sweatshirts",
                "image": "db0745bb3e636523fd2617756fa8b09f",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1539,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035579,
                    "display_name": "\u00c1o Hoodie",
                    "image": "d4ed17bf869b076e45c4020ee7124b53",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035580,
                    "display_name": "\u00c1o N\u1ec9",
                    "image": "98dc67b608ea00e1d1fcb079f760b88c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035581,
                    "display_name": "\u00c1o Len",
                    "image": "2c9f19f094340c56217d5884edf26286",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035582,
                    "display_name": "Kh\u00e1c",
                    "image": "6124eba1e63eb5b8165783d74b2410a1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035583,
                "display_name": "Qu\u1ea7n Jeans",
                "name": "Jeans",
                "image": "5b0689b777035cfe7af759a707027b52",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1534,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035584,
                "display_name": "Qu\u1ea7n D\u00e0i/Qu\u1ea7n \u00c2u",
                "name": "Pants/Suits",
                "image": "6cc0c44875b5d2464fceae41bc7366f8",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1533,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035585,
                    "display_name": "Qu\u1ea7n \u00c2u",
                    "image": "005ee2e3d21a50796a538926d117a815",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035586,
                    "display_name": "Qu\u1ea7n T\u00fai H\u1ed9p",
                    "image": "e38e4b8228444477bc7cf805833845e7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035587,
                    "display_name": "Qu\u1ea7n Jogger",
                    "image": "eee7f0eac8f5109dfe411516b3f320f0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035588,
                    "display_name": "Qu\u1ea7n D\u00e0i",
                    "image": "08ef623fb4c52c0e13e5cc2cd7bec9b7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035589,
                    "display_name": "Kh\u00e1c",
                    "image": "b26ae4a170b68398417a32d615e03707",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035590,
                "display_name": "Qu\u1ea7n Short",
                "name": "Shorts",
                "image": "5df9fef3f414995d6576cc71573660e6",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1527,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035591,
                    "display_name": "Qu\u1ea7n \u0110\u00f9i/Qu\u1ea7n Short",
                    "image": "b79336708d6c04369848f7e5d3f27d49",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035592,
                "display_name": "\u00c1o",
                "name": "Tops",
                "image": "4028340d69c8c74286b31531a3fbfdce",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1525,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035593,
                    "display_name": "\u00c1o S\u01a1 Mi",
                    "image": "f97585cd59b00483d6f2399d8866722c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035594,
                    "display_name": "\u00c1o Polo",
                    "image": "f3e6811f1885342501aa3853257b7ee2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035595,
                    "display_name": "\u00c1o Thun",
                    "image": "bac66dcaaa2347ec51cfe9e570415731",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035596,
                    "display_name": "Kh\u00e1c",
                    "image": "96fcd4d13a30170624aba38f8d8feee8",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035597,
                "display_name": "\u00c1o Ba L\u1ed7",
                "name": "Tanks",
                "image": "e953ee70629ba5770893b9088683f753",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1520,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035598,
                "display_name": "\u0110\u1ed3 L\u00f3t",
                "name": "Innerwear & Underwear",
                "image": "d7ea60e8b6f9940f943d13ef58a3e850",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1519,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035599,
                    "display_name": "Qu\u1ea7n L\u00f3t",
                    "image": "b49e87eeca0863bf51df368445046bd3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035600,
                    "display_name": "\u00c1o L\u00f3t",
                    "image": "fc5e791bef6747766f6fb2157b321201",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035601,
                    "display_name": "\u0110\u1ed3 L\u00f3t Gi\u1eef Nhi\u1ec7t",
                    "image": "957560c013f71a3e518c989a6586efb0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035602,
                    "display_name": "Kh\u00e1c",
                    "image": "773bd3597dacfe9d810288fadcd7fa84",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035603,
                "display_name": "\u0110\u1ed3 Ng\u1ee7",
                "name": "Sleepwear",
                "image": "7d89b8d28669b770fe5fba66fa21e09a",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1514,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035604,
                "display_name": "\u0110\u1ed3 B\u1ed9",
                "name": "Sets",
                "image": "cca565321b356177532133974f7da7a6",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1513,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035605,
                "display_name": "V\u1edb/T\u1ea5t",
                "name": "Socks",
                "image": "0fa64dcece678b1e1d3578464f328bca",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1512,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035606,
                "display_name": "Trang Ph\u1ee5c Truy\u1ec1n Th\u1ed1ng",
                "name": "Traditional Wear",
                "image": "a53258bcba0067500864b8b3ed9591f6",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1511,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035607,
                    "display_name": "\u00c1o",
                    "image": "7bd57ada07889ba7cc6de93e6dc2062a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035608,
                    "display_name": "Qu\u1ea7n",
                    "image": "93f8f118d034adc691fecbe49345aa66",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035609,
                    "display_name": "B\u1ed9",
                    "image": "4e7283e19014088398b5e56ebd193d78",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035610,
                    "display_name": "Kh\u00e1c",
                    "image": "a9fa9a8785927c381bb434162fa9f81b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035611,
                "display_name": "\u0110\u1ed3 H\u00f3a Trang",
                "name": "Costumes",
                "image": "bba3027a635023f03b4c98ddfeb305b0",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1506,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035612,
                "display_name": "Trang Ph\u1ee5c Ng\u00e0nh Ngh\u1ec1",
                "name": "Occupational Attire",
                "image": "cba28fb65d13af89a1e1a709771c672a",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1505,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035613,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "28c7afc9836d133611baecc1283ae98f",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1504,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035614,
                "display_name": "Trang S\u1ee9c Nam",
                "name": "Men Jewelries",
                "image": "a64779862feb4fb5fcac7ed6f4dec1f3",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1503,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035615,
                    "display_name": "Nh\u1eabn",
                    "image": "af10abc8e3dc590674dbab9489bf58a5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035616,
                    "display_name": "B\u00f4ng tai",
                    "image": "63b2d116eed9491d55194b8eb583661f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035617,
                    "display_name": "V\u00f2ng tay & L\u1eafc tay",
                    "image": "12775d513bb5a41f3fdc55e7567af3e6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035618,
                    "display_name": "L\u1eafc ch\u00e2n",
                    "image": "b289042dfffcf469903cd3a8875c3941",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035619,
                    "display_name": "D\u00e2y chuy\u1ec1n",
                    "image": "2fcd1fee020c7fecaefa910ced2ec664",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035620,
                "display_name": "K\u00ednh M\u1eaft Nam",
                "name": "Eyewear",
                "image": "57b90f015f8ea5a41fe8d2043fdbdc06",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1497,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035621,
                    "display_name": "K\u00ednh M\u00e1t",
                    "image": "f7068fae554762a91aae3ae2657f1b79",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035622,
                    "display_name": "G\u1ecdng K\u00ednh",
                    "image": "b72bc65ae6b45e6184fcc623df152821",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035623,
                    "display_name": "H\u1ed9p K\u00ednh V\u00e0 Ph\u1ee5 Ki\u1ec7n",
                    "image": "68289d9d015fb438108c81cc792cbf8c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035624,
                    "display_name": "Kh\u00e1c",
                    "image": "937a34f936222935902020da452556c1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035625,
                "display_name": "Th\u1eaft L\u01b0ng Nam",
                "name": "Belts",
                "image": "0a64484c2848495eb72486f414176d92",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1492,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035626,
                "display_name": "C\u00e0 v\u1ea1t & N\u01a1 c\u1ed5",
                "name": "Neckties, Bow Ties & Cravats",
                "image": "2bf91453f25ead859191f8e63674cda0",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1491,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035627,
                "display_name": "Ph\u1ee5 Ki\u1ec7n Nam",
                "name": "Additional Accessories",
                "image": "8d2ff5f6c753fb2dc08e20c83a92fa03",
                "is_adult": null,
                "parent_category": 11035567,
                "sort_weight": 1490,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035628,
                    "display_name": "Tr\u00e2m & Pin C\u00e0i \u00c1o",
                    "image": "e8340c5bedea260f9eeb684ab8504e5c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035629,
                    "display_name": "Mi\u1ebfng V\u00e1 \u00c1o",
                    "image": "8212e3d82c5a3bd2e09e46fc9fca04f2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035630,
                    "display_name": "M\u1eb7t D\u00e2y Chuy\u1ec1n & Charm",
                    "image": "2fcd1fee020c7fecaefa910ced2ec664",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035632,
                    "display_name": "H\u00ecnh X\u0103m D\u00e1n",
                    "image": "70814bbe902bef04d34edf39316f8228",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035633,
                    "display_name": "Kh\u1ea9u Trang Th\u1eddi Trang",
                    "image": "a4200a14c1253a307a1088e8a67137f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035634,
                    "display_name": "Kh\u0103n Tay",
                    "image": "a7595ef31105cadc03681df401fe8e26",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035635,
                    "display_name": "Ph\u1ee5 Ki\u1ec7n Kh\u00e1c",
                    "image": "9082621ca257f1b778fec042c4070474",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035636,
                    "display_name": "B\u1ed9 ph\u1ee5 ki\u1ec7n",
                    "image": "4a8ef2807b097164c66923d7056e4d57",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035637,
                    "display_name": "G\u0103ng tay",
                    "image": "f0ba07548e8510173b9af5f7af930491",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035638,
                    "display_name": "M\u0169",
                    "image": "9cac565b37651f13005e6296192b9a75",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035631,
                    "display_name": "M\u0103ng S\u00e9t Nam",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11035639,
                "display_name": "Th\u1eddi Trang N\u1eef",
                "name": "Women Clothes",
                "image": "75ea42f9eca124e9cb3cde744c060e4d",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1478,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035648,
                "display_name": "Qu\u1ea7n",
                "name": "Pants & Leggings",
                "image": "299858e064025d073f0acc7798d77274",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1477,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035649,
                    "display_name": "Qu\u1ea7n legging",
                    "image": "23facc012a395867c9c44c254190bbc8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035650,
                    "display_name": "Qu\u1ea7n d\u00e0i",
                    "image": "92b4a135fbb970394252b87dd3cd62d9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035651,
                    "display_name": "Kh\u00e1c",
                    "image": "188256b3c27097458807cad324f6b0fc",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035652,
                "display_name": "Qu\u1ea7n \u0111\u00f9i",
                "name": "Shorts",
                "image": "a5d03e56bc832981c0b14d1b98492b5f",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1473,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035653,
                    "display_name": "Qu\u1ea7n \u0111\u00f9i",
                    "image": "9e88cdd3e32f35c8c19771f8a768aa29",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035654,
                    "display_name": "Qu\u1ea7n v\u00e1y",
                    "image": "7319e5f8571ed293af5815c8ebe1fb42",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035655,
                    "display_name": "Kh\u00e1c",
                    "image": "146ba025b137062af470b94a4eda074f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035656,
                "display_name": "Ch\u00e2n v\u00e1y",
                "name": "Skirts",
                "image": "cdb8fe568c29fa39905dafbe1f4fecd3",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1469,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035657,
                "display_name": "Qu\u1ea7n jeans",
                "name": "Jeans",
                "image": "4c2da6e7db6d589b97b5e55a7dc11aab",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1468,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035658,
                "display_name": "\u0110\u1ea7m/V\u00e1y",
                "name": "Dresses",
                "image": "c102346ca37a44670acf9fb0bce8c4d0",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1467,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035659,
                "display_name": "V\u00e1y c\u01b0\u1edbi",
                "name": "Wedding Dresses",
                "image": "707087f9883aa273a61eabb586d5408b",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1466,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035660,
                "display_name": "\u0110\u1ed3 li\u1ec1n th\u00e2n",
                "name": "Jumpsuits, Playsuits & Overalls",
                "image": "1168812ccc7ac288c01159b211bb89c9",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1465,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035661,
                    "display_name": "\u0110\u1ed3 li\u1ec1n th\u00e2n d\u00e0i tay (Jumpsuits/Rompers)",
                    "image": "16e29b264bb5774fc7598ea8faf9f369",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035662,
                    "display_name": "\u0110\u1ed3 li\u1ec1n th\u00e2n ng\u1eafn tay (playsuits)",
                    "image": "f0b35c18f7d1aa0c29fc2427e28880d9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035663,
                    "display_name": "Qu\u1ea7n y\u1ebfm",
                    "image": "d2b1965b11eade9bb71a9d416b069201",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035664,
                    "display_name": "Kh\u00e1c",
                    "image": "ac52f5fe1485c6b923651f5a95d0bd76",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035665,
                "display_name": "\u00c1o kho\u00e1c, \u00c1o cho\u00e0ng & Vest",
                "name": "Jackets, Coats & Vests",
                "image": "95f50b73f72c05b4aaf04aeaa728eebe",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1460,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035666,
                    "display_name": "\u00c1o kho\u00e1c m\u00f9a \u0111\u00f4ng & \u00c1o cho\u00e0ng",
                    "image": "3817823bdff99bb6bc7dc8087c858e4d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035667,
                    "display_name": "\u00c1o cho\u00e0ng Cape",
                    "image": "ad2b01568dd8676424923c66ff54b3ba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035668,
                    "display_name": "\u00c1o blazer",
                    "image": "9511f54af9673c1e04e72110f0a90520",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035669,
                    "display_name": "\u00c1o kho\u00e1c ngo\u00e0i",
                    "image": "055128f561e1a82fa56d8fd8a956a48f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035670,
                    "display_name": "\u00c1o vest",
                    "image": "5c92221c004a2e7ffe2bb502a8de34e0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035671,
                    "display_name": "Kh\u00e1c",
                    "image": "998e0eb1ad09a527390a20e4a5c2a1db",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035672,
                "display_name": "\u00c1o len & Cardigan",
                "name": "Sweaters & Cardigans",
                "image": "29a77c7aedd317061dff67efffee6957",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1453,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035673,
                "display_name": "Hoodie v\u00e0 \u00c1o n\u1ec9",
                "name": "Hoodies & Sweatshirts",
                "image": "ca7311ecc7029c948ab305ac7d72757d",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1452,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035674,
                    "display_name": "\u00c1o kho\u00e1c n\u1ec9",
                    "image": "636a40b206af6596abd69ae65c979ab9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035675,
                    "display_name": "\u00c1o hoodies",
                    "image": "7bc55437240d3f1500047d281a40145b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035676,
                    "display_name": "Kh\u00e1c",
                    "image": "9486d3917faa54a5a0d0e094799bafa0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035677,
                "display_name": "B\u1ed9",
                "name": "Sets",
                "image": "d7a4f03b15220cc0188112c44ea6de51",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1448,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035678,
                    "display_name": "B\u1ed9 \u0111\u1ed3 \u0111\u00f4i",
                    "image": "19e8aa3402b246df03b636d32207f502",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035679,
                    "display_name": "B\u1ed9 \u0111\u1ed3 gia \u0111\u00ecnh",
                    "image": "f13673635011b8ddc962c10012c6c301",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035680,
                    "display_name": "\u0110\u1ed3 l\u1ebb",
                    "image": "df4b8c46bfa256887264ac04bf85a20e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035681,
                    "display_name": "Kh\u00e1c",
                    "image": "f828cc05138d2fc7864827ad9646d5db",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035682,
                "display_name": "\u0110\u1ed3 l\u00f3t",
                "name": "Lingerie & Underwear",
                "image": "068539fd68043ac677554e36a2577d1f",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1443,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035683,
                    "display_name": "B\u1ed9 \u0111\u1ed3 l\u00f3t",
                    "image": "d69a4d0afe801804b9b3f24bd9ea0b0c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035684,
                    "display_name": "\u00c1o ng\u1ef1c",
                    "image": "51473e59081e6167d977cb0c6d4ed4ed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035685,
                    "display_name": "Qu\u1ea7n l\u00f3t",
                    "image": "150c1f570df7fe4bec6705debc1406ad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035686,
                    "display_name": "\u0110\u1ed3 l\u00f3t gi\u1eef nhi\u1ec7t",
                    "image": "a40e14e70deb92b5af22aa91c64c9822",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035687,
                    "display_name": "Ph\u1ee5 ki\u1ec7n \u0111\u1ed3 l\u00f3t",
                    "image": "c8384b89f749c8bbcd8e28beba60ffed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035688,
                    "display_name": "\u0110\u1ed3 \u0111\u1ecbnh h\u00ecnh",
                    "image": "447dbf072a4db05eef6eaa4a2559fbef",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035689,
                    "display_name": "\u0110\u1ed3 l\u00f3t b\u1ea3o h\u1ed9",
                    "image": "9f5f1527d8b659160f3de1274a611567",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035690,
                    "display_name": "\u0110\u1ed3 l\u00f3t g\u1ee3i c\u1ea3m",
                    "image": "c9e97c631cf2b4bea3615201a6b7eb2f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035691,
                    "display_name": "Kh\u00e1c",
                    "image": "068539fd68043ac677554e36a2577d1f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035692,
                "display_name": "\u0110\u1ed3 ng\u1ee7",
                "name": "Sleepwear & Pajamas",
                "image": "7742c88f8502e179b1b3079dfc3ba307",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1433,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035693,
                    "display_name": "Pyjama",
                    "image": "d80bb689b1788b212469c45f79b804b8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035694,
                    "display_name": "V\u00e1y ng\u1ee7",
                    "image": "3123619f0eda9e307136e246f60aff81",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035695,
                    "display_name": "\u00c1o cho\u00e0ng ng\u1ee7, \u00c1o kho\u00e1c kimono",
                    "image": "a7835779bd21c8815af2a9611af32438",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035696,
                    "display_name": "Kh\u00e1c",
                    "image": "b1a2eacdb7de1dbf633f0842084feccf",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035640,
                "display_name": "\u00c1o",
                "name": "Tops",
                "image": "eaa7259abbf3da20645ba657f3a164e2",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1428,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035641,
                    "display_name": "\u00c1o hai d\u00e2y v\u00e0 ba l\u1ed7",
                    "image": "441c948158566cb98c9b49d8e7611f02",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035642,
                    "display_name": "\u00c1o \u1ed1ng",
                    "image": "849c490039de8d51b943a6671ebe7cdf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035643,
                    "display_name": "\u00c1o thun",
                    "image": "870caeebc7ef91be430ccf05c49d3c64",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035644,
                    "display_name": "\u00c1o s\u01a1 mi",
                    "image": "45fe9b8cf1753b7acb50b11c40c9ebbf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035645,
                    "display_name": "\u00c1o polo",
                    "image": "b6740f18525cfba36ed634b17f48687b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035646,
                    "display_name": "\u00c1o li\u1ec1n th\u00e2n",
                    "image": "ac52f5fe1485c6b923651f5a95d0bd76",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035647,
                    "display_name": "Kh\u00e1c",
                    "image": "80c13aa62c929e966e7424ff7bf38d7f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035730,
                "display_name": "\u0110\u1ed3 t\u1eadp",
                "name": "Sportwear",
                "image": "c5aa300b3491b940c92a7579e2dfec0c",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1420,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035731,
                    "display_name": "\u0110\u1ed3 t\u1eadp theo b\u1ed9",
                    "image": "e5a43dafe52e113e4f02bc9e63d20eb6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035732,
                    "display_name": "\u00c1o kho\u00e1c t\u1eadp",
                    "image": "60d046cc886cd902ac2c349300194218",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035733,
                    "display_name": "\u00c1o thun",
                    "image": "16e462489120cf79c665f82216e0159c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035734,
                    "display_name": "\u00c1o t\u1eadp d\u00e0i tay",
                    "image": "77255ce2a0f07f58ddc7a58b8159161f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035735,
                    "display_name": "Qu\u1ea7n t\u1eadp",
                    "image": "3e1160ebeab28a570440f574ea5a5287",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035736,
                    "display_name": "Qu\u1ea7n \u0111\u00f9i b\u01a1i cho nam",
                    "image": "8faae4bc033cee9af745a73aa3a1ffd0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035737,
                    "display_name": "Bikini",
                    "image": "0c84f906089e8e8eb5fc43daf2fe33ad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035738,
                    "display_name": "\u00c1o b\u01a1i m\u1ed9t m\u1ea3nh",
                    "image": "7289b96216a2a609c8e8a74fbf3aedf9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035739,
                    "display_name": "\u00c1o b\u01a1i d\u00e0i tay / \u00e1o l\u01b0\u1edbt v\u00e1n",
                    "image": "9075c39a1a5b705dd9eb52871d783e71",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035740,
                    "display_name": "Kh\u00e1c",
                    "image": "e4b8faf4cdb75cec78a34692f0ee9ea9",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035697,
                "display_name": "\u0110\u1ed3 B\u1ea7u",
                "name": "Maternity Wear",
                "image": "961a28de30868c2354601fc4d744b2b1",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1409,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035698,
                    "display_name": "\u00c1o ng\u1ef1c cho con b\u00fa",
                    "image": "521b2cf24a76086a1573cd9a6254c826",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035699,
                    "display_name": "\u0110\u1ea7m b\u1ea7u",
                    "image": "5c8b767ed03d0216f857676827dc4630",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035700,
                    "display_name": "\u00c1o b\u1ea7u",
                    "image": "0257e71ea83c2d890aac36b92a2c33c7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035701,
                    "display_name": "\u0110\u1ed3 m\u1eb7c cho con b\u00fa",
                    "image": "35943ffb8cb55ae99a7934bff3ac101b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035702,
                    "display_name": "B\u1ed9 \u0111\u1ed3 b\u1ea7u",
                    "image": "0856859e37842a7f6fd6a84aeb215b35",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035703,
                    "display_name": "Qu\u1ea7n b\u1ea7u, V\u00e1y b\u1ea7u",
                    "image": "8a0ec491c1145a1c75448add9f2f9ba8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035704,
                    "display_name": "Kh\u00e1c",
                    "image": "d2551d303c9713fc00e9a621c29c317e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035705,
                "display_name": "\u0110\u1ed3 truy\u1ec1n th\u1ed1ng",
                "name": "Traditional Wear",
                "image": "51260e2a21eb3d6e0d0663778ecdc10d",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1401,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035706,
                    "display_name": "\u00c1o",
                    "image": "a151c61326214232970d547c7f8a8504",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035707,
                    "display_name": "Qu\u1ea7n v\u00e0 ch\u00e2n v\u00e1y",
                    "image": "84c90af049391f21c8185a6f99c27bf6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035708,
                    "display_name": "B\u1ed9",
                    "image": "c80111c7da0bb6c8f6b0848b94f0e08d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035709,
                    "display_name": "\u0110\u1ea7m",
                    "image": "bbf92056f8f25b02e0abf0a3e1faee4e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035710,
                    "display_name": "Kh\u00e1c",
                    "image": "1783c8e2c60301607ff1c6ea6518bf60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035711,
                "display_name": "\u0110\u1ed3 h\u00f3a trang",
                "name": "Costumes",
                "image": "dfe3e251d609eecaae5be62396cabca7",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1395,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035713,
                "display_name": "V\u1ea3i",
                "name": "Fabric",
                "image": "8a1ef9d07e775060e91694508f7e7df2",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1394,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035716,
                    "display_name": "V\u1ea3i cotton",
                    "image": "52416457533f58c6180a6b2fd68a2589",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035717,
                    "display_name": "V\u1ea3i len",
                    "image": "5e49f458c62e4ebf7cd6268033fe2f1f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035718,
                    "display_name": "V\u1ea3i nhung, l\u1ee5a, satin",
                    "image": "dccc9620e48912a8f34eadffde6bc29b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035719,
                    "display_name": "V\u1ea3i da",
                    "image": "3cfb532f6ea46570d6a166269bc87472",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035720,
                    "display_name": "V\u1ea3i nylon",
                    "image": "79bab4bfdde4b0e69d581fb5951416f8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035721,
                    "display_name": "V\u1ea3i denim/V\u1ea3i b\u00f2",
                    "image": "dd556932ff01fcb08c7f80fff109a315",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035722,
                    "display_name": "V\u1ea3i canvas",
                    "image": "4ba9a1ad71856888e0e548c811dcb687",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035725,
                    "display_name": "Kh\u00e1c",
                    "image": "915b3acc78ff0eacc09a85f13cfdfe5d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035726,
                "display_name": "V\u1edb/ T\u1ea5t",
                "name": "Socks & Stockings",
                "image": "99ed0a3491b96d76407bd109d34a3945",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1381,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035727,
                    "display_name": "T\u1ea5t",
                    "image": "2373cf8f83b71a31757e4c140a06f485",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035728,
                    "display_name": "Qu\u1ea7n t\u1ea5t",
                    "image": "ee9ee8ec9c99bcfaf032976435585b9e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035729,
                    "display_name": "Kh\u00e1c",
                    "image": "46c71e7caa2f8d194717e4d129a6aab9",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035712,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "a643235aea2876af09815344de40dc6f",
                "is_adult": null,
                "parent_category": 11035639,
                "sort_weight": 1377,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036030,
                "display_name": "\u0110i\u1ec7n Tho\u1ea1i & Ph\u1ee5 Ki\u1ec7n",
                "name": "Mobile & Gadgets",
                "image": "31234a27876fb89cd522d7e3db1ba5ca",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1376,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036031,
                "display_name": "\u0110i\u1ec7n tho\u1ea1i",
                "name": "Mobile Phones",
                "image": "6eca5534f7e6588ca98921f3dd8977d8",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1375,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036032,
                    "display_name": "Apple",
                    "image": "616cff6017c0b4f00ad6c2031f100bd3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036033,
                    "display_name": "Samsung",
                    "image": "2af21a65e93a524d536540dade4582de",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036034,
                    "display_name": "Oppo",
                    "image": "bc8ec835d5bb5a90df7e3e61b2f4fcff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036035,
                    "display_name": "Vivo",
                    "image": "0973b72fccaf98961e805cdc59bdc9a6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036036,
                    "display_name": "Realme",
                    "image": "f3d0e4c4bd3a11a4f52c8b5004de3039",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036037,
                    "display_name": "Huawei",
                    "image": "afbe17e0f7612f97d9343cbecf52a3bb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036038,
                    "display_name": "Xiaomi",
                    "image": "60af1113d5dc910214d0049703606c56",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036039,
                    "display_name": "Nokia",
                    "image": "51bc19009a604f0b12f5f73ba650b690",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036040,
                    "display_name": "Kh\u00e1c",
                    "image": "bf6272bd3941739a3149f405d69364bc",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036041,
                "display_name": "M\u00e1y t\u00ednh b\u1ea3ng",
                "name": "Tablets",
                "image": "70a6084a1868b12fe7b3019e4f5883d4",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1362,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036042,
                    "display_name": "Apple",
                    "image": "9dca53cb0e0b2f33ac500c94815e1e13",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036043,
                    "display_name": "Samsung",
                    "image": "8090e8b2ee87ec649896bb540b0099ae",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036044,
                    "display_name": "Huawei",
                    "image": "663c69fdbd9ed2e0323547bb0e45742e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036045,
                    "display_name": "Lenovo",
                    "image": "b8f8a4d2d7e70b2fe72b06578649cfb1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036046,
                    "display_name": "Amazon",
                    "image": "b60c96df7f415fe7ba0d05f05a48a8de",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036047,
                    "display_name": "Kh\u00e1c",
                    "image": "91b83732f530b19770db1ce9518c49b4",
                    "block_buyer_platform": null
                }, {"catid": 11116471, "display_name": "Xiaomi", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11036048,
                "display_name": "Pin D\u1ef1 Ph\u00f2ng",
                "name": "Powerbanks",
                "image": "1057cf00838967399ec090e09e6ca1e5",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1355,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036049,
                    "display_name": "D\u01b0\u1edbi 5.000 mAh",
                    "image": "ea61419e456a15c57c28cdaa887ee61d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036050,
                    "display_name": "5.000 - 10.000 mAh",
                    "image": "85b8e4a4d4802eeac808efd8d6156637",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036051,
                    "display_name": "10.001 - 20.000 mAh",
                    "image": "984da16457bb43a1a2736b275c8ed747",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036052,
                    "display_name": "Tr\u00ean 20.000 mAh",
                    "image": "8ade3db06efa7de5879a1b77972928cc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036053,
                    "display_name": "Ph\u1ee5 ki\u1ec7n pin d\u1ef1 ph\u00f2ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116443,
                    "display_name": "Bao Pin D\u1ef1 Ph\u00f2ng",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036054,
                "display_name": "Pin G\u1eafn Trong, C\u00e1p v\u00e0 B\u1ed9 S\u1ea1c",
                "name": "Batteries, Cables & Charger",
                "image": "f33482e0b6d7cc1016ffa6f05e37a073",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1349,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036055,
                    "display_name": "Pin G\u1eafn trong",
                    "image": "cfdd16b221913374e2a723356b48d9eb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036056,
                    "display_name": "C\u00e1p S\u1ea1c v\u00e0 \u0111\u1ea7u chuy\u1ec3n \u0111\u1ed5i",
                    "image": "15caab8ee0351d42a9481f0c041d23c9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036058,
                    "display_name": "\u0110\u1ebf s\u1ea1c",
                    "image": "32862d61b322e159bfc2680be42aa0b2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036059,
                    "display_name": "Kh\u00e1c",
                    "image": "814fa4e672d5d7ff5a1c4647a9c07674",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036057,
                    "display_name": "C\u1ed1c/B\u1ed9 s\u1ea1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036060,
                "display_name": "\u1ed0p l\u01b0ng, bao da, Mi\u1ebfng d\u00e1n \u0111i\u1ec7n tho\u1ea1i",
                "name": "Cases, Covers, & Skins",
                "image": "0a3a54b287c4f6ff731216a302265c34",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1343,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036061,
                    "display_name": "\u1ed0p l\u01b0ng, bao da, mi\u1ebfng d\u00e1n m\u1eb7t l\u01b0ng cho M\u00e1y t\u00ednh b\u1ea3ng",
                    "image": "dfd3c92d18ff459299a2ed7aca92aae6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036062,
                    "display_name": "\u1ed0p l\u01b0ng, bao da, mi\u1ebfng d\u00e1n m\u1eb7t l\u01b0ng cho \u0110i\u1ec7n tho\u1ea1i",
                    "image": "6a6c4f502a5530804462f43265be0cd6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036063,
                    "display_name": "\u1ed0p l\u01b0ng, bao da, mi\u1ebfng d\u00e1n thi\u1ebft b\u1ecb kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036064,
                "display_name": "B\u1ea3o v\u1ec7 m\u00e0n h\u00ecnh",
                "name": "Screen Protectors",
                "image": "f19bc122a374d195ab83a08d1317361c",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1339,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036073,
                    "display_name": "Mi\u1ebfng d\u00e1n kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116444,
                    "display_name": "Mi\u1ebfng d\u00e1n c\u01b0\u1eddng l\u1ef1c",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116445,
                    "display_name": "Mi\u1ebfng d\u00e1n ch\u1ea5t li\u1ec7u kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036083,
                "display_name": "Th\u1ebb nh\u1edb",
                "name": "Memory Cards",
                "image": "c6ac426ae524c13cc291fe06e211ddeb",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1320,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036084,
                "display_name": "Sim",
                "name": "Sims",
                "image": "825e9b8f1cb5df1ed6857c096fe8096f",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 1319,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036085,
                    "display_name": "Vinaphone",
                    "image": "09363dca3f941cf58f132f902337253e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036086,
                    "display_name": "Mobifone",
                    "image": "9e83e41f8b2a40db45058af556d0b721",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036087,
                    "display_name": "Viettel",
                    "image": "999af23b031dbeb74c0c2401f1233a6e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036088,
                    "display_name": "Vietnamobile",
                    "image": "7e517e3c98487d38336c5ac4eda455d0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036090,
                    "display_name": "Kh\u00e1c",
                    "image": "48d047902a8e09b99cbf9372fdb9d2e8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036089,
                    "display_name": "B\u1ed9 ph\u00e1t wifi di \u0111\u1ed9ng",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036074,
                "display_name": "\u0110\u1ebf gi\u1eef \u0111i\u1ec7n tho\u1ea1i",
                "name": "Phone Holders",
                "image": "",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036076,
                    "display_name": "G\u1eady \u0111u\u00f4i kh\u1ec9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036078,
                    "display_name": "Gi\u00e1 \u0111\u1ee1 \u0111i\u1ec7n tho\u1ea1i",
                    "image": "30192fe291226a0009fc4e9e720399af",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036079,
                    "display_name": "D\u00e2y \u0111eo \u0111i\u1ec7n tho\u1ea1i v\u00e0 m\u00f3c kh\u00f3a",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036091,
                "display_name": "Ph\u1ee5 ki\u1ec7n kh\u00e1c",
                "name": "Other Accessories",
                "image": "",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036094,
                    "display_name": "B\u00fat C\u1ea3m \u1ee9ng",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036095,
                    "display_name": "\u0110\u00e8n Usb",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036096,
                    "display_name": "Kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116450,
                    "display_name": "T\u00fai \u0111\u1ef1ng \u0111i\u1ec7n tho\u1ea1i",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036097,
                "display_name": "Thi\u1ebft b\u1ecb kh\u00e1c",
                "name": "Other devices",
                "image": "",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036100,
                    "display_name": "Kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116451,
                    "display_name": "B\u1ed9 \u0111\u00e0m",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116452,
                    "display_name": "\u0110i\u1ec7n Tho\u1ea1i B\u00e0n",
                    "image": "",
                    "block_buyer_platform": null
                }, {"catid": 11116599, "display_name": "M\u00e1y Fax", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11116447,
                "display_name": "Nhi\u1ebfp \u1ea3nh \u0111i\u1ec7n tho\u1ea1i",
                "name": "Mobile Photography",
                "image": "",
                "is_adult": null,
                "parent_category": 11036030,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036075,
                    "display_name": "G\u1eady Ch\u1ee5p h\u00ecnh & Ph\u1ee5 Ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036077,
                    "display_name": "\u0110i\u1ec1u khi\u1ec3n ch\u1ee5p h\u00ecnh",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036080,
                    "display_name": "Tay c\u1ea7m ch\u1ed1ng rung",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036081,
                    "display_name": "Ch\u00e2n m\u00e1y \u1ea3nh & g\u1eady",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036092,
                    "display_name": "\u1ed0ng k\u00ednh \u0111i\u1ec7n tho\u1ea1i",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036093,
                    "display_name": "\u0110\u00e8n Flash di \u0111\u1ed9ng",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036194,
                "display_name": "M\u1eb9 & B\u00e9",
                "name": "Moms, Kids & Babies",
                "image": "099edde1ab31df35bc255912bab54a5e",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1302,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036195,
                "display_name": "\u0110\u1ed3 d\u00f9ng du l\u1ecbch cho b\u00e9",
                "name": "Baby Travel Essentials",
                "image": "b00214bbde1c76dd9118a9f2f0766759",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1301,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036196,
                    "display_name": "\u0110\u1ecbu em b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036197,
                    "display_name": "Xe \u0111\u1ea9y",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036198,
                    "display_name": "Ph\u1ee5 ki\u1ec7n xe \u0111\u1ea9y",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036199,
                    "display_name": "Gh\u1ebf ng\u1ed3i \u00f4 t\u00f4 & xe m\u00e1y",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036200,
                    "display_name": "Ph\u1ee5 ki\u1ec7n gh\u1ebf ng\u1ed3i \u00f4 t\u00f4 & xe m\u00e1y",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036201,
                    "display_name": "T\u00fai \u0111\u1ef1ng b\u1ec9m s\u1eefa",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036202,
                    "display_name": "D\u00e2y & \u0110ai d\u1eaft tr\u1ebb",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036203,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036204,
                "display_name": "\u0110\u1ed3 d\u00f9ng \u0103n d\u1eb7m cho b\u00e9",
                "name": "Feeding Essentials",
                "image": "d402cc89fb4e8bfe5a861e205e0deaa4",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1292,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036205,
                    "display_name": "B\u00ecnh s\u1eefa",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036206,
                    "display_name": "\u0110\u1ed3 d\u00f9ng cho con b\u00fa",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036207,
                    "display_name": "Gh\u1ebf \u0103n d\u1eb7m",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036208,
                    "display_name": "\u0110\u1ed3 d\u00f9ng cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036209,
                    "display_name": "Y\u1ebfm",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036210,
                    "display_name": "Ti gi\u1ea3",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036211,
                    "display_name": "M\u00e1y xay c\u1eaft th\u1ef1c ph\u1ea9m",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036212,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036213,
                "display_name": "Ph\u1ee5 ki\u1ec7n cho m\u1eb9",
                "name": "Maternity Accessories",
                "image": "26ea029f69775ded6a813a6fabfc009b",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1283,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036214,
                    "display_name": "\u0110ai h\u1ed7 tr\u1ee3 b\u1ee5ng",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036215,
                    "display_name": "G\u1ed1i b\u1ea7u",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036216,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036217,
                "display_name": "Ch\u0103m s\u00f3c s\u1ee9c kh\u1ecfe m\u1eb9",
                "name": "Maternity Healthcare",
                "image": "ed3955256306e2619c305530d6a87f94",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1279,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036218,
                    "display_name": "S\u1eefa b\u1ea7u",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036219,
                    "display_name": "Vitamin & Th\u1ef1c ph\u1ea9m b\u1ed5 sung cho m\u1eb9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036220,
                    "display_name": "Kem d\u01b0\u1ee1ng \u1ea9m cho m\u1eb9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036221,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036222,
                "display_name": "\u0110\u1ed3 d\u00f9ng ph\u00f2ng t\u1eafm & Ch\u0103m s\u00f3c c\u01a1 th\u1ec3 b\u00e9",
                "name": "Bath & Body Care",
                "image": "b47125a4cf4f94f5ddbc59b9227bc6c5",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1274,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036223,
                    "display_name": "Ch\u1eadu t\u1eafm & Gh\u1ebf t\u1eafm",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036224,
                    "display_name": "\u00c1o cho\u00e0ng t\u1eafm, Kh\u0103n t\u1eafm & Kh\u0103n m\u1eb7t",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036225,
                    "display_name": "N\u00f3n t\u1eafm",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036226,
                    "display_name": "D\u1ee5ng c\u1ee5 t\u1eafm & Ph\u1ee5 ki\u1ec7n",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036227,
                    "display_name": "S\u1ea3n ph\u1ea9m t\u1eafm & g\u1ed9i cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036228,
                    "display_name": "N\u01b0\u1edbc hoa cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036229,
                    "display_name": "B\u1ed9 ch\u0103m s\u00f3c tr\u1ebb s\u01a1 sinh",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036230,
                    "display_name": "Kh\u0103n lau",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036231,
                    "display_name": "Gi\u1eb7t x\u1ea3 qu\u1ea7n \u00e1o tr\u1ebb em",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036232,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036233,
                "display_name": "\u0110\u1ed3 d\u00f9ng ph\u00f2ng ng\u1ee7 cho b\u00e9",
                "name": "Nursery",
                "image": "ecc2ec58fb29385a3e8648815ea8e0b6",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1263,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036234,
                    "display_name": "N\u00f4i & C\u0169i & Gi\u01b0\u1eddng cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036235,
                    "display_name": "Gh\u1ebf rung, Gh\u1ebf nh\u00fan & X\u00edch \u0111u t\u1eadp \u0111i",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036236,
                    "display_name": "Xe t\u1eadp \u0111i",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036237,
                    "display_name": "N\u1ec7m v\u00e0 ch\u0103n ga",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036238,
                    "display_name": "K\u1ec7 & T\u1ee7",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036239,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036240,
                "display_name": "An to\u00e0n cho b\u00e9",
                "name": "Baby Safety",
                "image": "7505b3703245155b566010d058d8e68e",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1256,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036241,
                    "display_name": "Thi\u1ebft b\u1ecb gi\u00e1m s\u00e1t tr\u1ebb",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036242,
                    "display_name": "M\u00e0n ch\u1ed1ng mu\u1ed7i",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036243,
                    "display_name": "B\u1ed9 \u0111\u1ec7m c\u0169i, Qu\u00e2y c\u0169i & Thanh ch\u1eafn gi\u01b0\u1eddng",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036244,
                    "display_name": "B\u1ecdc g\u00f3c & C\u1ea1nh",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036245,
                    "display_name": "Thanh ch\u1eafn c\u1eeda & C\u1ea7u thang",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036246,
                    "display_name": "Kh\u00f3a & D\u00e2y \u0111ai an to\u00e0n",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036247,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036248,
                "display_name": "Th\u1ef1c ph\u1ea9m cho b\u00e9",
                "name": "Baby Food",
                "image": "733fc8cc2b84800e0ba5e61c244e5418",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1248,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036250,
                    "display_name": "Ch\u00e1o, Th\u1ef1c ph\u1ea9m xay nhuy\u1ec5n & Ng\u0169 c\u1ed1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036251,
                    "display_name": "\u0110\u1ed3 \u0103n nh\u1eb9 cho b\u00e9 & kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036253,
                "display_name": "Ch\u0103m s\u00f3c s\u1ee9c kh\u1ecfe b\u00e9",
                "name": "Baby Healthcare",
                "image": "7f299998543d6acfd0cd2a5e525afadd",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1245,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036254,
                    "display_name": "Vitamin & Th\u1ef1c ph\u1ea9m b\u1ed5 sung",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036255,
                    "display_name": "Ch\u0103m s\u00f3c m\u0169i cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036256,
                    "display_name": "Ch\u0103m s\u00f3c da cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036257,
                    "display_name": "Ch\u0103m s\u00f3c r\u0103ng mi\u1ec7ng cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036258,
                    "display_name": "Ch\u1ed1ng n\u1eafng cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036259,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036260,
                "display_name": "T\u00e3 & b\u00f4 em b\u00e9",
                "name": "Diapering & Potty",
                "image": "7ab979da971f70ae322249903fc34720",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1238,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036261,
                    "display_name": "T\u1ea5m thay t\u00e3 cho b\u00e9",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036262,
                    "display_name": "B\u1ec7 thu nh\u1ecf b\u1ed3n c\u1ea7u & B\u00f4 v\u1ec7 sinh",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036263,
                    "display_name": "T\u00e3 d\u00f9ng m\u1ed9t l\u1ea7n",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036264,
                    "display_name": "T\u00e3 v\u1ea3i & Ph\u1ee5 ki\u1ec7n",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036265,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036266,
                "display_name": "\u0110\u1ed3 ch\u01a1i",
                "name": "Toys",
                "image": "4b126234b32abb98ec6f710f8c9ea56b",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1232,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036267,
                    "display_name": "\u0110\u1ed3 ch\u01a1i cho tr\u1ebb s\u01a1 sinh & tr\u1ebb nh\u1ecf",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036277,
                "display_name": "B\u1ed9 & G\u00f3i qu\u00e0 t\u1eb7ng",
                "name": "Gift Sets & Packages",
                "image": "e3ca692da9341360a47ace28a8c46c0c",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1230,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036278,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "83487a1a34339a6f1a65b0c5df4d8cf4",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1229,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11059299,
                "display_name": "S\u1eefa c\u00f4ng th\u1ee9c tr\u00ean 24 th\u00e1ng",
                "name": "Milk 24 months and ups",
                "image": "e288ae38138761f10a63e5aab66627b7",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1228,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11059300,
                "display_name": "S\u1eefa c\u00f4ng th\u1ee9c 0-24 th\u00e1ng tu\u1ed5i",
                "name": "Milk Formula 0- 24 months",
                "image": "436c1690e586542b835b11a5bf5f8291",
                "is_adult": null,
                "parent_category": 11036194,
                "sort_weight": 1227,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036132,
                "display_name": "Thi\u1ebft B\u1ecb \u0110i\u1ec7n T\u1eed",
                "name": "Consumer Electronics",
                "image": "978b9e4cb61c611aaaf58664fae133c5",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1226,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036160,
                "display_name": "Thi\u1ebft b\u1ecb \u0111eo th\u00f4ng minh",
                "name": "Wearable Devices",
                "image": "549cc2c93c5ada75120de647fd5b64e1",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1225,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036161,
                    "display_name": "Thi\u1ebft b\u1ecb \u0111\u1ecbnh v\u1ecb GPS",
                    "image": "dc98a94952867282aed68c65801b5321",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036162,
                    "display_name": "Thi\u1ebft b\u1ecb th\u1ef1c t\u1ebf \u1ea3o",
                    "image": "423ac36cf1d51fe29d2c41880578a260",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036163,
                    "display_name": "Kh\u00e1c",
                    "image": "b8d2a68f9d75cb0805fadb93c503201f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036164,
                    "display_name": "\u0110\u1ed3ng h\u1ed3 th\u00f4ng minh & v\u00f2ng tay s\u1ee9c kh\u1ecfe",
                    "image": "264995a5cda4773ebb207374d55338fd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036166,
                    "display_name": "Ph\u1ee5 ki\u1ec7n \u0111\u1ed3ng h\u1ed3 th\u00f4ng minh",
                    "image": "6b5c1cbc2670d84fc9604c1226faba53",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036167,
                "display_name": "Ph\u1ee5 ki\u1ec7n tivi",
                "name": "Tivi Accessories",
                "image": "01ad270503f331db0e9e50d786da5ac6",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1218,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036169,
                    "display_name": "Gi\u00e1 treo tivi",
                    "image": "327bb7929f333ce0d15f071dc3c2f88d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036170,
                    "display_name": "Remote Tivi",
                    "image": "ff2fff89909c569e155756e4da4d49a0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036171,
                    "display_name": "\u0102ng ten TV",
                    "image": "830f3b16f0df6ed984d792fe4de03701",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109138,
                    "display_name": "Kh\u00e1c",
                    "image": "949fa44858ebf03bed8e2161c012e4c9",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036172,
                "display_name": "M\u00e1y Game Console",
                "name": "Gaming & Console",
                "image": "9455f1868243470f902109ca64e5b984",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1213,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036173,
                    "display_name": "Playstation",
                    "image": "c13985cbf5e3e6ef0df04256acddaf13",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036174,
                    "display_name": "Xbox",
                    "image": "082d761fc285a02e37edfdf137bf413e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036175,
                    "display_name": "Wii",
                    "image": "53e7194a10ddeab531bd1c8024dbec72",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036176,
                    "display_name": "Nintendo DS",
                    "image": "bac3ffba20c30bfd30cc02dff1061f53",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036177,
                    "display_name": "Gameboy",
                    "image": "e3718cef65b4a94e902469051bd33a2d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036178,
                    "display_name": "Switch",
                    "image": "5119a7fbb57a375e247011eb40d2e4bf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036179,
                    "display_name": "PS Vita",
                    "image": "c7ae08180ecd5cb92da4e983bda14d63",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036180,
                    "display_name": "PSP",
                    "image": "71ce75664196aa22769aff38af6c9a30",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036181,
                    "display_name": "Kh\u00e1c",
                    "image": "33e7c66cc7e14aea41bd44bf47200e0c",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036182,
                "display_name": "Ph\u1ee5 ki\u1ec7n Console",
                "name": "Console Accessories",
                "image": "1725108461beb4e138e30faf0947021c",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1203,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036183,
                    "display_name": "Ph\u1ee5 ki\u1ec7n Console",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036184,
                "display_name": "\u0110\u0129a game",
                "name": "Video Games",
                "image": "ab997b3f70e9b07f7eb07d184e888f49",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1201,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036185,
                    "display_name": "Playstation",
                    "image": "a84428f1ada23658429b816504005bdd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036186,
                    "display_name": "Xbox",
                    "image": "31ac7622bfa50330b2858c45b0f8f4d2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036187,
                    "display_name": "Wii",
                    "image": "44703795350a36763c69e2986931c828",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036188,
                    "display_name": "Nintendo DS",
                    "image": "b85de40686a2958e7c2ece57c6441b24",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036189,
                    "display_name": "Gameboy",
                    "image": "d59391396e355d6d5b4ed10a725d7a29",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036190,
                    "display_name": "Switch",
                    "image": "320a7c77363490696177a83ee7e1d8d7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036191,
                    "display_name": "PS Vita",
                    "image": "60eb872f5e3d5cff1e1b5894657ab3e6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036192,
                    "display_name": "PSP",
                    "image": "184288c2124aec75636f570c4b74a693",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036193,
                    "display_name": "Others",
                    "image": "cd865296b4699fbf376d9efa71d92415",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109139,
                    "display_name": "PC",
                    "image": "46c6476179ae0a1fae3329f376bb035e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036133,
                "display_name": "Linh ph\u1ee5 ki\u1ec7n",
                "name": "Accessories and spare parts",
                "image": "f9a05edc3bb84bca88086e72fbb741fb",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1191,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036135,
                "display_name": "Loa",
                "name": "Audio",
                "image": "e7765221252c934614aa7e830c8c9b54",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1189,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036137,
                    "display_name": "M\u00e1y nghe nh\u1ea1c",
                    "image": "10389a931291e56c7421c47e6437f007",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036139,
                    "display_name": "Loa bluetooth",
                    "image": "351e086f91a0bed738397affc770aba7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036140,
                    "display_name": "Loa di \u0111\u1ed9ng",
                    "image": "c302f13f72a709b19e879e055953dcac",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036141,
                    "display_name": "Amply & Mixer",
                    "image": "f0f5613bc05d0f8914e7a35ff38712bb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036142,
                    "display_name": "D\u00e0n \u00e2m thanh",
                    "image": "3a65797e997df00ca7beee735658b62d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109134,
                    "display_name": "Microphones",
                    "image": "7bbcf8fb98454ea693cc5c5de16fe8da",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109135,
                    "display_name": "AV Receivers",
                    "image": "fd5432c03368779bfc5f2a41ade43f2e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109136,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109137,
                    "display_name": "D\u00e2y c\u00e1p, b\u1ed9 chuy\u1ec3n \u0111\u1ed5i \u00e2m thanh & video",
                    "image": "449d9518860dbdaa51f2d10fd45c2234",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109140,
                    "display_name": "Loa th\u00f4ng minh",
                    "image": "0111b6c3b788bc00df657cbb7f9867c6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036151,
                "display_name": "Tivi",
                "name": "Tivi",
                "image": "6111582fcd108674fbc2824599457fe5",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1173,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036152,
                    "display_name": "D\u01b0\u1edbi 33 inches",
                    "image": "dba41c2c6bb0fdeb3dd2a485e8acca0e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036153,
                    "display_name": "33 - 39 inches",
                    "image": "1895f4f64ec72937aa5613e90ce25e63",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036154,
                    "display_name": "40 - 49 inches",
                    "image": "8944f3fb86903d86fbbd2153b0db22a7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036155,
                    "display_name": "50 - 60 inches",
                    "image": "ad8bbfe016d7487065b5db28007d1af8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036156,
                    "display_name": "L\u1edbn h\u01a1n 60 inches",
                    "image": "d19349a3011bb6c1051bff3999ac0dd6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036157,
                "display_name": "Tivi Box",
                "name": "Tivi Box",
                "image": "ef6483fac1adb53e3f9e108b886fe341",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 1167,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036143,
                "display_name": "Tai nghe nh\u00e9t tai",
                "name": "Earphones",
                "image": "",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11109141,
                "display_name": "Headphones",
                "name": "Headphones",
                "image": "",
                "is_adult": null,
                "parent_category": 11036132,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036670,
                "display_name": "Nh\u00e0 C\u1eeda & \u0110\u1eddi S\u1ed1ng",
                "name": "Home & Living",
                "image": "24b194a695ea59d384768b7b471d563f",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1164,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036683,
                "display_name": "Ch\u0103n, Ga, G\u1ed1i & N\u1ec7m",
                "name": "Bedding",
                "image": "f733d34a4a4a26df73d8c8b667ba10f6",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1163,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036684,
                    "display_name": "Kh\u00e1c",
                    "image": "3c08f855122e25db7888a23c604472ef",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036694,
                    "display_name": "M\u00f9ng",
                    "image": "1833294bdfb07be67cda85ec4b983cad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111672,
                    "display_name": "Th\u1ea3m l\u00e0m m\u00e1t",
                    "image": "cb34a9d4cb74f1569ee021fda6ebbbab",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111673,
                    "display_name": "T\u1ea5m ph\u1ee7 n\u1ec7m",
                    "image": "bfdc684ff16c43a9f8a6222dd019da7a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111674,
                    "display_name": "Ch\u0103n & m\u1ec1n",
                    "image": "e2444627ecea1a53b0ef674e100eb8bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111675,
                    "display_name": "G\u1ed1i v\u00e0 g\u1ed1i \u00f4m",
                    "image": "480a307085b1adaabfe8fe90aad01e8f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111676,
                    "display_name": "B\u1ed9 tr\u1ea3i gi\u01b0\u1eddng, v\u1ecf g\u1ed1i & h\u1ed9p \u0111\u1ef1ng",
                    "image": "ac1c748dd70109ed4fbd9ef18368fbba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111743,
                    "display_name": "N\u1ec7m.",
                    "image": "ebe54a5397bfdf2a88ac32ec9ebc749f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036695,
                "display_name": "\u0110\u1ed3 n\u1ed9i th\u1ea5t",
                "name": "Furniture",
                "image": "63e036fd4763206d47274a8fe047d2cb",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1151,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036696,
                    "display_name": "Kh\u00e1c",
                    "image": "25de1108034786bad9db2e27417b924f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111682,
                    "display_name": "N\u1ed9i th\u1ea5t ph\u00f2ng \u0103n",
                    "image": "d204e320562ed6537687e9af22a97d73",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111683,
                    "display_name": "N\u1ed9i th\u1ea5t h\u00e0nh lang",
                    "image": "41deb268cfbda915ad2c7821dc6a3092",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111684,
                    "display_name": "N\u1ed9i th\u1ea5t v\u0103n ph\u00f2ng",
                    "image": "175cf493dab2fecc8d38fa6fe5164d24",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111685,
                    "display_name": "N\u1ed9i th\u1ea5t nh\u00e0 b\u1ebfp",
                    "image": "ec631421254bcb740d0c4fcfc790aa39",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111686,
                    "display_name": "K\u1ec7 v\u00e0 gi\u00e1 \u0111\u1ee1",
                    "image": "bde3bcdecd546f93753f48fee6e92d8c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111687,
                    "display_name": "Ph\u1ee5 ki\u1ec7n n\u1ed9i th\u1ea5t",
                    "image": "5a4a3df1b0651ee23206e786ce2b0327",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111688,
                    "display_name": "N\u1ed9i th\u1ea5t ngo\u00e0i tr\u1eddi",
                    "image": "270e6a630418a6cfa3e0b19135a425c0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111746,
                    "display_name": "N\u1ed9i th\u1ea5t ph\u00f2ng ng\u1ee7.",
                    "image": "3ad8b6bbb2f5795a922cdbf64e77f0fc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111747,
                    "display_name": "N\u1ed9i th\u1ea5t ph\u00f2ng kh\u00e1ch.",
                    "image": "0fb53228efc1045a37b66f42a023531e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036717,
                "display_name": "Trang tr\u00ed nh\u00e0 c\u1eeda",
                "name": "Home Decoration",
                "image": "837bdc29ef68c792e1ce93611c12d18b",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1128,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11040422,
                    "display_name": "Kh\u00e1c",
                    "image": "74f4e202fe8f073dd62170e5c8322d49",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111677,
                    "display_name": "Hoa v\u00e0 l\u1ecd",
                    "image": "ff01aa67ab16fca8f48c3492bdb2f3ca",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111678,
                    "display_name": "T\u1ea5m ph\u1ee7",
                    "image": "44af2094603d1c645b289f354a716a4b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111679,
                    "display_name": "R\u00e8m & M\u00e0n s\u00e1o",
                    "image": "7246cd73a9b2d597a044ddf6e13fd636",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111680,
                    "display_name": "Trang tr\u00ed t\u01b0\u1eddng",
                    "image": "7c4c33357617a96b30e4ff88daa5c346",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111681,
                    "display_name": "Th\u1ea3m",
                    "image": "24128c5344d6e9d441fa660b806df65d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111744,
                    "display_name": "Gi\u1ea5y v\u00e0 decal d\u00e1n t\u01b0\u1eddng.",
                    "image": "05c5639fc3ee6dc6b7bd10986866c7e7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111745,
                    "display_name": "N\u1ebfn v\u00e0 ph\u1ee5 ki\u1ec7n.",
                    "image": "26802a04e1763e90404633d71bc50371",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036732,
                "display_name": "D\u1ee5ng c\u1ee5 & Thi\u1ebft b\u1ecb ti\u1ec7n \u00edch",
                "name": "Tools and Home improvement",
                "image": "bd689a49f06464140bc502fdc4eab1d8",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1112,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036760,
                "display_name": "\u0110\u00e8n",
                "name": "Lighting",
                "image": "d9f6d27597fff65b1feb69d77d041f97",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1087,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036761,
                    "display_name": "Kh\u00e1c",
                    "image": "8fd3343cb64d901fa114a53c0e23828f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111836,
                    "display_name": "\u0110\u00e8n n\u0103ng l\u01b0\u1ee3ng m\u1eb7t tr\u1eddi",
                    "image": "be4c9ef5c737dc991f9b87d779e75769",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111837,
                    "display_name": "\u0110\u00e8n b\u00e0n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111838,
                    "display_name": "\u0110\u00e8n r\u1ecdi",
                    "image": "8b659a1abdeaf37226323966c63b2968",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111839,
                    "display_name": "\u0110\u00e8n t\u01b0\u1eddng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111840,
                    "display_name": "\u0110\u00e8n d\u00e2y t\u00f3c",
                    "image": "3a594133cb51624186610234c20d421f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111841,
                    "display_name": "\u0110\u00e8n d\u00e0i",
                    "image": "f10d221ae8d025bd09029add2e0335a5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111842,
                    "display_name": "\u0110\u00e8n ch\u00f9m",
                    "image": "539db3f78cdea9c3f71753dbf21892b3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111843,
                    "display_name": "\u0110\u00e8n c\u1ea3m bi\u1ebfn",
                    "image": "a34f031dd83746219054180025c76791",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111844,
                    "display_name": "\u0110\u00e8n ng\u1ee7",
                    "image": "eb481213b786e864a00b54f9b696249f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111846,
                    "display_name": "\u0110\u00e8n treo",
                    "image": "b6bab52cf1b5dd9fde2aff02ecc99822",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111847,
                    "display_name": "\u0110\u00e8n s\u00e0n",
                    "image": "b6a1675c799b204dea6190c162159918",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111848,
                    "display_name": "Qu\u1ea1t tr\u1ea7n c\u00f3 \u0111\u00e8n",
                    "image": "2f069a1efef888459bec59a2d404591b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111849,
                    "display_name": "\u0110\u00e8n tr\u1ea7n, \u0111\u00e8n \u00e2m tr\u1ea7n & \u0111\u00e8n panel",
                    "image": "11776fff63f8f996439ac2d59fe3b012",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036776,
                "display_name": "Ngo\u00e0i tr\u1eddi & S\u00e2n v\u01b0\u1eddn",
                "name": "Outdoor & Garden",
                "image": "087fa5b9db94d57977725474e12be7e2",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1071,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036777,
                    "display_name": "Kh\u00e1c",
                    "image": "06cd8348f1a38ef0e9a2b808b0dc6e57",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036780,
                    "display_name": "C\u00e2y c\u1ea3nh",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036778,
                    "display_name": "D\u1ee5ng c\u1ee5 l\u00e0m v\u01b0\u1eddn",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111689,
                    "display_name": "Trang tr\u00ed v\u01b0\u1eddn",
                    "image": "f9b95f2769ba858280522cd82916e2df",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111690,
                    "display_name": "\u0110\u1ea5t tr\u1ed3ng",
                    "image": "540d6568c52665a9db37b2ed4ffa96f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111691,
                    "display_name": "Ph\u00e2n b\u00f3n",
                    "image": "eb504433c87f58e2f5a06cb64360cc08",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111692,
                    "display_name": "H\u1ea1t & c\u1ee7 gi\u1ed1ng",
                    "image": "a25136de28a37e00596f979a1cf5c627",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111693,
                    "display_name": "Ch\u1eadu & d\u1ee5ng c\u1ee5 tr\u1ed3ng c\u00e2y",
                    "image": "165785d45d2bae6e9f5084de100ae485",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111694,
                    "display_name": "Thi\u1ebft b\u1ecb l\u00e0m v\u01b0\u1eddn l\u1edbn",
                    "image": "b9cf510c32891970edd98f11152eaf37",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036671,
                "display_name": "\u0110\u1ed3 d\u00f9ng ph\u00f2ng t\u1eafm",
                "name": "Bathroom",
                "image": "9ebf742ff6713326045a2bd9e6ef0dfc",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 1054,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036672,
                    "display_name": "Kh\u00e1c",
                    "image": "b54cb66b3190110ecdf50825fc072426",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111736,
                    "display_name": "Ch\u1eadu v\u1ec7 sinh, gh\u1ebf ng\u1ed3i & n\u1eafp \u0111\u1eady",
                    "image": "90503db97f66147987d76a4e44602f86",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111737,
                    "display_name": "D\u1ee5ng c\u1ee5 \u0111\u00e1nh r\u0103ng",
                    "image": "18c7f476e7b4020d7a91262f9d311ac8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111738,
                    "display_name": "D\u1ee5ng c\u1ee5 \u0111\u1ef1ng x\u00e0 ph\u00f2ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111739,
                    "display_name": "K\u1ec7, Gi\u00e1 & T\u1ee7 trong Ph\u00f2ng t\u1eafm",
                    "image": "5163c93131026adfc7f4d2ce1354b4a0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111740,
                    "display_name": "Thi\u1ebft b\u1ecb nh\u00e0 t\u1eafm v\u00e0 v\u00f2i hoa sen",
                    "image": "520e233fdfa6acf9ce84bd176c573e3f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111741,
                    "display_name": "Kh\u0103n t\u1eafm v\u00e0 \u00e1o cho\u00e0ng t\u1eafm",
                    "image": "d1b55c423726ee2dcfcd193395d64c9f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111742,
                    "display_name": "Ph\u1ee5 ki\u1ec7n nh\u00e0 t\u1eafm",
                    "image": "85357ecd761e17cb9a227e4d92027ac0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036792,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036748,
                "display_name": "\u0110\u1ed3 d\u00f9ng nh\u00e0 b\u1ebfp v\u00e0 h\u1ed9p \u0111\u1ef1ng th\u1ef1c ph\u1ea9m",
                "name": "Kitchenware and food storage",
                "image": "",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036749,
                    "display_name": "Kh\u00e1c",
                    "image": "68f242c8fc0af592b27e361ae52a295c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036756,
                    "display_name": "H\u1ed9p, t\u00fai \u0111\u1ef1ng th\u1ef1c ph\u1ea9m",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111707,
                    "display_name": "Ch\u1ea3o, N\u1ed3i & V\u1ec9 N\u01b0\u1edbng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111708,
                    "display_name": "Ph\u1ee5 ki\u1ec7n v\u00e0 \u0111\u1ed3 d\u00f9ng nh\u00e0 b\u1ebfp",
                    "image": "73746b9bf18cb736ebfbda4803072310",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111709,
                    "display_name": "D\u1ee5ng c\u1ee5 ch\u1ee9a, \u0111\u1ef1ng",
                    "image": "259b4da1d3925eeecead3c1a3e17729b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111748,
                    "display_name": "D\u1ee5ng c\u1ee5 l\u00e0m b\u00e1nh.",
                    "image": "89be659cf0e1626d828e9fbad945065e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111664,
                "display_name": "Tinh d\u1ea7u th\u01a1m ph\u00f2ng",
                "name": "Home Fragrance & Aromatherapy",
                "image": "55c0ca28f933ac7b09cf0964d77aef28",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111671,
                    "display_name": "Tinh d\u1ea7u",
                    "image": "967e6d8e53d871a46176fc5a0610cc6b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111665,
                "display_name": "Ch\u0103m s\u00f3c nh\u00e0 c\u1eeda v\u00e0 gi\u1eb7t \u1ee7i",
                "name": "Housekeeping and Laundry",
                "image": "15d2f119c1232183e85b21dca668a7f6",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111701,
                    "display_name": "D\u00e2y ph\u01a1i & Gi\u00e1 ph\u01a1i",
                    "image": "44fd60bd2bdcb895007a7d27f1abdc7c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111702,
                    "display_name": "Ch\u1ed5i",
                    "image": "f93374b91371be31343310f7c4a60c09",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111703,
                    "display_name": "D\u1ee5ng c\u1ee5 lau ch\u00f9i",
                    "image": "69b68cfa0359bcdf3f5a38aa9f51eaf8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111704,
                    "display_name": "\u0110\u1ed3 lau nh\u00e0",
                    "image": "94b71b14d9a542ffe459147ef92354d7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111705,
                    "display_name": "Th\u00f9ng r\u00e1c",
                    "image": "a8025a4d2d517879c62cea99cfdcfb7c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111706,
                    "display_name": "M\u00f3c qu\u1ea7n \u00e1o",
                    "image": "13e474843080c6f6ad19bfdde4f8a431",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111834,
                    "display_name": "Kh\u0103n v\u1ec7 sinh",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111835,
                    "display_name": "T\u00fai gi\u1eb7t, gi\u1ecf \u0111\u1ef1ng qu\u1ea7n \u00e1o",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116430,
                    "display_name": "B\u00e0n ch\u1ea3i v\u1ec7 sinh",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111666,
                "display_name": "D\u1ee5ng c\u1ee5 pha ch\u1ebf",
                "name": "Drinkware",
                "image": "539e3d0cc0a4b801d7d377cbf403eb9a",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111710,
                    "display_name": "Thi\u1ebft b\u1ecb pha tr\u00e0, c\u00e0 ph\u00ea & pha ch\u1ebf",
                    "image": "2ff9a62585bb916833a009c9bfb6680b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111711,
                    "display_name": "B\u00ecnh dung t\u00edch v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "1e2269fa90846dabaf31e35f8ba1ba12",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111712,
                    "display_name": "B\u1ed9 \u1ea5m & tr\u00e0",
                    "image": "0278018a109c87ff781d06fc0eb4ee6e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111713,
                    "display_name": "Ch\u00e9n, c\u1ed1c & k\u00ednh",
                    "image": "11a45feca5ec66456cda733850370d08",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111714,
                    "display_name": "B\u00ecnh n\u01b0\u1edbc v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "a74dec0159085ddc7b0ba7c47b84e47f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111667,
                "display_name": "\u0110\u1ed3 d\u00f9ng ph\u00f2ng \u0103n",
                "name": "Dinnerware",
                "image": "879b1c91f130b6af972e4d01904e1e97",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111715,
                    "display_name": "B\u00e1t",
                    "image": "f18ec1d14e58edbe4db94c0f1648d564",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111716,
                    "display_name": "D\u0129a",
                    "image": "42982fbb25809ff1f34a65db4cd9c93b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111717,
                    "display_name": "Dao, mu\u1ed7ng, n\u0129a",
                    "image": "93b8fd59ccabb74c3a2a0d7af00be215",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111718,
                    "display_name": "\u1ed0ng h\u00fat",
                    "image": "1891f6210999cde406d0886c2c48ae10",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111719,
                    "display_name": "L\u1ed3ng b\u00e0n",
                    "image": "7eb09e8ec867d2b8c93d357bae908607",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111720,
                    "display_name": "Mi\u1ebfng l\u00f3t & \u0111\u1ebf l\u00f3t",
                    "image": "48d1c3abd816870f5558c09211241a99",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111721,
                    "display_name": "Kh\u00e1c",
                    "image": "7dbcf6f83780cc49308ca39373aea28c",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111668,
                "display_name": "S\u1eafp x\u1ebfp nh\u00e0 c\u1eeda",
                "name": "Houseorganizers",
                "image": "d8aca9bed91b3c9d339b4aa0d562dc2f",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111722,
                    "display_name": "H\u1ed9p l\u01b0u tr\u1eef",
                    "image": "70ab9135031c3cab9e2690becd330014",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111723,
                    "display_name": "M\u00f3c treo & Ch\u1ed1t v\u00e0 m\u00f3c",
                    "image": "abc3ee18d96d9f7283b2f2e5e0e30b6d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111724,
                    "display_name": "D\u1ee5ng c\u1ee5 s\u1eafp x\u1ebfp",
                    "image": "4d1a5c6d62db2e48b7590635c0cb88d1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111725,
                    "display_name": "Kh\u00e1c",
                    "image": "d09a8bd20cdc9f95bbe24ac5f59ad9f1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111669,
                "display_name": "\u0110\u1ed3 trang tr\u00ed ti\u1ec7c",
                "name": "Party supplies",
                "image": "216f65e2d8a1aaa0a8943913c22913e6",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111726,
                    "display_name": "B\u1ed9 \u0111\u1ed3 \u0103n d\u00f9ng m\u1ed9t l\u1ea7n",
                    "image": "bd83c55ab6eaec48de76e8c579ea73e9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111727,
                    "display_name": "M\u0169 v\u00e0 M\u1eb7t n\u1ea1 d\u1ef1 ti\u1ec7c",
                    "image": "81543671239160a5236adacf856399cc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111728,
                    "display_name": "Sashes",
                    "image": "732d90cad7b3908ba0d0b39ceb699552",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111729,
                    "display_name": "Kh\u00e1c",
                    "image": "a337329331b8a542bf6d236e7db026b1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111730,
                    "display_name": "B\u00f3ng bay",
                    "image": "0c6fb2c009a3189d7f06dd9210d7b47c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111731,
                    "display_name": "K\u1eb9p g\u1ed7",
                    "image": "b3934651548895183e4711aabd47df26",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111732,
                    "display_name": "Ph\u00f4ng n\u1ec1n & Bi\u1ec3u ng\u1eef",
                    "image": "8623eecdf51b6dbb45ff3428420e7f3d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111733,
                    "display_name": "Th\u1ebb",
                    "image": "4c7a90d36be29294566e8caac0788172",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111670,
                "display_name": "V\u1eadt ph\u1ea9m th\u1edd c\u00fang",
                "name": "Regilious and Worship items",
                "image": "eef4530088daacf1addde17d69a042fe",
                "is_adult": null,
                "parent_category": 11036670,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111734,
                    "display_name": "Phong th\u1ee7y & \u0110\u1ed3 d\u00f9ng t\u00f4n gi\u00e1o",
                    "image": "890fddb0a5c795f2c9fee4dda29ac452",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11035954,
                "display_name": "M\u00e1y T\u00ednh & Laptop",
                "name": "Computer & Accessories",
                "image": "c3f3edfaa9f6dafc4825b77d8449999d",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 1043,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035955,
                "display_name": "M\u00e1y T\u00ednh B\u00e0n",
                "name": "Desktop Computers",
                "image": "9ee23685d68971a04d18e3d82478ffd1",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1042,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035956,
                    "display_name": "B\u1ed9 M\u00e1y T\u00ednh B\u00e0n",
                    "image": "198edf7303ccb9fa20aab2ffed0e063f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035957,
                    "display_name": "M\u00e1y T\u00ednh Mini",
                    "image": "5f7c5187229585c187b6423da2a3b051",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035958,
                    "display_name": "M\u00e1y Ch\u1ee7",
                    "image": "39eef79b7674f2cf5aa990bdaacc3056",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035959,
                    "display_name": "M\u00e1y T\u00ednh All in one",
                    "image": "8bd1d0735956b36db38b2153e5c02071",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035960,
                    "display_name": "Kh\u00e1c",
                    "image": "9af9854589364c181e62e7bc0a1cdd5f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035961,
                "display_name": "M\u00e0n H\u00ecnh",
                "name": "Monitors",
                "image": "07eb6d1ec47997e879599f44faff9a32",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1036,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035962,
                "display_name": "Linh Ki\u1ec7n M\u00e1y T\u00ednh",
                "name": "Desktop & Laptop Components",
                "image": "dda433781a2e4391d2bdde8165cdfddd",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1035,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035963,
                    "display_name": "Qu\u1ea1t v\u00e0 T\u1ea3n Nhi\u1ec7t",
                    "image": "663f312c4db33d45c181a89c94e64c2f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035964,
                    "display_name": "CPU - B\u1ed9 Vi X\u1eed L\u00fd",
                    "image": "346da7068c58c5d8096a5350cff1ba1b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035965,
                    "display_name": "Mainboard - Bo M\u1ea1ch Ch\u1ee7",
                    "image": "41b042e181924470e1377f89031c9775",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035966,
                    "display_name": "VGA - Card M\u00e0n H\u00ecnh",
                    "image": "3ef7f28690bddc83e29ed7c9225d9592",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035967,
                    "display_name": "Keo T\u1ea3n Nhi\u1ec7t",
                    "image": "b5eb15a0a52b3be1637f50661709fc81",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035968,
                    "display_name": "Ngu\u1ed3n M\u00e1y T\u00ednh",
                    "image": "6cd2e971eca21ab23dc006b3aae53ad7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035969,
                    "display_name": "Ram M\u00e1y T\u00ednh",
                    "image": "61e45f1e2745fb949e5e075e166835ab",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035970,
                    "display_name": "B\u1ed9 L\u01b0u \u0110i\u1ec7n",
                    "image": "9bce09751e9d938b0f5b249fe42507e2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035971,
                    "display_name": "Case M\u00e1y T\u00ednh",
                    "image": "7180769427f25677d7585520f3b45416",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035972,
                    "display_name": "\u1ed4 \u0110\u0129a Quang",
                    "image": "e9d705b4162eac77cfe01ceae4365c06",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035973,
                    "display_name": "Bo M\u1ea1ch \u00c2m Thanh",
                    "image": "6524f9d8cfcc186fe840283e63008ef7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035974,
                    "display_name": "Kh\u00e1c",
                    "image": "b4ea4b38f9995daf04e4081f9d16c079",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035975,
                "display_name": "Thi\u1ebft B\u1ecb L\u01b0u Tr\u1eef",
                "name": "Data Storage",
                "image": "9152708928617686adbc9a257053411e",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1022,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035976,
                    "display_name": "\u1ed4 C\u1ee9ng Di \u0110\u1ed9ng",
                    "image": "92bc2f1a43fb4e813111f38566d1b8e0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035977,
                    "display_name": "\u1ed4 C\u1ee9ng SSD",
                    "image": "b7f267989be227acf46f8abb36cbaa56",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035978,
                    "display_name": "\u1ed4 C\u1ee9ng M\u1ea1ng (NAS)",
                    "image": "6202b9fa129b3ef7a962f2afdb47a19d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035979,
                    "display_name": "USB & OTG",
                    "image": "321328a24d86344d4689c08f4958a210",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035980,
                    "display_name": "Thi\u1ebft B\u1ecb \u0110\u1ef1ng \u1ed4 C\u1ee9ng",
                    "image": "796026e03d597b732b8fbad388c8f197",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035981,
                    "display_name": "\u0110\u0129a CD",
                    "image": "1124a72991a2312c2d9188a6e1001fc9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035982,
                    "display_name": "Kh\u00e1c",
                    "image": "ac3d0f59023f596366036c66ab54e8d9",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035983,
                "display_name": "Thi\u1ebft B\u1ecb M\u1ea1ng",
                "name": "Network Components",
                "image": "d7eb886f608996afb8fb77f41f2c14f6",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1014,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035984,
                    "display_name": "B\u1ed9 Ph\u00e1t Wifi",
                    "image": "7124e3fef8843d9cc07356f4b48eefe6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035985,
                    "display_name": "B\u1ed9 K\u00edch Wifi",
                    "image": "1b0ae55817dfffd7907946f51da73607",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035986,
                    "display_name": "B\u1ed9 Thu Wifi",
                    "image": "e6be6f9f2088908db77dde92f6947478",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035987,
                    "display_name": "B\u1ed9 Chuy\u1ec3n \u0110\u1ed5i M\u1ea1ng",
                    "image": "fe14a2d5012d4bd8f4fe7f3458b4b090",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035988,
                    "display_name": "B\u1ed9\u00a0chia\u00a0m\u1ea1ng",
                    "image": "03b5bd8d383d3068f0b5d9a6b2e244bb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035989,
                    "display_name": "C\u00e1p M\u00e1y T\u00ednh",
                    "image": "19747241b55d4f42f9b14eeb0487e042",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035990,
                    "display_name": "B\u1ed9 Chuy\u1ec3n M\u1ea1ch KVM",
                    "image": "5cc1be5a4c620e7910dce19064418f08",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035991,
                    "display_name": "M\u00e1y Ch\u1ee7 M\u00e1y In",
                    "image": "8f9c16b9772739200c4727b099bef672",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035992,
                    "display_name": "Kh\u00e1c",
                    "image": "271ae6e38f3f732684b515ebf22612f5",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035993,
                "display_name": "M\u00e1y In, M\u00e1y Scan & M\u00e1y Chi\u1ebfu",
                "name": "Printers, Scanners & Projectors",
                "image": "798c812646b1d72d16a988b7f854ca9d",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 1004,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035994,
                    "display_name": "M\u00e1y In, M\u00e1y Scan & M\u00e1y Photo",
                    "image": "801140cf3c068bb8acfa23d1f292a228",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035995,
                    "display_name": "M\u00e1y In M\u00e3 V\u1ea1ch",
                    "image": "d9ff37b29cff9ef414c3700f8baac2b7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035996,
                    "display_name": "M\u1ef1c In & Khay M\u1ef1c",
                    "image": "9967b01c84c97e63733a9cd63799a54e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035997,
                    "display_name": "M\u00e1y In 3D",
                    "image": "8a06bb9a570d6486e3de8686d42497bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035998,
                    "display_name": "M\u00e1y Chi\u1ebfu",
                    "image": "2197f8d5e92b3b39e169574c9d28cfc8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035999,
                    "display_name": "Kh\u00e1c",
                    "image": "1f4d31d0fe6d243cd7652806eea2ddfd",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036000,
                "display_name": "Ph\u1ee5 Ki\u1ec7n M\u00e1y T\u00ednh",
                "name": "Peripherals & Accessories",
                "image": "31f547fdaf50b92c4cfe77d3b0b0a440",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 997,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036001,
                    "display_name": "B\u1ed9 chia c\u1ed5ng USB & \u0110\u1ecdc th\u1ebb nh\u1edb",
                    "image": "c19790161ba8924be4578b0ebbf313d8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036002,
                    "display_name": "Webcam",
                    "image": "f316cdb5496dc75738fa5da02d142cf2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036003,
                    "display_name": "Mi\u1ebfng D\u00e1n & \u1ed0p Laptop",
                    "image": "a5fd5e5c6a92775211673b4e17d6b7e7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036004,
                    "display_name": "\u0110\u1ebf T\u1ea3n Nhi\u1ec7t",
                    "image": "6da71847ed6256b3426446575eb6f6c5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036005,
                    "display_name": "B\u00e0n Laptop",
                    "image": "91c09b2daa82c719c2bebc51af72ddd1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036006,
                    "display_name": "Mi\u1ebfng D\u00e1n B\u00e0n Ph\u00edm",
                    "image": "7e3609eaa917be09a62db3fc6af989c5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036007,
                    "display_name": "Pin Laptop",
                    "image": "9ee08cfc091cfcb582aafc1a7fdc21d0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036008,
                    "display_name": "B\u1ed9 S\u1ea1c Laptop",
                    "image": "a647a3fa6eb77c17f75df172533977bd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036009,
                    "display_name": "Thi\u1ebft B\u1ecb Truy\u1ec1n H\u00ecnh H\u1ed9i Ngh\u1ecb",
                    "image": "97a197fd5f7e792dc2d368361e3c649f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036010,
                    "display_name": "B\u00e0n Di Chu\u1ed9t",
                    "image": "e4710ee2e1ec69332d2f3a25007b5f16",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036011,
                    "display_name": "Kh\u00e1c",
                    "image": "7e32bf621a8c90ca6f306f0cf2314bd0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036012,
                    "display_name": "Chu\u1ed9t M\u00e1y T\u00ednh",
                    "image": "012a38349a941a73f0cdbf5f5bcc4660",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036013,
                    "display_name": "B\u00e0n Ph\u00edm M\u00e1y T\u00ednh",
                    "image": "51ee8f906dd6b6191855ffeb08444349",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036014,
                    "display_name": "B\u1ea3ng V\u1ebd \u0110i\u1ec7n T\u1eed",
                    "image": "6c2f83a185fcef5c3cd7dfa55da99bf7",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036015,
                "display_name": "Laptop",
                "name": "Laptops",
                "image": "90af01c1be8cd3e00c5f05ceb6851127",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 982,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036016,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "b8fc994f4ed24f88e6c9cad70ce48da8",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 981,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036017,
                    "display_name": "Kh\u00e1c",
                    "image": "c85731c7e6a59b721e108676682b8c2e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036018,
                    "display_name": "Ph\u1ea7n M\u1ec1m",
                    "image": "8de5efcf63435dd9a1e95eacbb91d3c3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036019,
                    "display_name": "M\u00e1y \u0110\u00e1nh Ch\u1eef",
                    "image": "62b207037d711aca4e51cfedf23a0360",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036020,
                    "display_name": "M\u00e1y Ch\u1ea5m C\u00f4ng",
                    "image": "80856fc88bf71ed1fa5f1e2bc2e867a1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036021,
                    "display_name": "M\u00e1y H\u1ee7y T\u00e0i Li\u1ec7u",
                    "image": "6e8cd4cc287c9dcb26ecbda0317bac66",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036022,
                    "display_name": "M\u00e1y \u0110\u1ebfm Ti\u1ec1n",
                    "image": "eeeee3fab3e243915a4211e946349961",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036023,
                "display_name": "Gaming",
                "name": "Gaming",
                "image": "3bd8e8566c0e2f9eda4e2acd18f9f144",
                "is_adult": null,
                "parent_category": 11035954,
                "sort_weight": 974,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036024,
                    "display_name": "Chu\u1ed9t M\u00e1y T\u00ednh",
                    "image": "b82f21b2ba54e2834248732c135c858e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036025,
                    "display_name": "B\u00e0n Ph\u00edm M\u00e1y T\u00ednh",
                    "image": "0d042ce0e3cbfa642b6b10818f9a68d3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036026,
                    "display_name": "B\u00e0n Di Chu\u1ed9t",
                    "image": "c022641f0a842f20040311eb2fa12675",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036027,
                    "display_name": "B\u1ed9 M\u00e1y T\u00ednh B\u00e0n",
                    "image": "3df0fdb248cfacf3c7473ceb65eaf826",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036028,
                    "display_name": "M\u00e0n H\u00ecnh",
                    "image": "bd8244b305d626a897ca87a911008fb9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036029,
                    "display_name": "Laptop",
                    "image": "0ddae3be074488463fd5b747678e2d89",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116435,
                    "display_name": "Loa",
                    "image": "",
                    "block_buyer_platform": null
                }, {"catid": 11116436, "display_name": "Tai Nghe", "image": "", "block_buyer_platform": null}]
            }]
        }, {
            "main": {
                "catid": 11036279,
                "display_name": "S\u1eafc \u0110\u1eb9p",
                "name": "Beauty & Personal Care",
                "image": "ef1f336ecc6f97b790d5aae9916dcb72",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 967,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036280,
                "display_name": "T\u1eafm & ch\u0103m s\u00f3c c\u01a1 th\u1ec3",
                "name": "Bath & Body Care",
                "image": "4f6604b9c4d752adc7761aed5a656080",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 966,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036281,
                    "display_name": "X\u00e0 ph\u00f2ng & s\u1eefa t\u1eafm",
                    "image": "f5bf3d4c2eb71ba7dcf75f619a5e5dc8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036282,
                    "display_name": "T\u1ea9y t\u1ebf b\u00e0o ch\u1ebft c\u01a1 th\u1ec3",
                    "image": "32284e6786c93ea834caeb014043bbd3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036283,
                    "display_name": "M\u1eb7t n\u1ea1 \u1ee7 c\u01a1 th\u1ec3",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036284,
                    "display_name": "D\u1ea7u d\u01b0\u1ee1ng da",
                    "image": "639dbd84807c2b683bf0135b33f0492c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036285,
                    "display_name": "Kem & s\u1eefa d\u01b0\u1ee1ng th\u1ec3",
                    "image": "aa8418f18f7e7f7aa477ebe09811db4b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036286,
                    "display_name": "Kh\u1eed m\u00f9i c\u01a1 th\u1ec3",
                    "image": "74ac2bd50574961d2521caa52393f302",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036287,
                    "display_name": "D\u1ea7u massage",
                    "image": "0aa293d4d11602dbae2bfed47d96ad89",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036288,
                    "display_name": "Kem t\u1ea9y l\u00f4ng & wax l\u00f4ng",
                    "image": "c9614be6d2c69daf699b2fc72da1201c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036289,
                    "display_name": "Ch\u1ed1ng n\u1eafng",
                    "image": "242353417dc6c4f27ec636691ccc5f85",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036290,
                    "display_name": "Ch\u0103m s\u00f3c ng\u1ef1c",
                    "image": "73064944ea684aa7667ee03d2c254363",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036291,
                    "display_name": "Kh\u00e1c",
                    "image": "b9a049f9458221bf4800ce692f66f922",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036293,
                    "display_name": "Ch\u0103m s\u00f3c tay",
                    "image": "ad2506ffa9ef83206ce00f2bf2ca3163",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036294,
                    "display_name": "Ch\u0103m s\u00f3c ch\u00e2n",
                    "image": "7619f16eaca68b3a1344379f667531f5",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036297,
                "display_name": "Ch\u0103m s\u00f3c t\u00f3c",
                "name": "Hair Care",
                "image": "8df57bc6ec6ee6dc67f8a482ede8ae57",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 949,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036298,
                    "display_name": "D\u1ea7u g\u1ed9i",
                    "image": "d9d0b7f570cc2bb3a3eec5ad25d62b18",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036299,
                    "display_name": "Thu\u1ed1c nhu\u1ed9m t\u00f3c",
                    "image": "7a1daeb5fc12c5c2cc5eab389a58d94b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036300,
                    "display_name": "D\u01b0\u1ee1ng t\u00f3c",
                    "image": "ab7cf3794901c4ad00dc725a49cde7f2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036301,
                    "display_name": "D\u1ea7u x\u1ea3",
                    "image": "b97d1c866b6bce0945cd0e4aea8ffed8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036302,
                    "display_name": "S\u1ea3n ph\u1ea9m t\u1ea1o ki\u1ec3u t\u00f3c",
                    "image": "87f6ba4e1127903473928d1f91c83d35",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036303,
                    "display_name": "Kh\u00e1c",
                    "image": "1b64ab72c532d9a9f3278cbf9b0d36ed",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036304,
                "display_name": "Ch\u0103m s\u00f3c nam gi\u1edbi",
                "name": "Men's Care",
                "image": "2df595fa1c9121b19b653258f6823ddc",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 942,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036305,
                    "display_name": "S\u1eefa t\u1eafm & ch\u0103m s\u00f3c c\u01a1 th\u1ec3",
                    "image": "bfb6fe1feb5025e2dea438022fc205b3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036306,
                    "display_name": "Ch\u0103m s\u00f3c da",
                    "image": "bea3c7eea9b99e371152cc399c776a5c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036307,
                    "display_name": "S\u1ea3n ph\u1ea9m c\u1ea1o r\u00e2u & h\u1edbt t\u00f3c",
                    "image": "47b32ad0db81acbb42e43f70eafa1476",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036308,
                    "display_name": "Ch\u0103m s\u00f3c t\u00f3c",
                    "image": "c224d2fc76f9b06e4bca302cbe83c533",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036309,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036310,
                "display_name": "N\u01b0\u1edbc hoa",
                "name": "Perfumes & Fragrances",
                "image": "1e86393fb01f47ec44036d941a962ad4",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 936,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036311,
                    "display_name": "Nam",
                    "image": "1663d809e4f9c923689aff541a6e1cf5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036312,
                    "display_name": "N\u1eef",
                    "image": "323917c30079ccdfdf857d6271c9d606",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036313,
                    "display_name": "Unisex",
                    "image": "1938a535e7fb50d88c24471caa0ede3f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036314,
                "display_name": "Trang \u0111i\u1ec3m",
                "name": "Makeup",
                "image": "94243cb53223e425c8241f0d833e87fd",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 932,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036315,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036316,
                    "display_name": "Trang \u0111i\u1ec3m m\u1eb7t",
                    "image": "9baaeebc4489332ca652ac4c85470d0b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036317,
                    "display_name": "Trang \u0111i\u1ec3m m\u1eaft",
                    "image": "3261eeff802bb6c3f99b27cd406a3937",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036318,
                    "display_name": "Trang \u0111i\u1ec3m m\u00f4i",
                    "image": "bd357c750c7fd400dee7dcecc5c39244",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036319,
                    "display_name": "D\u01b0\u1ee1ng m\u00f4i",
                    "image": "20a96672de814ac20d2d9012237c4100",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036320,
                    "display_name": "T\u1ea9y trang",
                    "image": "e7ded984bf7e767695ce03e3506b79f1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036321,
                "display_name": "D\u1ee5ng c\u1ee5 & Ph\u1ee5 ki\u1ec7n L\u00e0m \u0111\u1eb9p",
                "name": "Beauty Tools & Accessories",
                "image": "36c5cb7b9e25df4b8fde453691d7d357",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 925,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036295,
                    "display_name": "Ch\u0103m s\u00f3c m\u00f3ng",
                    "image": "407df3518007f6afb70e9b2802d38370",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036322,
                    "display_name": "D\u1ee5ng c\u1ee5 trang \u0111i\u1ec3m",
                    "image": "6b0fa4170580c014a71589435a537e9b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036323,
                    "display_name": "D\u1ee5ng c\u1ee5 ch\u0103m s\u00f3c da m\u1eb7t",
                    "image": "04671e5070b106409b5326926c1398a6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036324,
                    "display_name": "D\u1ee5ng c\u1ee5 l\u00e0m thon g\u1ecdn c\u01a1 th\u1ec3",
                    "image": "4d93143c2152ed711f3d9ede9f7a5fb1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036325,
                    "display_name": "D\u1ee5ng c\u1ee5 t\u1ea9y l\u00f4ng",
                    "image": "7a4e8323163ae15ce0438e4ca6e025a0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036326,
                    "display_name": "D\u1ee5ng c\u1ee5 ch\u0103m s\u00f3c t\u00f3c",
                    "image": "59763e1c33856fad0f8fc08bd5e8c2a7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036327,
                    "display_name": "Kh\u00e1c",
                    "image": "ccb9c5ac3c5a9ec7eb3f20978771a80e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036328,
                "display_name": "Ch\u0103m s\u00f3c da m\u1eb7t",
                "name": "Skincare",
                "image": "aa7a885342e375e15ee241065d3fcaf1",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 918,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036329,
                    "display_name": "S\u1eefa r\u1eeda m\u1eb7t",
                    "image": "89eef8ae6dc994699a4544bab506ff1e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036330,
                    "display_name": "N\u01b0\u1edbc c\u00e2n b\u1eb1ng da",
                    "image": "c76699ccad0b126e90f604276b8b76a5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036331,
                    "display_name": "Kem d\u01b0\u1ee1ng \u1ea9m",
                    "image": "597d2fabbb4f98ff2ed83dc531c2cc79",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036332,
                    "display_name": "D\u1ea7u d\u01b0\u1ee1ng \u1ea9m",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036333,
                    "display_name": "X\u1ecbt kho\u00e1ng",
                    "image": "1411d95d829d6381f3eb35868af03bc3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036334,
                    "display_name": "Tinh ch\u1ea5t d\u01b0\u1ee1ng",
                    "image": "728e716b14072e9fa4d3cea841d47162",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036335,
                    "display_name": "T\u1ea9y t\u1ebf b\u00e0o ch\u1ebft",
                    "image": "1c1f2ded8b93fdf56557e288ef53e1c0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036336,
                    "display_name": "M\u1eb7t n\u1ea1",
                    "image": "b1e0080f76f1a5c0e16ccc1cc6d42686",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036337,
                    "display_name": "D\u01b0\u1ee1ng m\u1eaft",
                    "image": "53600f8eced16ccb9202fe833c0b3ed5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036338,
                    "display_name": "Kem ch\u1ed1ng n\u1eafng cho m\u1eb7t",
                    "image": "76f8e7ad1f000ad740ab495e70268ce4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036339,
                    "display_name": "Kem d\u01b0\u1ee1ng sau ch\u1ed1ng n\u1eafng",
                    "image": "b0a83bd64d13df614bf10788167901dc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036340,
                    "display_name": "Gi\u1ea5y th\u1ea5m d\u1ea7u",
                    "image": "07a72b88665447afb950f3f8d69e4a36",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036341,
                    "display_name": "S\u1ea3n ph\u1ea9m tr\u1ecb m\u1ee5n",
                    "image": "de23ec188e6beade04986b9f45888e5c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036342,
                    "display_name": "Kh\u00e1c",
                    "image": "d6565e27d4e0ff7a581a3c422f272862",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036343,
                "display_name": "B\u1ed9 s\u1ea3n ph\u1ea9m l\u00e0m \u0111\u1eb9p",
                "name": "Beauty Sets & Packages",
                "image": "9c013765005212208ccc424c242c6eb8",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 903,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036344,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "c901d864ef65c26758cfe5d2a30bfd66",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 902,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11111646,
                "display_name": "V\u1ec7 sinh r\u0103ng mi\u1ec7ng",
                "name": "Oral Care",
                "image": "2439afb78130c2788d37d26dd42c91fd",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111648,
                    "display_name": "B\u00e0n ch\u1ea3i \u0111\u00e1nh r\u0103ng th\u01b0\u1eddng",
                    "image": "514603a648cf4ac8d94c80d5704c9850",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111649,
                    "display_name": "B\u00e0n ch\u1ea3i \u0111\u00e1nh r\u0103ng \u0111i\u1ec7n & Ph\u1ee5 ki\u1ec7n",
                    "image": "32b163a92fa39f6bcd03061a281cb537",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111650,
                    "display_name": "Kem \u0111\u00e1nh r\u0103ng",
                    "image": "34f3ece13aac953a647ef9358fe64b80",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111651,
                    "display_name": "Ch\u1ec9 nha khoa",
                    "image": "e2f48643d9f39c9cfb8a593484eb2f40",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111652,
                    "display_name": "N\u01b0\u1edbc s\u00fac mi\u1ec7ng",
                    "image": "5fa0f8c731dcb38c088ca8b7d87e9237",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111653,
                    "display_name": "Ch\u0103m s\u00f3c r\u0103ng mi\u1ec7ng",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111654,
                    "display_name": "L\u00e0m tr\u1eafng r\u0103ng",
                    "image": "132eed2361f2f34ee1df180ad4c5e71b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111655,
                    "display_name": "Ph\u1ee5 ki\u1ec7n ch\u1ec9nh nha",
                    "image": "c71854f7b7e0964adc34d8537fa43fb4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111656,
                    "display_name": "Kh\u00e1c",
                    "image": "47997a5622f511bf00e5c65eb011cbb6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111647,
                "display_name": "Ch\u0103m s\u00f3c ph\u1ee5 n\u1eef",
                "name": "Feminine Care",
                "image": "66fef7da4c5b0405b4a641862794554c",
                "is_adult": null,
                "parent_category": 11036279,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111657,
                    "display_name": "B\u0103ng v\u1ec7 sinh",
                    "image": "7836fc9a75cc8b4e978d1196afe47b0c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111658,
                    "display_name": "Tampon",
                    "image": "adbc574e13bcca2ecd80a4a52bd6f7f2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111659,
                    "display_name": "Que th\u1eed thai",
                    "image": "4761ccc66c9d848c9b205282cce5d367",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111660,
                    "display_name": "C\u1ed1c nguy\u1ec7t san",
                    "image": "d3f1cad9440048b0b34617248bdc4ed1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111661,
                    "display_name": "Dung d\u1ecbch v\u1ec7 sinh",
                    "image": "783a6baa98338d8311e93c2471bab1da",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111662,
                    "display_name": "Kem ph\u1ee5 khoa",
                    "image": "a2d8e00a347548f532247cb3656c9fa6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111663,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036101,
                "display_name": "M\u00e1y \u1ea2nh & M\u00e1y Quay Phim",
                "name": "Cameras",
                "image": "ec14dd4fc238e676e43be2a911414d4d",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 901,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036102,
                "display_name": "M\u00e1y \u1ea3nh - M\u00e1y quay phim",
                "name": "Cameras",
                "image": "f3fed6b55c5863b110dcb71c419821c4",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 900,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036103,
                    "display_name": "M\u00e1y \u1ea3nh du l\u1ecbch",
                    "image": "4a406b3df5292e4e2d3017a22fd5cc4c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036104,
                    "display_name": "M\u00e1y \u1ea3nh kh\u00f4ng g\u01b0\u01a1ng l\u1eadt",
                    "image": "0f9ba9973ba5c3fe0e7c1803dd2efdd0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036105,
                    "display_name": "M\u00e1y \u1ea3nh DSLR",
                    "image": "95dd46fad665e36d0e51eda951533ef1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036106,
                    "display_name": "M\u00e1y quay h\u00e0nh \u0111\u1ed9ng",
                    "image": "b76f35e9d8b984c47ef42511c3ac4677",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036107,
                    "display_name": "M\u00e1y quay phim",
                    "image": "5a31dbc5d6e421da39f20dc3e7c57aaf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036108,
                    "display_name": "Kh\u00e1c",
                    "image": "3d81b5425caa6b7103663a4a776f4198",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036109,
                "display_name": "Camera gi\u00e1m s\u00e1t & Camera h\u1ec7 th\u1ed1ng",
                "name": "Security Cameras & Systems",
                "image": "ad1d22459e850c8e9de3c865d5152557",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 893,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036110,
                    "display_name": "Camera gi\u00e1m s\u00e1t",
                    "image": "5b9b7e94fce2154927e45a40b2f0eb98",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036111,
                    "display_name": "\u0110\u1ea7u ghi h\u00ecnh camera",
                    "image": "85e80cfe06fd4ab2d4e24df771e4f45a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036113,
                    "display_name": "Kh\u00e1c",
                    "image": "e1bde85940bfbbee80fd6dfebaa4f523",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036114,
                "display_name": "Th\u1ebb nh\u1edb",
                "name": "Memory Cards",
                "image": "0604caa0e5ecc9afef27ef92a71502ce",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 888,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036115,
                "display_name": "\u1ed0ng k\u00ednh",
                "name": "Lenses",
                "image": "66d1f2aea9679630005dc2b29d126fab",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 887,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036116,
                    "display_name": "\u1ed0ng k\u00ednh",
                    "image": "0e19b8e308520c31aba33e95c552f61f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036117,
                    "display_name": "Ph\u1ee5 ki\u1ec7n \u1ed1ng k\u00ednh",
                    "image": "59ea773f9826a993f5ee7dba2ab2d5fc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036118,
                    "display_name": "Kh\u00e1c",
                    "image": "f71a6d765ca4c5738ddd667590274b8b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036119,
                "display_name": "Ph\u1ee5 ki\u1ec7n m\u00e1y \u1ea3nh",
                "name": "Camera Accessories",
                "image": "d05acdce5034d0893a172aefb526a591",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 883,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036120,
                    "display_name": "Tay c\u1ea7m ch\u1ed1ng rung",
                    "image": "6a980823566e0f9f07215a9b1a3baf1a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036121,
                    "display_name": "\u0110\u00e8n flash v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "09b4fdd668ba6c4e0f182e2ff818b3de",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036122,
                    "display_name": "Thi\u1ebft b\u1ecb ph\u00f2ng ch\u1ee5p",
                    "image": "e81d93ae00ce0c93788b5b0c5d14e5b7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036123,
                    "display_name": "Phim - Gi\u1ea5y in \u1ea3nh",
                    "image": "471e1cd8ef562db348acaeb2304ea381",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036124,
                    "display_name": "Balo, t\u00fai \u0111\u1ef1ng, bao da",
                    "image": "05a058e9edcfc08961e0ac4d72fc84e9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036125,
                    "display_name": "Pin - S\u1ea1c m\u00e1y \u1ea3nh",
                    "image": "95f8dcfc4f6abb944081fe898db32730",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036126,
                    "display_name": "Ch\u00e2n m\u00e1y \u1ea3nh & g\u1eady",
                    "image": "c2e5b8d67656d9e1b9d49ebbe4ae2331",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036127,
                    "display_name": "D\u1ee5ng c\u1ee5 v\u1ec7 sinh m\u00e1y \u1ea3nh",
                    "image": "c66e5ab8df5139151f84bdd136edbfd3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036128,
                    "display_name": "Kh\u00e1c",
                    "image": "e76b3ce1c76e0c309ce8323e37ca83c5",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036129,
                "display_name": "M\u00e1y bay camera & Ph\u1ee5 ki\u1ec7n",
                "name": "Drones",
                "image": "74aa544f0c6e486a350f8c12e1c9b4b5",
                "is_adult": null,
                "parent_category": 11036101,
                "sort_weight": 873,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036130,
                    "display_name": "M\u00e1y bay camera",
                    "image": "d9c86fbfcd0223703f2ff6b0f46087be",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036131,
                    "display_name": "Ph\u1ee5 ki\u1ec7n m\u00e1y bay camera",
                    "image": "cf95a0f27337fb46b4c3ee2a7dfb89cf",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036345,
                "display_name": "S\u1ee9c Kh\u1ecfe",
                "name": "Health",
                "image": "49119e891a44fa135f5f6f5fd4cfc747",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 870,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11036346,
                "display_name": "Th\u1ef1c ph\u1ea9m ch\u1ee9c n\u0103ng",
                "name": "Food Supplement",
                "image": "c5e646fea2919e2aa09215f48babd356",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 869,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036347,
                    "display_name": "H\u1ed7 tr\u1ee3 ki\u1ec3m so\u00e1t c\u00e2n n\u1eb7ng",
                    "image": "42d32e19c734f90f4ff8ca00766cfdc4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036349,
                    "display_name": "H\u1ed7 tr\u1ee3 t\u0103ng c\u01a1",
                    "image": "d3088ef0b9fc5db2418e5af09f0fc708",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036350,
                    "display_name": "H\u1ed7 tr\u1ee3 s\u1ee9c kh\u1ecfe",
                    "image": "50aa69ffe8a21112c496c50c2f13a234",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036351,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036348,
                "display_name": "H\u1ed7 tr\u1ee3 l\u00e0m \u0111\u1eb9p",
                "name": "Beauty Supplements",
                "image": "80b1706e12785e4cba5679c164f45979",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 867,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036352,
                "display_name": "V\u1eadt t\u01b0 y t\u1ebf",
                "name": "Medical Supplies",
                "image": "cc7eef683ea136e699f824045f2e1a8d",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 863,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036353,
                    "display_name": "Thu\u1ed1c kh\u00f4ng k\u00ea \u0111\u01a1n",
                    "image": "15f0efa9fd7885665472a764abd1c8b1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036354,
                    "display_name": "Thu\u1ed1c gia truy\u1ec1n",
                    "image": "cc4bbd6604244f710110d9ff2ed13b75",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036355,
                    "display_name": "Ki\u1ec3m tra v\u00e0 theo d\u00f5i s\u1ee9c kh\u1ecfe",
                    "image": "15d7621f169143009564c15c18f9eee3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036356,
                    "display_name": "C\u00e2n s\u1ee9c kh\u1ecfe v\u00e0 ph\u00e2n t\u00edch c\u01a1 th\u1ec3",
                    "image": "43aaf640b046e12f33800f7f8009381e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036357,
                    "display_name": "Ch\u0103m s\u00f3c m\u0169i",
                    "image": "d32bdfde718be4098df9e7ab45e4a6a4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036358,
                    "display_name": "D\u1ee5ng c\u1ee5 s\u01a1 c\u1ee9u",
                    "image": "0b3e732107b4df275df88f7d2fa70863",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036359,
                    "display_name": "\u1ed0ng nghe y t\u1ebf",
                    "image": "5ab6e1a22ec3ecbeaab445e89ba45ba3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036361,
                    "display_name": "D\u1ee5ng c\u1ee5 th\u00ed nghi\u1ec7m",
                    "image": "b7eed55135813d85d265ef17d6889476",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036362,
                    "display_name": "Bao tay v\u00e0 kh\u1ea9u trang y t\u1ebf",
                    "image": "bf0053b9f449ea8810e8d5f6cd467b74",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036363,
                    "display_name": "H\u1ed7 tr\u1ee3 ch\u1ea5n th\u01b0\u01a1ng v\u00e0 khuy\u1ebft t\u1eadt",
                    "image": "7f8bf88589bd97270f5340f0947c17ee",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036364,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036366,
                    "display_name": "Dung d\u1ecbch s\u00e1t khu\u1ea9n tay",
                    "image": "1ed5cc3aea272555453bf24b1c0908a9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036367,
                    "display_name": "Ch\u0103m s\u00f3c m\u1eaft",
                    "image": "849688f01cb3a56c57256a18c1ebdc10",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036368,
                    "display_name": "Ch\u0103m s\u00f3c tai",
                    "image": "d0f4b648842f7a2438241dfdc58559ab",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036360,
                    "display_name": "S\u1ea3n ph\u1ea9m gi\u1ea3m \u0111au d\u00f9ng ngo\u00e0i da",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036370,
                "display_name": "T\u00e3 ng\u01b0\u1eddi l\u1edbn",
                "name": "Adult Diapers & Incontinence",
                "image": "579bbc6df6b7c3768cff23cac2c0fae5",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 845,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036372,
                "display_name": "D\u1ee5ng c\u1ee5 massage v\u00e0 tr\u1ecb li\u1ec7u",
                "name": "Massage & Therapy Devices",
                "image": "1932f19c5321a4b08066b078d54e8dc2",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 843,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036373,
                "display_name": "Ch\u1ed1ng mu\u1ed7i & xua \u0111u\u1ed5i c\u00f4n tr\u00f9ng",
                "name": "Insect Repellents",
                "image": "6d74d79a897a5651428166121e89b7d3",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 842,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036375,
                "display_name": "H\u1ed7 tr\u1ee3 t\u00ecnh d\u1ee5c",
                "name": "Sexual Wellness",
                "image": "71753022762c763712f158978cf15980",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 840,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036376,
                    "display_name": "Bao cao su",
                    "image": "3d89d264f847b9c16b5fe8692b8fa896",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036377,
                    "display_name": "B\u00f4i tr\u01a1n",
                    "image": "8bc915d915d2f16796c33fb86c81f13e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036379,
                    "display_name": "T\u0103ng c\u01b0\u1eddng sinh l\u00fd",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036380,
                    "display_name": "Kh\u00e1c",
                    "image": "e761990df7a92b084eb9c1563855a5cf",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036381,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "ddf51d955a33b900d050a09411df06c3",
                "is_adult": null,
                "parent_category": 11036345,
                "sort_weight": 834,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11035788,
                "display_name": "\u0110\u1ed3ng H\u1ed3",
                "name": "Watches",
                "image": "86c294aae72ca1db5f541790f7796260",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 833,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035789,
                "display_name": "\u0110\u1ed3ng H\u1ed3 Nam",
                "name": "Men Watches",
                "image": "f8b6a574093d3d611972b857d2d825a8",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 832,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035790,
                "display_name": "\u0110\u1ed3ng H\u1ed3 N\u1eef",
                "name": "Women Watches",
                "image": "73716a6af1e3fb3b7ac538f1552e3459",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 831,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035791,
                "display_name": "B\u1ed9 \u0110\u1ed3ng H\u1ed3 & \u0110\u1ed3ng H\u1ed3 C\u1eb7p",
                "name": "Set & Couple Watches",
                "image": "33dca0575037643e4bdf7eef68f529d5",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 830,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035792,
                "display_name": "\u0110\u1ed3ng H\u1ed3 Tr\u1ebb Em",
                "name": "Kid Watches",
                "image": "b70831e364fa46406d06cf2fe8b1daee",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 829,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035793,
                "display_name": "Ph\u1ee5 Ki\u1ec7n \u0110\u1ed3ng H\u1ed3",
                "name": "Watches Accessories",
                "image": "83977549d485afaf922b76173f11ca71",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 828,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035794,
                    "display_name": "D\u00e2y \u0110\u1ed3ng H\u1ed3",
                    "image": "4de8cb33cb70e5a4cde7d5e5ce56e02e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035795,
                    "display_name": "D\u1ee5ng C\u1ee5 S\u1eeda Ch\u1eefa",
                    "image": "49483754fbfe57ca3d39ef46726e57db",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035796,
                    "display_name": "Kh\u00f3a \u0110\u1ed3ng H\u1ed3",
                    "image": "70e61eafecc975c3dbda4a4cffe3fe05",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035797,
                    "display_name": "Pin \u0110\u1ed3ng H\u1ed3",
                    "image": "b72b8e4fa29506d7a0831aa40f6d7961",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035798,
                    "display_name": "H\u1ed9p \u0110\u1ef1ng \u0110\u1ed3ng H\u1ed3",
                    "image": "95766c1271c138d6adaf1775f163d5c4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035799,
                    "display_name": "Kh\u00e1c",
                    "image": "c4161040e5e2a53935f433a846fd684d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035800,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "5ff9ffb4d3dc6c2370a1655a39c8d75d",
                "is_adult": null,
                "parent_category": 11035788,
                "sort_weight": 821,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11035825,
                "display_name": "Gi\u00e0y D\u00e9p N\u1eef",
                "name": "Women Shoes",
                "image": "48630b7c76a7b62bc070c9e227097847",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 820,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035826,
                "display_name": "B\u1ed1t",
                "name": "Boots",
                "image": "970d1c56a7c1d09cd2e95f85ec18f595",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 819,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035827,
                    "display_name": "B\u1ed1t \u0110i M\u01b0a",
                    "image": "033bbd70d576d8af390f3881ac14679d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035828,
                    "display_name": "B\u1ed1t Th\u1eddi Trang",
                    "image": "528bfbde567d83d9b5396f1fef36e48a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035829,
                    "display_name": "Kh\u00e1c",
                    "image": "e3df64ab31dc036b779e2896c03634d8",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035830,
                "display_name": "Gi\u00e0y Th\u1ec3 Thao/ Sneaker",
                "name": "Sneakers",
                "image": "bc6331e7a2e4abd287151dd1df37f11f",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 815,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035831,
                "display_name": "Gi\u00e0y \u0110\u1ebf B\u1eb1ng",
                "name": "Flats",
                "image": "241420cf60bafec79868e0b8cc09af99",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 814,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035832,
                    "display_name": "Gi\u00e0y Bale",
                    "image": "9e850ab4a9853e5db935e86834ed0053",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035833,
                    "display_name": "Gi\u00e0y L\u01b0\u1eddi",
                    "image": "d20264c322e90e557ab403b29abc0d48",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035834,
                    "display_name": "Gi\u00e0y Oxford & Gi\u00e0y Bu\u1ed9c D\u00e2y",
                    "image": "f21007bfc233176a7ba8b1bb221bd102",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035835,
                    "display_name": "Gi\u00e0y S\u1ee5c & Gi\u00e0y B\u00fap B\u00ea",
                    "image": "f603796648addebb039cdde2c0ce86d2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035836,
                    "display_name": "Kh\u00e1c",
                    "image": "5458e0bb78dc65ed98da6b7de99d282f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035837,
                "display_name": "Gi\u00e0y Cao G\u00f3t",
                "name": "Heels",
                "image": "9808d9f92ed8885a37e60b587331d19c",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 808,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035838,
                "display_name": "Gi\u00e0y \u0110\u1ebf Xu\u1ed3ng",
                "name": "Wedges",
                "image": "07e1b56386a2d1d6281876483ed70a96",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 807,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035839,
                "display_name": "X\u0103ng-\u0111an V\u00e0 D\u00e9p",
                "name": "Flat Sandals & Flip Flops",
                "image": "3b6226a4bcc5cb597d2ed67483fa9a62",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 806,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035840,
                    "display_name": "X\u0103ng-\u0111an \u0110\u1ebf B\u1eb1ng",
                    "image": "f1aaae6c7bec2b0cb6a7ec405df9afc4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035841,
                    "display_name": "D\u00e9p K\u1eb9p/ D\u00e9p X\u1ecf Ng\u00f3n",
                    "image": "c6710dfb121fb77ce35875fd76157fdd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035842,
                    "display_name": "D\u00e9p M\u00e1t-xa",
                    "image": "758537a6903cb00aba750daecac64577",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035843,
                    "display_name": "D\u00e9p \u0110i Trong Nh\u00e0",
                    "image": "9ff3ef138c497b2c566001a24b3832ad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035844,
                    "display_name": "Kh\u00e1c",
                    "image": "974e726e694863510e89a16e3424d41b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035845,
                "display_name": "Ph\u1ee5 Ki\u1ec7n Gi\u00e0y",
                "name": "Shoe Care & Accessories",
                "image": "f8a085a9334c1bdecf747af57990f753",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 800,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035846,
                    "display_name": "\u0110\u1ed3 Kh\u1eed M\u00f9i Gi\u00e0y",
                    "image": "e37d4946303e89dde4bcd3caf9b483dc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035847,
                    "display_name": "Mi\u1ebfng L\u00f3t Gi\u00e0y",
                    "image": "66f5099042a4609593dfd7c92133a00b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035848,
                    "display_name": "C\u00e2y \u0110\u00f3n G\u00f3t & Gi\u1eef Form Gi\u00e0y",
                    "image": "d9a8a2d9e236ba3156d7021d2bb6b94f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035849,
                    "display_name": "\u0110\u1ed3 Ch\u0103m S\u00f3c V\u00e0 L\u00e0m S\u1ea1ch Gi\u00e0y",
                    "image": "8dba46766759326dbca5763c4514ad83",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035850,
                    "display_name": "D\u00e2y Gi\u00e0y",
                    "image": "14b4b906c5982d41d4b8abee50ea4bb6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035851,
                    "display_name": "Kh\u00e1c",
                    "image": "f14edc373c6be345a86d6d379c58397b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035852,
                "display_name": "Gi\u00e0y Kh\u00e1c",
                "name": "Others",
                "image": "e8937ee85035d988a7abcb1237ac5c26",
                "is_adult": null,
                "parent_category": 11035825,
                "sort_weight": 793,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11035801,
                "display_name": "Gi\u00e0y D\u00e9p Nam",
                "name": "Men Shoes",
                "image": "74ca517e1fa74dc4d974e5d03c3139de",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 792,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035802,
                "display_name": "B\u1ed1t",
                "name": "Boots",
                "image": "0e5a56f1a7b76cc3a6152b9e7d333b14",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 791,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035803,
                    "display_name": "B\u1ed1t Th\u1eddi Trang",
                    "image": "9add4ce06b0bc224c5162313c90a915a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035804,
                    "display_name": "B\u1ed1t \u0110i M\u01b0a",
                    "image": "418ebb24b66af3fcc82c6062093566eb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035805,
                    "display_name": "B\u1ed1t B\u1ea3o H\u1ed9",
                    "image": "eea6f4ce42f62833c9459e8e75d980b7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035806,
                    "display_name": "Kh\u00e1c",
                    "image": "39f01ed8c626f0135352f1fafaa6e09f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035807,
                "display_name": "Gi\u00e0y Th\u1ec3 Thao/ Sneakers",
                "name": "Sneakers",
                "image": "32c907a1b9c70b50b4b263f1e7ef06c9",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 786,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035808,
                "display_name": "Gi\u00e0y S\u1ee5c",
                "name": "Slip Ons & Mules",
                "image": "596a7bb65e29dc68e3118670103a7801",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 785,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035809,
                "display_name": "Gi\u00e0y T\u00e2y L\u01b0\u1eddi",
                "name": "Loafers & Boat Shoes",
                "image": "f1dfedbe7f20fb8f4f30c18fcf16777c",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 784,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035810,
                "display_name": "Gi\u00e0y Oxfords & Gi\u00e0y Bu\u1ed9c D\u00e2y",
                "name": "Oxfords & Lace-Ups",
                "image": "d6042e7cd99955276711971318be3907",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 783,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035811,
                "display_name": "X\u0103ng-\u0111an v\u00e0 D\u00e9p",
                "name": "Sandals & Flip Flops",
                "image": "c47139e7c2d5528113ca6d8191860e5d",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 782,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035812,
                    "display_name": "D\u00e9p X\u1ecf Ng\u00f3n",
                    "image": "738b56f1673d3d76b73b004393634393",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035813,
                    "display_name": "X\u0103ng-\u0111an",
                    "image": "76e3111af8956207da8b6cd4d4567ee1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035814,
                    "display_name": "D\u00e9p \u0110i Trong Nh\u00e0",
                    "image": "22290a3181a783d252d7563ae6f4e688",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035815,
                    "display_name": "D\u00e9p M\u00e1t-xa",
                    "image": "771df7c71da363c5360e0b576938179b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035816,
                    "display_name": "Kh\u00e1c",
                    "image": "286a33e70131016e841d2bae2ba0a811",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035817,
                "display_name": "Ph\u1ee5 ki\u1ec7n gi\u00e0y d\u00e9p",
                "name": "Shoe Care & Accessories",
                "image": "ee77a5926081272e8258ff805cec09f5",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 776,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035818,
                    "display_name": "D\u1ee5ng C\u1ee5 Ch\u0103m S\u00f3c & V\u1ec7 Sinh Gi\u00e0y",
                    "image": "92efc31636c79b814e5683e3136501b5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035819,
                    "display_name": "Kh\u1eed M\u00f9i Gi\u00e0y D\u00e9p",
                    "image": "e37d4946303e89dde4bcd3caf9b483dc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035820,
                    "display_name": "D\u00e2y Gi\u00e0y",
                    "image": "9b8e3a4202c7ab527ddc06310bc3e3cd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035821,
                    "display_name": "C\u00e2y \u0110\u00f3n G\u00f3t & Gi\u1eef Form Gi\u00e0y",
                    "image": "d9a8a2d9e236ba3156d7021d2bb6b94f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035822,
                    "display_name": "L\u00f3t Gi\u00e0y",
                    "image": "c3460da443e5edbec701205963f4b546",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035823,
                    "display_name": "Kh\u00e1c",
                    "image": "f14edc373c6be345a86d6d379c58397b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035824,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "046f26674b99e8092133b99861ce9b9c",
                "is_adult": null,
                "parent_category": 11035801,
                "sort_weight": 769,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11035761,
                "display_name": "T\u00fai V\u00ed N\u1eef",
                "name": "Women Bags",
                "image": "fa6ada2555e8e51f369718bbc92ccc52",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 768,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035762,
                "display_name": "Ba L\u00f4 N\u1eef",
                "name": "Backpacks",
                "image": "f2b5d42e62f7cf446cd4d7a0e9e2c36a",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 767,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035763,
                "display_name": "C\u1eb7p Laptop",
                "name": "Laptop Bags",
                "image": "3ba6d4afe11523c1f52eaad01d5bd539",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 766,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035764,
                    "display_name": "T\u00fai C\u1eb7p \u0110\u1ef1ng Laptop",
                    "image": "7fdbe7896369f3eb7bf4dbfbcf488bf6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035765,
                    "display_name": "T\u00fai \u0110\u1ef1ng Laptop Ch\u1ed1ng S\u1ed1c",
                    "image": "65c8487c9b57775f657bbd896836de35",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035766,
                    "display_name": "Ba L\u00f4 Laptop",
                    "image": "13d2c32abd7f9d8079002ffe2a4914f1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035767,
                    "display_name": "Kh\u00e1c",
                    "image": "b5f5d269944e201d4ef917c1c268ce8c",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035768,
                "display_name": "V\u00ed D\u1ef1 Ti\u1ec7c & V\u00ed C\u1ea7m Tay",
                "name": "Clutches & Wristlets",
                "image": "656b36de1018e82c860ee6cc4acb177d",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 761,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035769,
                "display_name": "T\u00fai \u0110eo H\u00f4ng & T\u00fai \u0110eo Ng\u1ef1c",
                "name": "Waist Bags & Chest Bags",
                "image": "c68fc58b02e8dbb7915a45c612367640",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 760,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035770,
                "display_name": "T\u00fai Tote",
                "name": "Tote Bags",
                "image": "f528bbf0fd17dd78e2c13b8eebeda49f",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 759,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035771,
                "display_name": "T\u00fai Quai X\u00e1ch",
                "name": "Top-handle Bags",
                "image": "fc3b9b660d4fa2f39a5a70ee3a90f4f2",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 758,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035772,
                "display_name": "T\u00fai \u0110eo Ch\u00e9o & T\u00fai \u0110eo Vai",
                "name": "Crossbody & Shoulder Bags",
                "image": "226ee0401864034e159243cba6f29e9d",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 757,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035773,
                "display_name": "V\u00ed/B\u00f3p N\u1eef",
                "name": "Wallets",
                "image": "c726baff1c853adad9963ffdb9bd3892",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 756,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035774,
                    "display_name": "V\u00ed/B\u00f3p \u0110\u1ef1ng Th\u1ebb",
                    "image": "7eef1ebf36c764cb1ebddfdf92ffa28e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035775,
                    "display_name": "V\u00ed/B\u00f3p Mini \u0110\u1ef1ng Ti\u1ec1n",
                    "image": "3ae44060bbad8bf981ffe6cd55ab9d67",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035776,
                    "display_name": "V\u00ed/B\u00f3p \u0110\u1ef1ng \u0110i\u1ec7n Tho\u1ea1i & Ch\u00eca Kh\u00f3a",
                    "image": "c425966b4337d9dc7ccd5c34f2afa5a5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035777,
                    "display_name": "V\u00ed/B\u00f3p G\u1eadp",
                    "image": "f6c4262172315a90be995f326b42d5be",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035778,
                    "display_name": "V\u00ed/B\u00f3p D\u00e0i",
                    "image": "87a4375241791c0127c794476a4e776d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035779,
                    "display_name": "V\u00ed Kh\u00e1c",
                    "image": "5fd05fc5cfda4d8a2badfdbc6532bfca",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035780,
                "display_name": "Ph\u1ee5 Ki\u1ec7n T\u00fai",
                "name": "Bag Accessories",
                "image": "1b64bdfe70910453cca3db255dc120f3",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 749,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035781,
                    "display_name": "D\u00e2y \u0110eo T\u00fai",
                    "image": "c9d5416e6c515e13ba0f34b007dc8f8f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035782,
                    "display_name": "D\u1ee5ng C\u1ee5 Treo/\u0110\u1ef1ng T\u00fai",
                    "image": "e783267a869a2c6eb500d0650a4a766e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035783,
                    "display_name": "Charm & Ph\u1ee5 Ki\u1ec7n G\u1eafn T\u00fai",
                    "image": "b4d28d97d7cfaface3029f6524ce2e0b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035784,
                    "display_name": "T\u00fai \u0110a Ng\u0103n Ti\u1ec7n \u00cdch",
                    "image": "115f836fe3834ca3a4f37e13d9bc9011",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035785,
                    "display_name": "D\u1ee5ng C\u1ee5 V\u1ec7 Sinh & Ch\u0103m S\u00f3c T\u00fai",
                    "image": "f4038d925ace7de068d49b335291c93b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035786,
                    "display_name": "Ph\u1ee5 Ki\u1ec7n Kh\u00e1c",
                    "image": "35725eb87298cc1fcd28d15d6b519d79",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035787,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "db1305c1bfbbe90c3e5507f46b39515c",
                "is_adult": null,
                "parent_category": 11035761,
                "sort_weight": 742,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036971,
                "display_name": "Thi\u1ebft B\u1ecb \u0110i\u1ec7n Gia D\u1ee5ng",
                "name": "Home Appliances",
                "image": "7abfbfee3c4844652b4a8245e473d857",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 741,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036972,
                "display_name": "\u0110\u1ed3 gia d\u1ee5ng nh\u00e0 b\u1ebfp",
                "name": "Kitchen Appliances",
                "image": "6de47fc1f3a5f7c63e5b121132cc4403",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 740,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036973,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036975,
                    "display_name": "M\u00e1y l\u00e0m kem, s\u1eefa chua",
                    "image": "7a4bfac7b9abb3f9a1dde93716de762b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036976,
                    "display_name": "M\u00e1y l\u00e0m b\u00e1nh",
                    "image": "b38bb7167d6750bbddb7a43999606389",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036978,
                    "display_name": "L\u00f2 n\u01b0\u1edbng & L\u00f2 vi s\u00f3ng",
                    "image": "cb2584ddeb4ab28596086e7778a39bb5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036979,
                    "display_name": "\u1ea4m si\u00eau t\u1ed1c & B\u00ecnh th\u1ee7y",
                    "image": "914fe559429fab497b00fe6e8a1a533b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036983,
                    "display_name": "N\u1ed3i h\u1ea7m ch\u1eadm",
                    "image": "375242683e0b0f32cebc269d01ab5cd2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036984,
                    "display_name": "B\u1ebfp gas & Ph\u1ee5 ki\u1ec7n b\u1ebfp gas",
                    "image": "d3f1709406f71a9e5934b660e6788072",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036986,
                    "display_name": "M\u00e1y ch\u1ebf bi\u1ebfn th\u1ef1c ph\u1ea9m",
                    "image": "9c842efe4dbfeb5435e141f3fcae56c1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036988,
                    "display_name": "M\u00e1y pha c\u00e0 ph\u00ea",
                    "image": "3ca23ea7f6cddd783ab2bb2c6281cc09",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036989,
                    "display_name": "Ph\u1ee5 t\u00f9ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036990,
                "display_name": "\u0110\u1ed3 gia d\u1ee5ng l\u1edbn",
                "name": "Large Appliance",
                "image": "297c929e6c277332200d06db9bfd971b",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 722,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036991,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036992,
                    "display_name": "M\u00e1y gi\u1eb7t v\u00e0 s\u1ea5y",
                    "image": "f379520e300ddd8bdffbfa38c4478a7f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036993,
                    "display_name": "T\u1ee7 l\u1ea1nh",
                    "image": "7365fbada0ba52e0d481e691fa7f4b2f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036994,
                    "display_name": "M\u00e1y \u1ee7 r\u01b0\u1ee3u",
                    "image": "59ae6a91f0a05e954aa769dad62e94f6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036995,
                    "display_name": "M\u00e1y l\u1ecdc n\u01b0\u1edbc",
                    "image": "dd29255aa7e4dd59b32dd1233557c870",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036996,
                    "display_name": "T\u1ee7 \u0111\u00f4ng",
                    "image": "8684f362897a519bbe69c9ec2243ebf6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036997,
                    "display_name": "M\u00e1y h\u00fat m\u00f9i",
                    "image": "23f71c529618673a3f2d770772680839",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036998,
                    "display_name": "M\u00e1y r\u1eeda ch\u00e9n b\u00e1t",
                    "image": "d53b9b7759e7d6c744e3217a1f7632d1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036999,
                    "display_name": "Ph\u1ee5 t\u00f9ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11037000,
                "display_name": "M\u00e1y h\u00fat b\u1ee5i & Thi\u1ebft b\u1ecb l\u00e0m s\u1ea1ch",
                "name": "Vacuums & Floor care",
                "image": "af21cea3fde669448568a4ec597927ac",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 712,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11037001,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037002,
                    "display_name": "M\u00e1y h\u00fat b\u1ee5i gia \u0111\u00ecnh",
                    "image": "8cc329a577c95cf87ef68d3ec3e6ca8e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037003,
                    "display_name": "Robot h\u00fat b\u1ee5i",
                    "image": "b16860c99e2102452911e8556ed7c189",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037004,
                    "display_name": "M\u00e1y h\u00fat b\u1ee5i c\u00f4ng nghi\u1ec7p",
                    "image": "250edf2cb33b519547fc79ddc66d147e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037005,
                    "display_name": "M\u00e1y th\u1ed5i b\u1ee5i",
                    "image": "7bf9fb29d9ffa5eb9c883672b6254eb3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037006,
                    "display_name": "Ph\u1ee5 t\u00f9ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11037007,
                "display_name": "Qu\u1ea1t & M\u00e1y n\u00f3ng l\u1ea1nh",
                "name": "Air Conditioners & Fans",
                "image": "c3d8f0dde1a3f650a2634dff6dfd45a6",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 705,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11037008,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037009,
                    "display_name": "Qu\u1ea1t",
                    "image": "59693e89772eeee44eed29748d5cf8f0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037010,
                    "display_name": "M\u00e1y \u0111i\u1ec1u h\u00f2a",
                    "image": "839af72891c2686e8e2a1243706d011c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037011,
                    "display_name": "M\u00e1y t\u1ea1o \u1ea9m, M\u00e1y l\u1ecdc kh\u00ed",
                    "image": "38d9333092acd87765df9f7cbebaae17",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037012,
                    "display_name": "M\u00e1y n\u01b0\u1edbc n\u00f3ng",
                    "image": "3fefcae5e6a6b19e01d9ac8546bbb623",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037013,
                    "display_name": "Thi\u1ebft b\u1ecb s\u01b0\u1edfi",
                    "image": "d2977462e4994fd1af419d069c989f9f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037014,
                    "display_name": "M\u00e1y h\u00fat \u1ea9m",
                    "image": "70415202ebd294b083a7647e85cf94f7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037015,
                    "display_name": "Ph\u1ee5 t\u00f9ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11037016,
                "display_name": "Thi\u1ebft b\u1ecb ch\u0103m s\u00f3c qu\u1ea7n \u00e1o",
                "name": "Garment Care",
                "image": "91c2d5705f790dd5b3292214b982b3af",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 696,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11037017,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037018,
                    "display_name": "B\u00e0n \u1ee7i h\u01a1i n\u01b0\u1edbc",
                    "image": "f237479bd4d1cd35ce614b538e686d39",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037019,
                    "display_name": "B\u00e0n \u1ee7i kh\u00f4",
                    "image": "42684d783bbee8f2c263b2ead9be9796",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037020,
                    "display_name": "M\u00e1y may",
                    "image": "8a967f6a109f4fa690147cc3a021fdcd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037021,
                    "display_name": "M\u00e1y c\u1eaft l\u00f4ng x\u00f9",
                    "image": "e7117a4f8ec1a5bce7dd48d8b6a4a58f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11037022,
                    "display_name": "Ph\u1ee5 t\u00f9ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11037023,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "dfb36dfbf8854d4b8df92338048160b5",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 689,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11037024,
                    "display_name": "Kh\u00e1c",
                    "image": "46b3a0d59bb2e64171d4bbf9424075d6",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111620,
                "display_name": "B\u1ebfp \u0111i\u1ec7n",
                "name": "Electric Cookers",
                "image": "72aae3a24aa85ae5ac73373c368170c0",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111624,
                    "display_name": "N\u1ed3i n\u1ea5u \u0111i\u1ec7n",
                    "image": "ebfd7351c5ed739ac233e8825539aa83",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111625,
                    "display_name": "N\u1ed3i c\u01a1m \u0111i\u1ec7n & N\u1ed3i h\u1ea5p",
                    "image": "62596a0ebc0ef143cd831d2cfbd55f3c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111626,
                    "display_name": "B\u1ebfp chi\u00ean kh\u00f4ng kh\u00ed",
                    "image": "b3fc2bb23a71b0040d93e21d2a82af9d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111627,
                    "display_name": "N\u1ed3i \u00e1p su\u1ea5t",
                    "image": "43c9b32d05e42175e0e08ac22a6dcf63",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111628,
                    "display_name": "N\u1ed3i n\u1ea5u ch\u1eadm, h\u1ea7m",
                    "image": "375242683e0b0f32cebc269d01ab5cd2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111630,
                    "display_name": "B\u1ebfp \u0111i\u1ec7n",
                    "image": "95d4b1c52d9b14aebe2ed791f68a42a3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11111631,
                    "display_name": "Ch\u1ea3o \u0111i\u1ec7n & N\u1ed3i l\u1ea9u \u0111i\u1ec7n",
                    "image": "1aa5b40e271edc7162621e888999619f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11111623,
                "display_name": "M\u00e1y xay, \u00e9p, m\u00e1y \u0111\u00e1nh tr\u1ee9ng tr\u1ed9n b\u1ed9t, m\u00e1y xay th\u1ef1c ph\u1ea9m",
                "name": "Blenders, Mixers & Grinders",
                "image": "",
                "is_adult": null,
                "parent_category": 11036971,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11111629,
                    "display_name": "M\u00e1y xay-\u00e9p, \u0111\u00e1nh tr\u1ee9ng tr\u1ed9n b\u1ed9t, m\u00e1y xay th\u1ecbt, xay th\u1ef1c ph\u1ea9m",
                    "image": "1f13def334083e22c6b7b93f5193323e",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11035853,
                "display_name": "Ph\u1ee5 Ki\u1ec7n & Trang S\u1ee9c N\u1eef",
                "name": "Fashion Accessories",
                "image": "8e71245b9659ea72c1b4e737be5cf42e",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 687,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035854,
                "display_name": "Nh\u1eabn",
                "name": "Rings",
                "image": "141c7ad68239e1b3e3a280967b963cc1",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 686,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035855,
                "display_name": "B\u00f4ng tai",
                "name": "Earrings",
                "image": "d597db4812e28977c3d8d53456e21e1c",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 685,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035856,
                "display_name": "Kh\u0103n cho\u00e0ng",
                "name": "Scarves & Shawls",
                "image": "85c4cdd457e45a6170ea096fff6983a9",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 684,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035857,
                "display_name": "G\u0103ng tay",
                "name": "Gloves",
                "image": "43eabb77635a1c0f458c40c126b23369",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 683,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035858,
                "display_name": "Ph\u1ee5 ki\u1ec7n t\u00f3c",
                "name": "Hair Accessories",
                "image": "f55d01008ef0628e978b8061f5330ac4",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 682,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035859,
                    "display_name": "B\u0103ng \u0111\u00f4 t\u00f3c",
                    "image": "47dbc71d9500b4f48dea022d73da7c81",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035860,
                    "display_name": "\u0110\u1ed3 bu\u1ed9c t\u00f3c & N\u01a1",
                    "image": "73a511eb5badcbb722f9596fd7bdd8d2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035861,
                    "display_name": "K\u1eb9p t\u00f3c",
                    "image": "c1180e70d5f3f08d075e00b1f1a83fb5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035862,
                    "display_name": "T\u00f3c gi\u1ea3 & T\u00f3c n\u1ed1i",
                    "image": "f36d8bc0fb1e78d590b49558765bb599",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035863,
                    "display_name": "C\u00e0i t\u00f3c, v\u01b0\u01a1ng mi\u1ec7n c\u00e0i t\u00f3c",
                    "image": "f41d7f3cd05d20b6da12db2bc4d15c8a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035864,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035865,
                "display_name": "V\u00f2ng tay & L\u1eafc tay",
                "name": "Bracelets & Bangles",
                "image": "966c7b041287a7d8730eecb8b1b01593",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 675,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035866,
                "display_name": "L\u1eafc ch\u00e2n",
                "name": "Anklets",
                "image": "1c923e0e2eb9606409451a6ecd37b5fe",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 674,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035867,
                "display_name": "M\u0169",
                "name": "Hats & Caps",
                "image": "5651f768d28242ce05b8e688861965e6",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 673,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035868,
                "display_name": "D\u00e2y chuy\u1ec1n",
                "name": "Necklaces",
                "image": "013db1d5c0b263d333165c0241995059",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 672,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035869,
                "display_name": "K\u00ednh m\u1eaft",
                "name": "Eyewear",
                "image": "a93948c52d5bca7353f756b03cc4e463",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 671,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035870,
                    "display_name": "K\u00ednh m\u00e1t",
                    "image": "878dda35b66f2c3d91b5dc2d1a990434",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035871,
                    "display_name": "G\u1ecdng k\u00ednh",
                    "image": "25c8b3ea04bf860891eccf63ffb074b8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035872,
                    "display_name": "H\u1ed9p k\u00ednh v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "370f05de7101991457f61e708f6ecd07",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035873,
                    "display_name": "Kh\u00e1c",
                    "image": "d609fb65e61946b67983707b3d9e46b1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035874,
                "display_name": "Kim lo\u1ea1i qu\u00fd",
                "name": "Investment Precious Metals",
                "image": "598cce98046f0b59a15a4f969bc4e91a",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 666,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035875,
                    "display_name": "Platinum & V\u00e0ng",
                    "image": "3f86e57f6f66bf8cd7bfa3741e945ba9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035876,
                    "display_name": "B\u1ea1c",
                    "image": "1845caadbf7f1b466131b7fca247b1a0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035877,
                    "display_name": "Kim c\u01b0\u01a1ng",
                    "image": "7bd81fed048426276cd6f136ac084ead",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035878,
                    "display_name": "Ng\u1ecdc b\u00edch, C\u1ea9m th\u1ea1ch",
                    "image": "d549bb9a1bc112918feef865936ece09",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035879,
                    "display_name": "Kh\u00e1c",
                    "image": "5d910238d8ae41a4f1900f61a7926885",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035880,
                "display_name": "Th\u1eaft l\u01b0ng",
                "name": "Belts",
                "image": "437efa41eda23201aeb6ddfea7477660",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 660,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035881,
                "display_name": "C\u00e0 v\u1ea1t & N\u01a1 c\u1ed5",
                "name": "Neckties, Bow Ties & Cravats",
                "image": "94d5eac288e34fe20979723c9cd25348",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 659,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035882,
                "display_name": "Ph\u1ee5 ki\u1ec7n th\u00eam",
                "name": "Additional Accessories",
                "image": "22381a03b27fd7f5dbe526173506ddec",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 658,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035883,
                    "display_name": "Tr\u00e2m & Pin c\u00e0i \u00e1o",
                    "image": "0b9a41b8cd7aa89bfcf4e3162f8ba463",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035884,
                    "display_name": "Mi\u1ebfng v\u00e1 \u00e1o",
                    "image": "8212e3d82c5a3bd2e09e46fc9fca04f2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035885,
                    "display_name": "M\u1eb7t d\u00e2y chuy\u1ec1n v\u00e0 Charm",
                    "image": "2a79970622cd67eae6241e0242b51428",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035887,
                    "display_name": "H\u00ecnh x\u0103m d\u00e1n",
                    "image": "6a9291ad6a0739d3d5540e7cd749b9c9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035888,
                    "display_name": "Kh\u1ea9u trang th\u1eddi trang",
                    "image": "a39ffd4443f276bf4f79809421ec12bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035889,
                    "display_name": "Kh\u0103n tay",
                    "image": "fbbff00e71bb961a83e36a8f1a021ec3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035890,
                    "display_name": "Kh\u00e1c",
                    "image": "ff8d13545c93f6f0e2b4043ef949e591",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035886,
                    "display_name": "M\u0103ng s\u00e9t nam",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035891,
                "display_name": "B\u1ed9 ph\u1ee5 ki\u1ec7n",
                "name": "Accessories Sets & Packages",
                "image": "10314feb327e3efdde4eaed48b0501a0",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 649,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035892,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "f80b6f6dcdde34415405023c8a07a727",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 648,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035893,
                "display_name": "V\u1edb/ T\u1ea5t",
                "name": "Socks & Stockings",
                "image": "4b540845840c720a432bd589a6ea08c9",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 647,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035894,
                    "display_name": "T\u1ea5t",
                    "image": "4f836fabb9152f0438e084650a7d8bd7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035895,
                    "display_name": "Qu\u1ea7n t\u1ea5t",
                    "image": "2d12c6c0c6e416dacb896a102f907118",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035896,
                    "display_name": "Kh\u00e1c",
                    "image": "ee9ee8ec9c99bcfaf032976435585b9e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035897,
                "display_name": "\u00d4/D\u00f9",
                "name": "Umbrella",
                "image": "eed8e815f405304ebc487fd5222beb43",
                "is_adult": null,
                "parent_category": 11035853,
                "sort_weight": 643,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11035478,
                "display_name": "Th\u1ec3 Thao & Du L\u1ecbch",
                "name": "Sport & Outdoor",
                "image": "6cb7e633f8b63757463b676bd19a50e4",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 642,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11035479,
                "display_name": "Vali",
                "name": "Luggage",
                "image": "ea260552a9f37122ea636a29117a347c",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 641,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035480,
                    "display_name": "Vali ti\u1ec3u",
                    "image": "f0a877bff3bcf738c39215f1e75daea8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035481,
                    "display_name": "Vali trung",
                    "image": "4d84bce66714834303995ac4dcd34e09",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035482,
                    "display_name": "Vali \u0111\u1ea1i",
                    "image": "c7df0f0c38c834ca32973359ed9d4492",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035483,
                    "display_name": "Vali v\u1ea3i",
                    "image": "458ff9caa7a13f0d1eb9f9fb80c951ad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035484,
                    "display_name": "Vali nh\u1ef1a",
                    "image": "1c947427e29de9ec5bf24323cb87e2ea",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035485,
                    "display_name": "Vali kh\u00e1c",
                    "image": "16947b1e9740339325818c83e3d88a95",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035486,
                    "display_name": "Vali da",
                    "image": "93412d212b1f3597701ce102de695ddd",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035487,
                "display_name": "T\u00fai du l\u1ecbch",
                "name": "Travel Bags",
                "image": "ec442bb08d34b258a3e09fed3a48466e",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 633,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035488,
                    "display_name": "T\u00fai tr\u1ed1ng",
                    "image": "7aa99276a2f722a30dd4d8f61aeed36c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035489,
                    "display_name": "T\u00fai g\u1ea5p g\u1ecdn",
                    "image": "18190809a5f8a73780b743dfc42868cb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035490,
                    "display_name": "T\u00fai d\u00e2y r\u00fat",
                    "image": "e266949e99db46a81ea70a2371f6505d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035491,
                    "display_name": "T\u00fai kh\u00e1c",
                    "image": "a0e417fdcb03481e260b8a6e9844909f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035492,
                "display_name": "Ph\u1ee5 ki\u1ec7n du l\u1ecbch",
                "name": "Travel Accessories",
                "image": "e7bdb1c7d8d088ca2451cb178a92acfa",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 628,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035493,
                    "display_name": "V\u00ed h\u1ed9 chi\u1ebfu",
                    "image": "68b88243641ad57f4e7459a490ea6a5a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035494,
                    "display_name": "T\u00fai du l\u1ecbch nhi\u1ec1u ng\u0103n",
                    "image": "689e8e960a7f904682728ca882528fa5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035495,
                    "display_name": "\u00c1o tr\u00f9m vali",
                    "image": "4d84bce66714834303995ac4dcd34e09",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035496,
                    "display_name": "Th\u1ebb h\u00e0nh l\u00fd",
                    "image": "aab7ba13e23a2e76d66833109bcc7e11",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035497,
                    "display_name": "D\u00e2y \u0111ai vali",
                    "image": "e9d094bdf83b408d4161dcab664dbc85",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035498,
                    "display_name": "Kh\u00f3a vali",
                    "image": "4636e7cf0632887b42026bf2067c35d4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035499,
                    "display_name": "C\u00e2n h\u00e0nh l\u00fd",
                    "image": "e14552db409b6191ddb6ce4330395c58",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035500,
                    "display_name": "G\u1ed1i & B\u1ecbt m\u1eaft",
                    "image": "b9f98a071564e0488c83491a541e9d91",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035501,
                    "display_name": "B\u1ed9 chi\u1ebft m\u1ef9 ph\u1ea9m",
                    "image": "d0bea9f356acf9d66cfd9e6bac5a47e4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035502,
                    "display_name": "Ph\u1ee5 ki\u1ec7n kh\u00e1c",
                    "image": "7ad95d981f342325c2fe443f6aeefc08",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035503,
                "display_name": "D\u1ee5ng C\u1ee5 Th\u1ec3 Thao & D\u00e3 Ngo\u1ea1i",
                "name": "Sports & Outdoor Recreation Equipments",
                "image": "ffa3e776dc5ffb4b519c30d79645819e",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 617,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035504,
                    "display_name": "C\u00e2u C\u00e1",
                    "image": "abfeba3a692279ce869202e1224e3a5d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035506,
                    "display_name": "C\u1eafm Tr\u1ea1i & D\u00e3 ngo\u1ea1i",
                    "image": "56c6376e090e31ebfba8f790991eff42",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035507,
                    "display_name": "Leo N\u00fai",
                    "image": "c2905dea5462231e2dc38402de20a453",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035508,
                    "display_name": "Th\u1ec3 Thao V\u00e1n Tr\u01b0\u1ee3t",
                    "image": "da646ffa2b87443532d7e2ce2014dfa7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035510,
                    "display_name": "B\u00f3ng \u0110\u00e1, Futsal & C\u1ea7u M\u00e2y",
                    "image": "c35feff8f6a455a0e3bbe53902387dc6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035511,
                    "display_name": "B\u00f3ng R\u1ed5",
                    "image": "0d5302b6558335fdc3ef786c9c7f9eec",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035512,
                    "display_name": "B\u00f3ng Chuy\u1ec1n",
                    "image": "ec41ecd6df5e0608787cdfe1308676ba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035513,
                    "display_name": "C\u1ea7u L\u00f4ng",
                    "image": "80e020d4fdb3f1a43fe6077de1206819",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035514,
                    "display_name": "Tennis",
                    "image": "6aa08d0b5458788502268a97a5ea5d6c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035515,
                    "display_name": "B\u00f3ng B\u00e0n",
                    "image": "1b1ecdc5c538aa55c05051653ce0bf41",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035516,
                    "display_name": "\u0110\u1ea5m b\u1ed1c & V\u00f5 T\u1ed5ng H\u1ee3p",
                    "image": "74888f2d8f5817a54158e1ec02ff6037",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035517,
                    "display_name": "Golf",
                    "image": "6aa08d0b5458788502268a97a5ea5d6c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035518,
                    "display_name": "B\u00f3ng Ch\u00e0y & B\u00f3ng N\u00e9m",
                    "image": "cf38f875f478218ec16fd2b6943f399a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035519,
                    "display_name": "B\u00f3ng Qu\u1ea7n",
                    "image": "5587c12129264fb77fbc50cc1cb61b21",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035520,
                    "display_name": "B\u1eafn S\u00fang & Game Sinh T\u1ed3n",
                    "image": "a2b2dc7167ed94e9ffcf326323de6b7e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035521,
                    "display_name": "B\u00f3ng B\u1ea7u D\u1ee5c",
                    "image": "eb0c8b26e6e79dd6602017fba16afa21",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035522,
                    "display_name": "Bida",
                    "image": "38ddd6a2ab44d8034996ebc380cc9252",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035523,
                    "display_name": "L\u01b0\u1edbt V\u00e1n",
                    "image": "fec6e716211225ca8758967858a39e93",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035524,
                    "display_name": "Tr\u01b0\u1ee3t Tuy\u1ebft & Th\u1ec3 Thao M\u00f9a \u0110\u00f4ng",
                    "image": "f5269cca3a6917e8b08ec9d354338dbc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035525,
                    "display_name": "B\u01a1i L\u1ed9i & L\u1eb7n",
                    "image": "decbc39e25160eea38327fe97132e9f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035526,
                    "display_name": "Ch\u00e8o Thuy\u1ec1n",
                    "image": "da646ffa2b87443532d7e2ce2014dfa7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035527,
                    "display_name": "Yoga & Pilates",
                    "image": "a69db3f3e348fd7aecaed2d665191c27",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035528,
                    "display_name": "Thi\u1ebft B\u1ecb Th\u1ec3 Thao",
                    "image": "68e2efb9fe16ddb2e38e2120030dae00",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035529,
                    "display_name": "N\u00e9m Phi Ti\u00eau",
                    "image": "83b71daab13e9dfe82662f66bae83541",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035530,
                    "display_name": "M\u00f4n Th\u1ec3 Thao Kh\u00e1c",
                    "image": "43ab8cf53256dbc6be47140617917895",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035531,
                "display_name": "Gi\u00e0y Th\u1ec3 Thao",
                "name": "Sports Footwear",
                "image": "c1d30ac8f87bff3b1e78c2546f1014cf",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 589,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035532,
                    "display_name": "Gi\u00e0y B\u00f3ng R\u1ed5",
                    "image": "96f7e81eb01ff8d80618f338ade75e5b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035533,
                    "display_name": "Gi\u00e0y Ch\u1ea1y B\u1ed9",
                    "image": "cb962a552019973fe426d1f6f94937bd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035534,
                    "display_name": "Gi\u00e0y T\u1eadp Luy\u1ec7n",
                    "image": "7c7dc0e5e6cd762fda9dd23a2f13f452",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035535,
                    "display_name": "Gi\u00e0y Tennis",
                    "image": "3fbcdc5486ef42d3fea874e1cfa9c245",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035536,
                    "display_name": "Gi\u00e0y B\u00f3ng Chuy\u1ec1n",
                    "image": "5cf08dc586b51600cb99b6c2b427e8c8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035537,
                    "display_name": "Gi\u00e0y C\u1ea7u L\u00f4ng",
                    "image": "cff0d28b190b4d891a34c3490e58dad4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035538,
                    "display_name": "Gi\u00e0y Futsal",
                    "image": "3ca1fd4f7e05f42f435f7dca9cad4ada",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035539,
                    "display_name": "Gi\u00e0y D\u00e3 Ngo\u1ea1i",
                    "image": "cb962a552019973fe426d1f6f94937bd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035540,
                    "display_name": "Gi\u00e0y B\u00f3ng \u0110\u00e1",
                    "image": "1182afb2d44e6bd53af69fb93062761e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035541,
                    "display_name": "Gi\u00e0y Th\u1ec3 Thao Tr\u1ebb Em",
                    "image": "601368f25d36c42b8980201d43753526",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035542,
                    "display_name": "Gi\u00e0y Th\u1ec3 Thao Kh\u00e1c",
                    "image": "ec77f33db7b51173eaae6c361791e637",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035543,
                "display_name": "Th\u1eddi Trang Th\u1ec3 Thao & D\u00e3 Ngo\u1ea1i",
                "name": "Sports & Outdoor Apparels",
                "image": "db31ccfb06839f449c592dcdbcb096bb",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 577,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035544,
                    "display_name": "B\u1ed9 \u0110\u1ed3 Th\u1ec3 Thao",
                    "image": "61375ba218d2bd0439e4cc797faa2df2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035545,
                    "display_name": "\u00c1o Kho\u00e1c",
                    "image": "33852bbce288712e6866264a7b927122",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035546,
                    "display_name": "\u00c1o Th\u1ec3 Thao",
                    "image": "997bedaab77f50b5a06aed893f4c5961",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035547,
                    "display_name": "\u00c1o CLB",
                    "image": "af8796b2b40bddff9b56644063d70e0e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035548,
                    "display_name": "Qu\u1ea7n Th\u1ec3 Thao",
                    "image": "510ad52d9feca78ba10d2c8dfc0cea46",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035549,
                    "display_name": "\u0110\u1ed3 B\u01a1i",
                    "image": "decbc39e25160eea38327fe97132e9f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035550,
                    "display_name": "\u00c1o L\u00f3t Th\u1ec3 Thao",
                    "image": "5e5dfba019312b96ff325e9f8127aa59",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035551,
                    "display_name": "Th\u1eddi Trang Th\u1ec3 Thao Tr\u1ebb Em",
                    "image": "5585168fd585d3261d6ee310d243b60c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035552,
                    "display_name": "Kh\u00e1c",
                    "image": "fb92f60de0f31e46fabd793324630d93",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035553,
                "display_name": "Ph\u1ee5 Ki\u1ec7n Th\u1ec3 Thao & D\u00e3 Ngo\u1ea1i",
                "name": "Sports & Outdoor Accessories",
                "image": "1509de3b43eea5b71f0e1660b099e3dd",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 567,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035554,
                    "display_name": "\u0110\u1ed3ng H\u1ed3 B\u1ea5m Gi\u00e2y & M\u00e1y \u0110\u1ebfm B\u01b0\u1edbc Ch\u00e2n",
                    "image": "7ad95d981f342325c2fe443f6aeefc08",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035555,
                    "display_name": "T\u00fai \u0110\u1ef1ng Gi\u00e0y",
                    "image": "653d109064daee0b6eee068107e105e8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035556,
                    "display_name": "V\u00f2ng Tay Th\u1ec3 Thao",
                    "image": "750b721ed6bb9801e129b89187aaa78a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035557,
                    "display_name": "B\u0103ng \u0110\u00f4 Th\u1ec3 Thao",
                    "image": "08a7fe2b3789f5b8a0542043469bfc68",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035558,
                    "display_name": "M\u0169 Th\u1ec3 Thao & D\u00e3 Ngo\u1ea1i",
                    "image": "fb92f60de0f31e46fabd793324630d93",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035559,
                    "display_name": "T\u00fai Ch\u1ed1ng Th\u1ea5m",
                    "image": "a0e417fdcb03481e260b8a6e9844909f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035560,
                    "display_name": "\u00c1o M\u01b0a",
                    "image": "2309481419cee090266f8efe342f8760",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035561,
                    "display_name": "\u00d4/D\u00f9",
                    "image": "4afc530c579143f92cc6d9f68f60bbaa",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035562,
                    "display_name": "D\u1ee5ng C\u1ee5 B\u1ea3o V\u1ec7 Mi\u1ec7ng & B\u0103ng Keo Th\u1ec3 Thao",
                    "image": "bcc124d68fe2fa2b10775044a30c8035",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035563,
                    "display_name": "Ph\u1ee5 Ki\u1ec7n T\u1eadp Luy\u1ec7n",
                    "image": "68e2efb9fe16ddb2e38e2120030dae00",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035564,
                    "display_name": "\u0110\u1ed3 B\u1ea3o H\u1ed9 Gym",
                    "image": "750b721ed6bb9801e129b89187aaa78a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035565,
                    "display_name": "Ph\u1ee5 Ki\u1ec7n Kh\u00e1c",
                    "image": "e4e189ed5928982f7cc55a23ab7ee154",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035566,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "f6bf8529a475580aafc2f7a31e3f248f",
                "is_adult": null,
                "parent_category": 11035478,
                "sort_weight": 554,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036525,
                "display_name": "B\u00e1ch H\u00f3a Online",
                "name": "Grocery",
                "image": "c432168ee788f903f1ea024487f2c889",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 553,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036532,
                "display_name": "\u0110\u1ed3 \u0103n v\u1eb7t",
                "name": "Snacks",
                "image": "6a916b9d84dfd47d52e17aed6645a076",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 552,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036533,
                    "display_name": "K\u1eb9o",
                    "image": "321abdff5ec4db577c83f0f11d37ad7a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036534,
                    "display_name": "S\u00f4 c\u00f4 la",
                    "image": "9b0a47da425f4b1eed54f563a5d76346",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036535,
                    "display_name": "B\u00e1nh quy",
                    "image": "ca6f414c3bf44508c758be5a71bf2bf8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036536,
                    "display_name": "Khoai t\u00e2y l\u00e1t",
                    "image": "74945ded399f6a7394c476de2bb0729f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036537,
                    "display_name": "C\u00e1c lo\u1ea1i \u0111\u1eadu s\u1ea5y kh\u00f4",
                    "image": "1c32200b28b8d1ec57a1a2474f7377a6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036538,
                    "display_name": "B\u1ecfng ng\u00f4",
                    "image": "07072705fda6afc5159bc600ccd59f16",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036539,
                    "display_name": "C\u00e1c lo\u1ea1i rong bi\u1ec3n \u0103n li\u1ec1n",
                    "image": "cd82a74a6ab5692076e215cacb801554",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036540,
                    "display_name": "C\u00e1c lo\u1ea1i h\u1ea1t s\u1ea5y kh\u00f4",
                    "image": "cf28e728bc2adcadc0784529a2120cd8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036541,
                    "display_name": "Pudding, th\u1ea1ch & k\u1eb9o d\u1ebbo",
                    "image": "5c1e48fde3a4acf5b491bb484a63991a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036543,
                    "display_name": "Kh\u00e1c",
                    "image": "f44fdbcfa6091c57be13a63c2f2ff3e0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036542,
                    "display_name": "\u0110\u1ed3 \u0103n v\u1eb7t kh\u00f4",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036526,
                "display_name": "\u0110\u1ed3 ch\u1ebf bi\u1ebfn s\u1eb5n",
                "name": "Convenience / Ready-to-eat",
                "image": "aa0f55b8dd843555821a5e64da3d68d6",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 540,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036527,
                    "display_name": "\u0110\u1ed3 \u0103n ch\u1ebf bi\u1ebfn s\u1eb5n",
                    "image": "6f772f6cb9623818dbc7f7e3d8401400",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036528,
                    "display_name": "C\u01a1m v\u00e0 ch\u00e1o \u0103n li\u1ec1n",
                    "image": "8c3805a76ae87a616afebdc9431245b0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036529,
                    "display_name": "L\u1ea9u \u0103n li\u1ec1n",
                    "image": "4078a9f58ee7a8ccc4d77e10cfeaa6dd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036530,
                    "display_name": "M\u00ec \u0103n li\u1ec1n",
                    "image": "69f38bc8e4ebfa399336c2ddbdd35fac",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036531,
                    "display_name": "Kh\u00e1c",
                    "image": "a8a481004f2eab1666a6d7f366aac00c",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036544,
                "display_name": "Nhu y\u1ebfu ph\u1ea9m",
                "name": "Food Staples",
                "image": "299615d77f4012974184d589bd099b15",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 534,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036545,
                    "display_name": "Th\u1ef1c ph\u1ea9m kh\u00f4",
                    "image": "95db63b23bfb8f6f95dbdc02e6c8d3c4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036546,
                    "display_name": "M\u00ec",
                    "image": "a08f4613926a8a23db7af01c3c06306f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036547,
                    "display_name": "G\u1ea1o",
                    "image": "cc4ffb00a185d9d1b3428b37d2e950d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036548,
                    "display_name": "M\u00ec \u00fd",
                    "image": "fbb4d1e3ea1211ab00137a9ee67916ca",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036549,
                    "display_name": "Th\u1ef1c ph\u1ea9m \u0111\u00f3ng h\u1ed9p",
                    "image": "44c275092fe66b2e459e7fe98922ef43",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036550,
                    "display_name": "Rau c\u1ee7 ng\u00e2m",
                    "image": "d5818b790bf0a1ab0a366bd27ee19312",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036551,
                    "display_name": "Kh\u00e1c",
                    "image": "025f2c67a0416585c963d700498820ef",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036552,
                "display_name": "Nguy\u00ean li\u1ec7u n\u1ea5u \u0103n",
                "name": "Cooking Essentials",
                "image": "e5d8eeb533af1e0ae66727348df591f2",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 526,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036553,
                    "display_name": "D\u1ea7u \u0103n",
                    "image": "a77b618bc785406570cea4f9cfbc4bb9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036554,
                    "display_name": "Gia v\u1ecb & H\u01b0\u01a1ng li\u1ec7u",
                    "image": "666b736b0d5099e54ed67df1f92b906c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036555,
                    "display_name": "\u0110\u01b0\u1eddng",
                    "image": "91f6c5fb64ba96deff859bc1b33869ec",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036556,
                    "display_name": "Ch\u1ea5t t\u1ea1o ng\u1ecdt",
                    "image": "188ab20a7d360a6267e2205b59837ed0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036557,
                    "display_name": "S\u1ed1t & s\u00fap \u0103n li\u1ec1n",
                    "image": "0bb23c3164c64c5b8165d35a5dbf576c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036558,
                    "display_name": "G\u00f3i/ b\u1ed9t gia v\u1ecb",
                    "image": "d45ad4785403a3db3c5d053c7c605962",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036559,
                    "display_name": "Ph\u1ee5 gia th\u1ef1c ph\u1ea9m",
                    "image": "f7dd5428e67d7f064e727ac55a043b07",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036560,
                    "display_name": "B\u1ed9t ph\u1ee7",
                    "image": "19a42c236764976eba2403ee51550972",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036561,
                    "display_name": "Kh\u00e1c",
                    "image": "3949a4427c916c5f773240d430530a15",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036562,
                "display_name": "\u0110\u1ed3 l\u00e0m b\u00e1nh",
                "name": "Baking Needs",
                "image": "30509e0467d400b486eb64026d3583ee",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 516,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036563,
                    "display_name": "H\u01b0\u01a1ng li\u1ec7u",
                    "image": "2908cafaebe160d9dd16000bf6c8d6b0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036564,
                    "display_name": "B\u1ed9t n\u1edf v\u00e0 mu\u1ed1i n\u1edf",
                    "image": "69f3d8798153481e2a87d91d61acfa2b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036565,
                    "display_name": "B\u1ed9t pha s\u1eb5n",
                    "image": "b88d7b6751c963537f1030017623f7d1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036566,
                    "display_name": "B\u1ed9t m\u00ec",
                    "image": "933d69679944f7e0d44311df381ecac3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036567,
                    "display_name": "Ch\u1ea5t t\u1ea1o m\u00e0u",
                    "image": "d31d5e9269979c0269f5961393376392",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036568,
                    "display_name": "\u0110\u1ed3 trang tr\u00ed",
                    "image": "d51af569799a36fe364878097498194f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036569,
                    "display_name": "Kh\u00e1c",
                    "image": "37fec2b25d5aabc06ed779442efb2798",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036591,
                "display_name": "S\u1eefa - tr\u1ee9ng",
                "name": "Dairy & Eggs",
                "image": "8487ddb64e76a25095494464eea17a9b",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 508,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036592,
                    "display_name": "S\u1eefa",
                    "image": "dee806e549d0ceefe75bf471fe2d1a27",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036593,
                    "display_name": "S\u1eefa chua",
                    "image": "36c4280c1c4dc7e7f09195f3fc0c944d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036594,
                    "display_name": "B\u1ed9t kem b\u00e9o",
                    "image": "efaaf60f9a5dacc3aef9caeb03b9be4e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036595,
                    "display_name": "B\u01a1 \u0111\u1ed9ng v\u1eadt v\u00e0 b\u01a1 th\u1ef1c v\u1eadt",
                    "image": "b4e0e6b7e46958d46fd4975539caa8ee",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036596,
                    "display_name": "Ph\u00f4 mai & b\u1ed9t ph\u00f4 mai",
                    "image": "357957ccfe9e4508507e8215c8b392f9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036597,
                    "display_name": "Kem",
                    "image": "567cbb1d683b00e525f0cd119d7785d2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036598,
                    "display_name": "Tr\u1ee9ng",
                    "image": "90d35a31c3ea6fe4a6ab95a4868fb680",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036599,
                    "display_name": "\u0110\u1eadu ph\u1ee5",
                    "image": "03bdac3a10cfef5682c675d067993558",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036600,
                    "display_name": "Kh\u00e1c",
                    "image": "ef063cd0dea3874ade604197ac3c4651",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036576,
                "display_name": "\u0110\u1ed3 u\u1ed1ng",
                "name": "Beverages",
                "image": "772a0404ea3205802bb2baec6248c476",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 498,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036577,
                    "display_name": "C\u00e0 ph\u00ea",
                    "image": "b1528c8eb1397fab35fcd279988c2e8f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036578,
                    "display_name": "Tr\u00e0 & tr\u00e0 t\u00fai l\u1ecdc",
                    "image": "c6b8f0914a39dc0666a09b9ded2ed9df",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036579,
                    "display_name": "S\u00f4 c\u00f4 la",
                    "image": "d0fe735adc5fc45810e7d8d1b9645e71",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036580,
                    "display_name": "N\u01b0\u1edbc t\u0103ng l\u1ef1c",
                    "image": "c715963aa9f62e07b0675df6424206f3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036581,
                    "display_name": "N\u01b0\u1edbc tinh khi\u1ebft",
                    "image": "b9140b9696494d5fa4c5db0558edd594",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036582,
                    "display_name": "N\u01b0\u1edbc tr\u00e1i c\u00e2y l\u00ean men",
                    "image": "4f05cf3a0fa39d80e59bd0dc56671aa7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036583,
                    "display_name": "Siro",
                    "image": "1387426fbe282d049e3c7495ffe0b248",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036584,
                    "display_name": "N\u01b0\u1edbc c\u00f3 ga",
                    "image": "62b6152e0640b98c111d6001077b52c8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036585,
                    "display_name": "B\u1ed9t pha",
                    "image": "2f6999388f86e3192d84a9ccd553181a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036586,
                    "display_name": "\u0110\u1ed3 tr\u00e1ng mi\u1ec7ng",
                    "image": "99d555eb495a7c87eebe1dbf1635d9aa",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036587,
                    "display_name": "Tr\u00e0 th\u1ea3o m\u1ed9c",
                    "image": "b533025caeee7519add299b943555ac2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036588,
                    "display_name": "Topping",
                    "image": "0e55a2c3870a7cceddf77022c028129a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036589,
                    "display_name": "S\u1eefa th\u1ef1c v\u1eadt",
                    "image": "ca149a7f327352e754dcea5a50be1aea",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036590,
                    "display_name": "Kh\u00e1c",
                    "image": "bb02eac435c8d7df27aa01e351cf79c3",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036570,
                "display_name": "Ng\u0169 c\u1ed1c & m\u1ee9t",
                "name": "Breakfast Cereals & Spread",
                "image": "e0ce345bab5a1aac2fa1c924270192a2",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 483,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036571,
                    "display_name": "M\u1eadt ong v\u00e0 siro",
                    "image": "e8beebc414f80ff3f670121e7297cbe5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036572,
                    "display_name": "M\u1ee9t",
                    "image": "424420a33e9d4fee37664c6719622474",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036573,
                    "display_name": "Ng\u0169 c\u1ed1c",
                    "image": "969fdd717a3f32bb011d5af075be0a13",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036574,
                    "display_name": "Thanh dinh d\u01b0\u1ee1ng",
                    "image": "ca1be40b41a04a4b3966a682e470d9c7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036575,
                    "display_name": "Kh\u00e1c",
                    "image": "90bd64398020a9fbd4cdb74e1d61a29d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036611,
                "display_name": "C\u00e1c lo\u1ea1i b\u00e1nh",
                "name": "Bakery",
                "image": "7cda1cf3ff845b14703e65368fb022a9",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 477,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036612,
                    "display_name": "B\u00e1nh m\u00ec",
                    "image": "3d5bacfc239a506683125ad6ad1c5c3b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036613,
                    "display_name": "B\u00e1nh kem",
                    "image": "368d21e69099be473c2346c8a71faf9f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036614,
                    "display_name": "B\u00e1nh ng\u1ecdt/ pastry",
                    "image": "2dd75d3e315ef9f6a45438fa237f6145",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036615,
                    "display_name": "Kh\u00e1c",
                    "image": "426c55d2daf0e6e60b82a6fd9259efb9",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036616,
                "display_name": "\u0110\u1ed3 u\u1ed1ng c\u00f3 c\u1ed3n",
                "name": "Alcoholic Beverages",
                "image": "2b3ee36038127d0426aec7b0c3e0be1c",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 472,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036617,
                    "display_name": "Bia v\u00e0 tr\u00e1i c\u00e2y l\u00ean men",
                    "image": "473838eca5bc241107d220a09399230e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036618,
                    "display_name": "R\u01b0\u1ee3u vang v\u00e0 S\u00e2m panh",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036619,
                    "display_name": "R\u01b0\u1ee3u m\u1ea1nh",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036620,
                    "display_name": "R\u01b0\u1ee3u sake, soju & umeshu",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036621,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036622,
                "display_name": "B\u1ed9 qu\u00e0 t\u1eb7ng",
                "name": "Gift Set & Hampers",
                "image": "df21ac643118cbdd17e82e9097fdc790",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 466,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036601,
                "display_name": "Th\u1ef1c ph\u1ea9m t\u01b0\u01a1i s\u1ed1ng v\u00e0 th\u1ef1c ph\u1ea9m \u0111\u00f4ng l\u1ea1nh",
                "name": "Fresh & Frozen Food",
                "image": "2a517e74c84915df681d9d5078610007",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 465,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036602,
                    "display_name": "Th\u1ecbt",
                    "image": "c6a8e49c52bf7a6a112702afbfc837eb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036603,
                    "display_name": "H\u1ea3i s\u1ea3n",
                    "image": "a29f6a6d65eb8a27ce2ada12a95fddb7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036604,
                    "display_name": "Th\u1ecbt chay",
                    "image": "8dba5a4d15945b5c463a3f9229e1808f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036605,
                    "display_name": "Rau c\u1ee7",
                    "image": "eea1d7c8077ac21dcbcdee1f066c1d3b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036606,
                    "display_name": "Tr\u00e1i c\u00e2y",
                    "image": "928b424b8a5c7e51587985f1c571db42",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036607,
                    "display_name": "N\u1ea5m",
                    "image": "49c72072015ac68a8f241b1fa0916230",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036608,
                    "display_name": "Th\u1ef1c ph\u1ea9m \u0111\u00f4ng l\u1ea1nh ch\u1ebf bi\u1ebfn s\u1eb5n",
                    "image": "0a975588421f36bf2c3e95c19f9e9c3c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036609,
                    "display_name": "Th\u1ecbt v\u00e0 h\u1ea3i s\u1ea3n ch\u1ebf bi\u1ebfn s\u1eb5n",
                    "image": "166450c94f0671d991e7e5c444823169",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036610,
                    "display_name": "Kh\u00e1c",
                    "image": "fa4b44861bbbd70af1877c0ebda8604e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036623,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "55b6c666831403eb9655d6aa7781aa3b",
                "is_adult": null,
                "parent_category": 11036525,
                "sort_weight": 455,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036793,
                "display_name": "\u00d4 T\u00f4 & Xe M\u00e1y & Xe \u0110\u1ea1p",
                "name": "Automotive",
                "image": "3fb459e3449905545701b418e8220334",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 454,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036794,
                "display_name": "Xe \u0111\u1ea1p, xe \u0111i\u1ec7n",
                "name": "Bike, E-bike",
                "image": "9eba588845ff073fa4d384b93ddf1902",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 453,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036795,
                    "display_name": "Xe \u0111\u1ea1p Fix Gear",
                    "image": "72a0522d5c513920bd0e580ec21c87d4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036796,
                    "display_name": "Xe \u0111\u1ea1p g\u1ea5p",
                    "image": "43d7cbb5067a56a2ea4ce1554aa243cb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036797,
                    "display_name": "Xe \u0111\u1ea1p \u0111ua",
                    "image": "8089e3bed17d2e9275dfe90ebcf30b88",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036798,
                    "display_name": "Xe \u0111\u1ea1p leo n\u00fai",
                    "image": "fe995a9f8a7c461b95f8499f38aa5956",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036799,
                    "display_name": "Xe \u0111\u1ea1p \u0111\u01b0\u1eddng tr\u01b0\u1eddng",
                    "image": "7ef3f34c8885ac4d192697c41532d42e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036800,
                    "display_name": "Xe \u0111i\u1ec7n",
                    "image": "870af0401953599903f2c0cfaab8d1f6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036801,
                    "display_name": "Xe \u0111\u1ea1p th\u00f4ng d\u1ee5ng",
                    "image": "c2654abb189202dfa3c07d52658506fc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036802,
                    "display_name": "Xe \u0111\u1ea1p tr\u1ebb em",
                    "image": "85b5b6a73b4c32c74a8e8139abc9e9b1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036803,
                    "display_name": "Xe \u0111\u1ea1p th\u1ec3 thao",
                    "image": "15837ebd74d54349131ee333604d21e1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036804,
                "display_name": "M\u00f4 t\u00f4, xe m\u00e1y",
                "name": "Motorbike",
                "image": "12f22097cdfc2486d924d65a394a853b",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 443,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036805,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036806,
                    "display_name": "Xe tay ga",
                    "image": "1fb2ce45261acf7a4e4a8e67f548f0bd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036807,
                    "display_name": "Xe s\u1ed1",
                    "image": "949949e0413698f2a1ac795c931f85a3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036808,
                    "display_name": "Xe c\u00f4n tay",
                    "image": "f005ad78f805cf5d77d5615c8072b2c7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036809,
                    "display_name": "Xe ph\u00e2n kh\u1ed1i l\u1edbn",
                    "image": "fa538aa626d20caf75067b564fc23591",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036810,
                    "display_name": "Xe 50 cc",
                    "image": "f6ef0da1074c8a966751982c6847a78a",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036811,
                "display_name": "Xe \u00d4 t\u00f4",
                "name": "Car",
                "image": "20b181522d30b932d5e5f7464c9963db",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 436,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036812,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036813,
                    "display_name": "Xe Sedan",
                    "image": "8c84718da96df31b49c8087a662031d4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036814,
                    "display_name": "Xe SUV",
                    "image": "b264ff493704a163f4aa1e8f6cc63c9e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036815,
                    "display_name": "Xe Hatchback",
                    "image": "e317ac09d293e1dcff25231447cfc03d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036816,
                    "display_name": "Xe b\u00e1n t\u1ea3i",
                    "image": "1af9a94db0724e3c59605f92af2bfac7",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036817,
                "display_name": "M\u0169 b\u1ea3o hi\u1ec3m",
                "name": "Helmets",
                "image": "085be40e2b8dc75355e3c2989df865e4",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 430,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036818,
                    "display_name": "Ph\u1ee5 ki\u1ec7n m\u0169 b\u1ea3o hi\u1ec3m",
                    "image": "52bc2ecdf05c58f6659b328ec148d194",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036819,
                    "display_name": "M\u0169 b\u1ea3o hi\u1ec3m tr\u1ebb em",
                    "image": "119997a10e4b048d08d5381415c7338e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036820,
                    "display_name": "M\u0169 b\u1ea3o hi\u1ec3m n\u1eeda \u0111\u1ea7u",
                    "image": "7d107a80926826c9e85c52e94a9ad2dd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036821,
                    "display_name": "M\u0169 b\u1ea3o hi\u1ec3m 3/4 \u0111\u1ea7u",
                    "image": "d5ae59e32052661c6a9903549f7e7001",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036822,
                    "display_name": "M\u0169 b\u1ea3o hi\u1ec3m fullface",
                    "image": "7fba5fe139f29cabb637e6122ae8972e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036823,
                    "display_name": "M\u0169 b\u1ea3o hi\u1ec3m xe \u0111\u1ea1p",
                    "image": "90d83ba5761c8f4d781014027caf0870",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036824,
                "display_name": "Ph\u1ee5 ki\u1ec7n xe m\u00e1y",
                "name": "Motorbike Accessories",
                "image": "e66ab2f461bb17631d17062743e3a165",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 423,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036825,
                    "display_name": "Ph\u1ee5 ki\u1ec7n kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036830,
                    "display_name": "B\u1ea1t ph\u1ee7",
                    "image": "1a999523a11a98ec4e0ebd3ddf642aad",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108825,
                    "display_name": "Th\u1ea3m l\u00f3t",
                    "image": "512442c63e6c5c95500af424b54f90c9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108826,
                    "display_name": "\u0110\u1ed3ng h\u1ed3 xe m\u00e1y",
                    "image": "3200da5d73f27f3a45f64000f4d49452",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108827,
                    "display_name": "Logo, decal d\u00e1n xe m\u00e1y",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108828,
                    "display_name": "Gh\u1ebf, y\u00ean xe & B\u1ecdc y\u00ean",
                    "image": "7f1ded0e86d8cae23dbd622a45278a75",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108829,
                    "display_name": "G\u01b0\u01a1ng & Ph\u1ee5 ki\u1ec7n",
                    "image": "f2b0ad37341a0eb6778cc57d765c80cf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108830,
                    "display_name": "Kh\u00f3a ch\u1ed1ng tr\u1ed9m",
                    "image": "bab9a160a7561b197a1531b06e7c9a57",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108831,
                    "display_name": "Baga v\u00e0 th\u00f9ng xe m\u00e1y",
                    "image": "3dbfcedaf60659a237459fa5e026be77",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108832,
                    "display_name": "K\u1eb9p \u0111i\u1ec7n tho\u1ea1i",
                    "image": "6862c143f69328f00c7d3325f885f41f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108833,
                    "display_name": "Ch\u1eafn b\u00f9n xe m\u00e1y",
                    "image": "c27f9db37d2cf93d4874f1cc9d1d6d4e",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036846,
                "display_name": "Ph\u1ee5 ki\u1ec7n xe \u0111\u1ea1p",
                "name": "Bicycle & E-bike Accessories",
                "image": "66c339b238eb109e0890de4b5bf4bfb3",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 401,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036847,
                    "display_name": "Kh\u00e1c",
                    "image": "921ef732f66633433cd43102196a842a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108835,
                    "display_name": "B\u01a1m xe \u0111\u1ea1p",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108836,
                    "display_name": "\u0110\u00e8n xe \u0111\u1ea1p v\u00e0 \u0111\u00e8n ph\u1ea3n quang",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108837,
                    "display_name": "L\u1ed1p v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108838,
                    "display_name": "D\u1ee5ng c\u1ee5 s\u1eeda ch\u1eefa",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108839,
                    "display_name": "H\u00e0nh l\u00fd t\u00fai treo",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108840,
                    "display_name": "Ph\u1ee5 t\u00f9ng kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108841,
                    "display_name": "V\u00e0nh v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108842,
                    "display_name": "B\u1ed9 \u0111\u1ec1, s\u1ed1 xe \u0111\u1ea1p",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108843,
                    "display_name": "B\u00e0n \u0111\u1ea1p v\u00e0 khung s\u01b0\u1eddn",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108844,
                    "display_name": "Phanh v\u00e0 ghi \u0111\u00f4ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108845,
                    "display_name": "Pin xe \u0111i\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108846,
                    "display_name": "Kh\u00f3a b\u1ea3o v\u1ec7, ch\u1ed1ng tr\u1ed9m",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108953,
                "display_name": "Ph\u1ee5 t\u00f9ng xe m\u00e1y",
                "name": "Motorbike Spare Parts",
                "image": "9bd9fcdfbff327fbfd93b18e14c67327",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108834,
                    "display_name": "B\u1ed9 ph\u1eadn \u0111\u00e1nh l\u1eeda & \u0111\u1ed9ng c\u01a1",
                    "image": "05c88cda8582a4ec7cc2d0b1979e0e03",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108954,
                    "display_name": "H\u1ec7 th\u1ed1ng nhi\u00ean li\u1ec7u",
                    "image": "785d60de2715d9bc8227d2afb153993d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108955,
                    "display_name": "H\u1ec7 th\u1ed1ng phanh",
                    "image": "d8e2f31f249672b5f4b44fbd23c9f358",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108956,
                    "display_name": "Gi\u1ea3m x\u00f3c",
                    "image": "cf82e5b7f5e33264f5c07788657df664",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108957,
                    "display_name": "H\u1ec7 th\u1ed1ng truy\u1ec1n \u0111\u1ed9ng, H\u1ed9p s\u1ed1 & Ly h\u1ee3p",
                    "image": "ba00509de4a2f0781ebc349a6edf66b6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108958,
                    "display_name": "Pin & Ph\u1ee5 ki\u1ec7n",
                    "image": "f5e22949a894f53c66306216c8c85c05",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108959,
                    "display_name": "C\u00f2i & ph\u1ee5 ki\u1ec7n",
                    "image": "2852eee58c381c7ce17f24346526052e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108960,
                    "display_name": "C\u00e1p & \u1ed1ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108961,
                    "display_name": "Khung s\u01b0\u1eddn",
                    "image": "5341779e346b68709250691ee2854058",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108962,
                    "display_name": "H\u1ec7 th\u1ed1ng x\u1ea3 & kh\u00ed th\u1ea3i",
                    "image": "b6adf77c83b348d4d146601d2af27d3e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108963,
                    "display_name": "B\u00e1nh xe, V\u00e0nh & Ph\u1ee5 ki\u1ec7n",
                    "image": "82c233c35c768886fcf43292852d0c0e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108964,
                    "display_name": "L\u1ed1p & Ph\u1ee5 ki\u1ec7n",
                    "image": "a26109fb708ea80a0c8e60f0435074a7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108965,
                    "display_name": "\u0110\u00e8n",
                    "image": "7a4fe729476699aa836ddbc9e416ae72",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108966,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108967,
                "display_name": "D\u1ea7u nh\u1edbt & d\u1ea7u nh\u1eddn",
                "name": "Automotive Oils & Lubes",
                "image": "7fe3105f630bc40205eb96c94b4338cb",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108968,
                    "display_name": "D\u1ea7u",
                    "image": "365a8cc667c0eb0fe79f68e8d899c5c8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108969,
                    "display_name": "Ph\u1ee5 gia & Ti\u1ebft ki\u1ec7m Nhi\u00ean li\u1ec7u",
                    "image": "ab0e6ea8c91bbca33b50fd6f5de2adce",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108970,
                    "display_name": "M\u1ee1 & Ch\u1ea5t b\u00f4i tr\u01a1n",
                    "image": "cb82b4ff61a0eeb9192100c30a2990fb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108971,
                    "display_name": "Ch\u1ea5t ch\u1ed1ng \u0111\u00f4ng & ch\u1ea5t l\u00e0m m\u00e1t",
                    "image": "42c3af364099cc16eeb4dc553cc67a56",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108972,
                    "display_name": "Ch\u1ea5t l\u1ecfng \u00f4 t\u00f4",
                    "image": "3be34618c029120c6693207c5b287f55",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108973,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108974,
                "display_name": "Ch\u0103m s\u00f3c \u00f4 t\u00f4",
                "name": "Automotive Care",
                "image": "274dfd55df9c9de27ef81ac1c1590235",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108975,
                    "display_name": "Ch\u0103m s\u00f3c n\u1ed9i th\u1ea5t xe",
                    "image": "d291f868d1d4ad7e279d2b7f5058643e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108976,
                    "display_name": "Ch\u0103m s\u00f3c l\u1ed1p & b\u00e1nh xe",
                    "image": "dddb7ce8756034618488c97e11dd443b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108977,
                    "display_name": "L\u1edbp ph\u1ee7",
                    "image": "8bfc3b10211b592456334fc28deba675",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108978,
                    "display_name": "Dung m\u00f4i",
                    "image": "0e89a83e28435f323236cd476025823e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108979,
                    "display_name": "M\u00e1y h\u00fat b\u1ee5i",
                    "image": "3a3e433fc6c7db561114c1f5d15b6c0f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108980,
                    "display_name": "B\u1ed9 d\u1ee5ng c\u1ee5 l\u00e0m s\u1ea1ch v\u00e0 ch\u0103m s\u00f3c xe h\u01a1i",
                    "image": "a68b1f13615b1d133e671763417e3450",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108981,
                    "display_name": "\u0110\u00e1nh b\u00f3ng, s\u01a1n ph\u1ee7 & ch\u1ea5t l\u00e0m k\u00edn",
                    "image": "cd08f928827c510cc5f0e42cd1e7f543",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108982,
                    "display_name": "Kh\u00e1c",
                    "image": "04666340a835f8acad3dbec915c5c543",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108983,
                    "display_name": "D\u1ee5ng c\u1ee5 s\u1eeda ch\u1eefa",
                    "image": "d44340c2ac2a77e2cbad73d8357b9845",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108984,
                "display_name": "Ph\u1ee5 ki\u1ec7n b\u00ean trong \u00f4 t\u00f4",
                "name": "Interior Accessories",
                "image": "045ac2bfedd4be67b473859ef9231b1e",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108985,
                    "display_name": "\u0110i\u1ec1u h\u01b0\u1edbng & B\u1ed9 thu AV",
                    "image": "954cd86b32afe1df5b699d3becaa0b80",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108986,
                    "display_name": "B\u1ed9 khu\u1ebfch \u0111\u1ea1i, loa & loa si\u00eau tr\u1ea7m",
                    "image": "6b74c7dfe214c562c4a516e3cc049142",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108987,
                    "display_name": "T\u00fai treo, th\u00f9ng \u0111\u1ec3 \u0111\u1ed3",
                    "image": "3880c9ce06837d7072182ae16dcef14e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108988,
                    "display_name": "N\u01b0\u1edbc hoa, M\u00e1y l\u00e0m s\u1ea1ch kh\u00f4ng kh\u00ed & M\u00e1y l\u1ecdc",
                    "image": "2e92d24e03fbe80ced3d33d2ef8bb57b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108989,
                    "display_name": "Th\u1ea3m \u0111\u1ec1 ch\u00e2n",
                    "image": "4830b12882f6d0701433fe61eb6e6309",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108990,
                    "display_name": "G\u1ed1i, n\u1ec7m t\u1ef1a l\u01b0ng, \u0111\u1ea7u",
                    "image": "bbaad46cb756c193dc908cdd333c2673",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108991,
                    "display_name": "N\u1ec7m \u00f4 t\u00f4",
                    "image": "58349d2ddc93567c099169f43da145ee",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108992,
                    "display_name": "V\u00f4 l\u0103ng v\u00e0 b\u1ecdc v\u00f4 l\u0103ng",
                    "image": "c60eedbdd6ba8e98bac01b488b3b8055",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108993,
                    "display_name": "B\u1ecdc gh\u1ebf & Ph\u1ee5 ki\u1ec7n",
                    "image": "82ce6f36b142cacb3054ca2d0b05d6b0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108994,
                    "display_name": "K\u1eb9p \u0111i\u1ec7n tho\u1ea1i \u00f4 t\u00f4",
                    "image": "3d4b47ed3ee7fd0eb978c6ca80b771c0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108995,
                    "display_name": "B\u1ed9 s\u1ea1c USB, B\u1ed9 ph\u00e1t FM & Bluetooth",
                    "image": "c1d6c8b58694cfae7689e9f3d920ae82",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108996,
                    "display_name": "B\u00e0n \u0111\u1ea1p & C\u1ea7n s\u1ed1",
                    "image": "ac7881fad39069f3a965d84485237513",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108997,
                    "display_name": "T\u1ea5m ch\u1eafn n\u1eafng & Th\u1ea3m tablo",
                    "image": "396acdb874d9c6dedd6981e370c1c889",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108998,
                    "display_name": "Kh\u00f3a & B\u1ea3o m\u1eadt",
                    "image": "d3b866951af748266947599fc6d0c3c6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108999,
                    "display_name": "Camera h\u00e0nh tr\u00ecnh, camera l\u00f9i",
                    "image": "d6da68a1f3eacc9a1d00aba56e66967e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109000,
                    "display_name": "HUD, \u0110\u1ed3ng h\u1ed3 \u0111o t\u1ed1c \u0111\u1ed9 & \u0110\u1ed3ng h\u1ed3 \u0111o",
                    "image": "d6867d1a036114e5157be2f460bccc24",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109001,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116773,
                    "display_name": "M\u00f3c ch\u00eca kh\u00f3a v\u00e0 B\u1ecdc ch\u00eca \u00f4 t\u00f4",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11109002,
                "display_name": "Ph\u1ee5 ki\u1ec7n b\u00ean ngo\u00e0i \u00f4 t\u00f4",
                "name": "Exterior Accessories",
                "image": "908c0a1dfa540a400fcd3aaba49b5bf7",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11109003,
                    "display_name": "Phim d\u00e1n, b\u1ecdc xe",
                    "image": "9919e03253fab3ffeacba3e920ace8f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109004,
                    "display_name": "B\u1ea1t ph\u1ee7",
                    "image": "01bcfb9b5ae44de64de87ed3b74be699",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109005,
                    "display_name": "\u0102ng Ten",
                    "image": "81265843b2539832715593a9bf96bc2e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109006,
                    "display_name": "Logo, sticker, mi\u1ebfng d\u00e1n",
                    "image": "1fb197a9a0bb9006b563fdf5a30ce093",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109007,
                    "display_name": "B\u1ecdc bi\u1ec3n s\u1ed1",
                    "image": "27883f2b67a478cce6ebcd7d95bd3992",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109008,
                    "display_name": "V\u00e8 che n\u1eafng, che m\u01b0a",
                    "image": "c463fbe20c271276363350ba5aea9c5e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109009,
                    "display_name": "Ph\u1ee5 ki\u1ec7n ch\u1eafn b\u00f9n",
                    "image": "565f286a23398c5adb37f35271ffa6d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109010,
                    "display_name": "C\u00f2i xe v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "86b75760cb6e933c0349c6c06355aae6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109011,
                    "display_name": "Chrome b\u1ecdc xe",
                    "image": "2ad2ae5cafc0ff1356c3a0388b054987",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109012,
                    "display_name": "G\u01b0\u01a1ng v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "e1074a24dc50b3412871188c501e1cff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109013,
                    "display_name": "G\u0103ng cao su, n\u1eb9p ch\u1ed1ng tr\u1ea7y",
                    "image": "deb3361c9fdfc867477306edba9553de",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109014,
                    "display_name": "Kh\u00e1c",
                    "image": "52c0712448edaf021b17b8a536bac9c2",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11109015,
                "display_name": "Ph\u1ee5 t\u00f9ng \u00f4 t\u00f4",
                "name": "Auto Parts & Spares",
                "image": "de070238da398d417717d2fcdc1cc5aa",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11109016,
                    "display_name": "Th\u00e2n xe, Khung & B\u1ed9 \u0111\u1ec7m",
                    "image": "73b6a2c5bc49489ee16ec70abb7b3a07",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109017,
                    "display_name": "C\u1ea7n g\u1ea1t n\u01b0\u1edbc & v\u00f2ng \u0111\u1ec7m k\u00ednh ch\u1eafn gi\u00f3",
                    "image": "f9de152c3883e090c93c5cf21a282a5e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109018,
                    "display_name": "H\u1ec7 th\u1ed1ng x\u1ea3 & kh\u00ed th\u1ea3i",
                    "image": "dae8cbf2c376a2b8f923589cc6398704",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109019,
                    "display_name": "B\u00e1nh xe, V\u00e0nh & Ph\u1ee5 ki\u1ec7n",
                    "image": "076384a73c016853370c9f6dd57a1145",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109020,
                    "display_name": "L\u1ed1p & Ph\u1ee5 ki\u1ec7n",
                    "image": "96327573022a271224fc6472cdcc0240",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109021,
                    "display_name": "H\u1ec7 th\u1ed1ng gi\u1ea3m x\u00f3c",
                    "image": "f2a30dbbd57d4b801334d69eb8d37d43",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109022,
                    "display_name": "B\u1ed9 t\u1ea3n nhi\u1ec7t, L\u00e0m m\u00e1t \u0111\u1ed9ng c\u01a1 & Ki\u1ec3m so\u00e1t kh\u00ed",
                    "image": "3f0bdc8e279cc6663a9646568b3cf73f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109023,
                    "display_name": "H\u1ec7 th\u1ed1ng truy\u1ec1n \u0111\u1ed9ng, H\u1ed9p s\u1ed1 & b\u1ed9 ly h\u1ee3p",
                    "image": "95d4f25d6d2395a082d26cf12ec94c77",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109024,
                    "display_name": "V\u00f2ng bi & \u0111\u00e1nh d\u1ea5u",
                    "image": "e2791eb87ace39e9f2d46221afd04d0a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109025,
                    "display_name": "B\u1ed9 ph\u1eadn \u0111\u1ed9ng c\u01a1",
                    "image": "3ba28f0d58440140e25b32b88f0c92d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109026,
                    "display_name": "H\u1ec7 th\u1ed1ng phanh",
                    "image": "50dbc967ed868ece44d451190576a30b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109027,
                    "display_name": "D\u00e2y curoa, \u1ed1ng v\u00e0 r\u00f2ng r\u1ecdc",
                    "image": "c1473a26afa47ef13ae95b736e9bf070",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109028,
                    "display_name": "Thi\u1ebft b\u1ecb \u0111i\u1ec7n t\u1eed",
                    "image": "1eadd45b9dd81642139d466f1de9e9f8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109029,
                    "display_name": "H\u1ec7 th\u1ed1ng nhi\u00ean li\u1ec7u",
                    "image": "bc070c43af52be7cccb05252a5b60fc7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11109030,
                    "display_name": "Kh\u00e1c",
                    "image": "25320d62f545870f11a5017e10a1852d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11116267,
                "display_name": "D\u1ecbch v\u1ee5 cho xe",
                "name": "Automotive Services",
                "image": "5e8ca0f5dbd054427f0ac870c2d31c58",
                "is_adult": null,
                "parent_category": 11036793,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116268,
                    "display_name": "D\u1ecbch v\u1ee5 thay d\u1ea7u nh\u1edbt xe",
                    "image": "4fcb2d94ebdc8160afa54e8409b7bc0a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116269,
                    "display_name": "Thay v\u00e0 b\u1ea3o d\u01b0\u1ee1ng v\u00e0nh l\u1ed1p",
                    "image": "2ff5812f9ce482f233869589f32c9164",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116270,
                    "display_name": "R\u1eeda v\u00e0 ch\u0103m s\u00f3c xe",
                    "image": "aa8b8640536489837f26d00a5206c9e9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116271,
                    "display_name": "D\u1ecbch v\u1ee5 n\u00e2ng c\u1ea5p xe",
                    "image": "1b7ce545ab7ec333c6e745bb6addac75",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116272,
                    "display_name": "B\u1ea3o d\u01b0\u1ee1ng v\u00e0 s\u1eeda xe",
                    "image": "83625dd0eab8e79d37870c58d336621f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116274,
                    "display_name": "D\u1ecbch v\u1ee5 d\u00e1n decal v\u00e0 phim xe",
                    "image": "fee49cd7117190e0d29f9e48b86490d9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116275,
                    "display_name": "Kh\u00e1c",
                    "image": "2657e3d55b9825dd922eff9eca950f43",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036863,
                "display_name": "Nh\u00e0 S\u00e1ch Online",
                "name": "Books & Stationery",
                "image": "36013311815c55d303b0e6c62d6a8139",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 384,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11036914,
                "display_name": "Qu\u00e0 L\u01b0u Ni\u1ec7m",
                "name": "Souvenirs",
                "image": "c5ee94357c6ea45b0265a9fe677a9a23",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 329,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036915,
                    "display_name": "Qu\u1ea1t C\u1ea7m Tay",
                    "image": "1f8283bfba99523252e1b22b2f1362b4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036916,
                    "display_name": "M\u00f3c Kho\u00e1",
                    "image": "f7175c8223d45b8dfbfe8818526972c9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036917,
                    "display_name": "\u1ed0ng ti\u1ebft ki\u1ec7m",
                    "image": "329dc3f8808f62a2ba9ef409ca61a3e4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036918,
                    "display_name": "Nam Ch\u00e2m",
                    "image": "c3d98d15490cfc49176976b2c11d2255",
                    "block_buyer_platform": null
                }, {"catid": 11036919, "display_name": "Kh\u00e1c", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11036929,
                "display_name": "Album \u1ea2nh",
                "name": "Photo Albums",
                "image": "",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11108503,
                "display_name": "S\u00e1ch Ti\u1ebfng Vi\u1ec7t",
                "name": "Domestic Books",
                "image": "b0ea7a5428f74709c5e48113bdee7a45",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108504,
                    "display_name": "T\u1ea1p Ch\u00ed & B\u00e1o Gi\u1ea5y",
                    "image": "3ae68bd3b4b95797613cc87794defc7b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108505,
                    "display_name": "Truy\u1ec7n Tranh",
                    "image": "4bb34295cc015d2355ca1850e555173b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108506,
                    "display_name": "S\u00e1ch Thi\u1ebfu Nhi",
                    "image": "f63070cc79436ffe4032375f03f4f973",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108507,
                    "display_name": "S\u00e1ch N\u00f4ng - L\u00e2m - Ng\u01b0 Nghi\u1ec7p",
                    "image": "e98542b0f53667bdfab8b401bcd2ddb9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108508,
                    "display_name": "S\u00e1ch Ng\u01b0\u1eddi L\u1edbn",
                    "image": "174a72012f03ab21387c4fe029b97fea",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108509,
                    "display_name": "S\u00e1ch Ngh\u1ec7 thu\u1eadt, Thi\u1ebft k\u1ebf & Nhi\u1ebfp \u1ea3nh",
                    "image": "fb09225d7dee037a63c415cb36624903",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108510,
                    "display_name": "S\u00e1ch D\u1ea1y N\u1ea5u \u0102n",
                    "image": "75362aee658c18f6134981cabab7987b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108511,
                    "display_name": "S\u00e1ch Kinh T\u1ebf - Kinh Doanh",
                    "image": "f52912f6e88fadc2cb16b3bb0bf66509",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108512,
                    "display_name": "Sa\u0301ch Chi\u0301nh Tri\u0323 - Pha\u0301p Ly\u0301 & Khoa H\u1ecdc",
                    "image": "7500c733e001f75bc785fe8c7544eecd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108513,
                    "display_name": "S\u00e1ch C\u00f4ng Ngh\u1ec7 Th\u00f4ng Tin",
                    "image": "ec463302f20dd08069e524ec19a53311",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108514,
                    "display_name": "S\u00e1ch S\u1ee9c Kh\u1ecfe, R\u00e8n Luy\u1ec7n & \u0102n Ki\u00eang",
                    "image": "87e1abcc3f8471dfce3d23e6b59ead70",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108515,
                    "display_name": "S\u00e1ch Du L\u1ecbch - Du K\u00fd",
                    "image": "7bb713deced21f9603284265d9f1737c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108516,
                    "display_name": "S\u00e1ch H\u1ecdc Ngo\u1ea1i Ng\u1eef & T\u1eeb \u0110i\u1ec3n",
                    "image": "2d772d9d3b4151aaaba04107058d1fbd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108517,
                    "display_name": "S\u00e1ch S\u1edf Th\u00edch C\u00e1 Nh\u00e2n",
                    "image": "a5595e3bbf66de5837e95145a7dae919",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108518,
                    "display_name": "V\u0103n H\u1ecdc LGBTQ+",
                    "image": "d44d3f4139df0422bcfecc21de8f386d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108519,
                    "display_name": "Ti\u1ec3u thuy\u1ebft ng\u1eafn",
                    "image": "da0a589c55bc66a7e8c57614196e6a5a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108520,
                    "display_name": "V\u0103n H\u1ecdc Kinh \u0110i\u1ec3n",
                    "image": "f38393b3e2262ab92530f3c9b87cb56f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108521,
                    "display_name": "V\u0103n H\u1ecdc Gi\u1ea3 T\u01b0\u1edfng",
                    "image": "1b3a636f10a7216d61cea5df54787bf2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108522,
                    "display_name": "V\u0103n H\u1ecdc H\u00e0nh \u0110\u1ed9ng, T\u1ed9i Ph\u1ea1m & Kinh D\u1ecb",
                    "image": "7ff7d377f2210eff14ba5d612a9a68f7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108523,
                    "display_name": "V\u0103n H\u1ecdc L\u00e3ng M\u1ea1n",
                    "image": "bff09aa6a9394d863fd023505006cf5b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108524,
                    "display_name": "Ti\u1ec3u S\u1eed - H\u1ed3i K\u00fd",
                    "image": "c6f127131cad8eda1cb6cf19e7bf01f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108525,
                    "display_name": "Khoa H\u1ecdc - To\u00e1n H\u1ecdc",
                    "image": "4b79c2d6c9c5e38480f5568a9924240d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108526,
                    "display_name": "S\u00e1ch Y H\u1ecdc",
                    "image": "d67569315ce5ea1f101489eee88e8dee",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108527,
                    "display_name": "S\u00e1ch Gia \u0110\u00ecnh",
                    "image": "868da3250ff31a92d597be765ad1cfe9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108528,
                    "display_name": "S\u00e1ch T\u00e2m L\u00fd H\u1ecdc",
                    "image": "5a4c6ad1fdcf77c6c942c2bc4bba8415",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108529,
                    "display_name": "S\u00e1ch T\u00f4n gi\u00e1o & Tri\u1ebft h\u1ecdc",
                    "image": "4be480f4bfbfe097e707563c4412d734",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108530,
                    "display_name": "S\u00e1ch L\u1ecbch S\u1eed - V\u0103n Ho\u00e1",
                    "image": "ae45cf0828e5741e94d693ff6a46c56f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108531,
                    "display_name": "S\u00e1ch H\u01b0\u1edbng Nghi\u1ec7p & Ph\u00e1t Tri\u1ec3n B\u1ea3n Th\u00e2n",
                    "image": "dcfa10b97f0e7589d51cd97e2c4b4414",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108532,
                    "display_name": "S\u00e1ch Chi\u00eam Tinh",
                    "image": "90cd535ec5ffa96a719e845c98667c1a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108533,
                    "display_name": "S\u00e1ch Gi\u00e1o D\u1ee5c",
                    "image": "a6f6486a994ed1c7247377d58d2953c1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108534,
                    "display_name": "S\u00e1ch H\u00ecnh D\u00e1n & T\u00f4 M\u00e0u",
                    "image": "b90ab42a38dc3e1d3a3d5a28445d8ced",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108535,
                    "display_name": "S\u00e1ch \u00c2m Nh\u1ea1c",
                    "image": "a50b215396d84090534c3fd560d9a4f8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108537,
                    "display_name": "S\u00e1ch N\u00f3i",
                    "image": "e09bdf2a96f5231033e33b2e12197962",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108538,
                    "display_name": "E-Books",
                    "image": "32e44ee10dc00a5ef57266b855a7a18c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108539,
                    "display_name": "Kh\u00e1c",
                    "image": "9fbb2d67e78e0267f128a81f1f2a7d4b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108540,
                "display_name": "S\u00e1ch ngo\u1ea1i v\u0103n",
                "name": "Foreign Books",
                "image": "f3e8e17e794370f4568b51ea64a453f9",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108541,
                    "display_name": "T\u1ea1p Ch\u00ed & B\u00e1o Gi\u1ea5y",
                    "image": "77dcb77f8689846d06b4aea63de4d71b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108542,
                    "display_name": "Truy\u1ec7n Tranh",
                    "image": "e038f767d6b4b262821bdafbf14c74c7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108543,
                    "display_name": "S\u00e1ch Thi\u1ebfu Nhi",
                    "image": "ec6e91fea873f0278578be86d4f6c8ab",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108544,
                    "display_name": "S\u00e1ch N\u00f4ng - L\u00e2m - Ng\u01b0 Nghi\u1ec7p",
                    "image": "4516737d7ab918a6c933e9a31f064a17",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108545,
                    "display_name": "S\u00e1ch Ng\u01b0\u1eddi L\u1edbn",
                    "image": "2536af569fa7d2d701ace3b61eb7524d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108546,
                    "display_name": "S\u00e1ch Ngh\u1ec7 thu\u1eadt, Thi\u1ebft k\u1ebf & Nhi\u1ebfp \u1ea3nh",
                    "image": "08434a6f349209c8d1e75aaafd2740e9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108547,
                    "display_name": "S\u00e1ch D\u1ea1y N\u1ea5u \u0102n",
                    "image": "e0852c40d3c2a3d1303886639687b1ed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108548,
                    "display_name": "S\u00e1ch Kinh T\u1ebf - Kinh Doanh",
                    "image": "db78a64233d0ba7c312133d619ba2a33",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108549,
                    "display_name": "Sa\u0301ch Chi\u0301nh Tri\u0323 - Pha\u0301p Ly\u0301 & Khoa H\u1ecdc",
                    "image": "b449e7a27c81d43ed26d51c31c5de039",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108550,
                    "display_name": "S\u00e1ch C\u00f4ng Ngh\u1ec7 Th\u00f4ng Tin",
                    "image": "e63d954f4223392519c9de14c0b0812c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108551,
                    "display_name": "S\u00e1ch S\u1ee9c Kh\u1ecfe, R\u00e8n Luy\u1ec7n & \u0102n Ki\u00eang",
                    "image": "8aabc3f87dc9474a9e427fbc08db7f36",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108552,
                    "display_name": "S\u00e1ch Du L\u1ecbch - Du K\u00fd",
                    "image": "947f83c0f5571bdb70c35116ebc17247",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108553,
                    "display_name": "S\u00e1ch H\u1ecdc Ngo\u1ea1i Ng\u1eef & T\u1eeb \u0110i\u1ec3n",
                    "image": "348823702368194a7bd6bf07ae87043d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108554,
                    "display_name": "S\u00e1ch S\u1edf Th\u00edch C\u00e1 Nh\u00e2n",
                    "image": "e1d2811867c2358d1994d5ceb73de2c2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108555,
                    "display_name": "V\u0103n H\u1ecdc LGBTQ+",
                    "image": "70a2bf4e65577f94b5f0e3908583899c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108556,
                    "display_name": "Ti\u1ec3u thuy\u1ebft ng\u1eafn",
                    "image": "f285f33dc29ddd0255735d29066bb2e8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108557,
                    "display_name": "V\u0103n H\u1ecdc Kinh \u0110i\u1ec3n",
                    "image": "44e159390e24c5aab910ed1f0b2775e9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108558,
                    "display_name": "V\u0103n H\u1ecdc Gi\u1ea3 T\u01b0\u1edfng",
                    "image": "77fb7244747ad0d8dbfe647730fed92f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108559,
                    "display_name": "V\u0103n H\u1ecdc H\u00e0nh \u0110\u1ed9ng, T\u1ed9i Ph\u1ea1m & Kinh D\u1ecb",
                    "image": "e283fee86f1c1eea63329b6559b8de37",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108560,
                    "display_name": "V\u0103n H\u1ecdc L\u00e3ng M\u1ea1n",
                    "image": "b6936ddf423602fc3890a5b925b3d9f5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108561,
                    "display_name": "Ti\u1ec3u S\u1eed - H\u1ed3i K\u00fd",
                    "image": "c2f6980dcd92316bd509fb950e8f19fd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108562,
                    "display_name": "Khoa H\u1ecdc - To\u00e1n H\u1ecdc",
                    "image": "1946e79c3bd9f5d69c9e7f92cf6b965b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108563,
                    "display_name": "S\u00e1ch Y H\u1ecdc",
                    "image": "e4852b1f2ddccfa6604cc5fdaaf2e70b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108564,
                    "display_name": "S\u00e1ch Gia \u0110\u00ecnh",
                    "image": "fedfddb57a953564ab577140a485cc3a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108565,
                    "display_name": "S\u00e1ch T\u00e2m L\u00fd H\u1ecdc",
                    "image": "e2a4e8e622987d47810fbcbc87fd99b2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108566,
                    "display_name": "S\u00e1ch T\u00f4n gi\u00e1o & Tri\u1ebft h\u1ecdc",
                    "image": "b2e05921499300a69f441549a1edd819",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108567,
                    "display_name": "S\u00e1ch L\u1ecbch S\u1eed - V\u0103n Ho\u00e1",
                    "image": "a05619946e802596a229fecc33de2e66",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108568,
                    "display_name": "S\u00e1ch H\u01b0\u1edbng Nghi\u1ec7p & Ph\u00e1t Tri\u1ec3n B\u1ea3n Th\u00e2n",
                    "image": "56c2cb9e62003a284ef2e0632df4aae7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108569,
                    "display_name": "S\u00e1ch Chi\u00eam Tinh",
                    "image": "e77a3c156389ddb5c8099d702af76a0c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108570,
                    "display_name": "S\u00e1ch Gi\u00e1o D\u1ee5c",
                    "image": "448c7a595805c73b296b175b7dd4cc4b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108571,
                    "display_name": "S\u00e1ch H\u00ecnh D\u00e1n & T\u00f4 M\u00e0u",
                    "image": "537bc19194d782660b2b68b4f2933496",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108572,
                    "display_name": "S\u00e1ch \u00c2m Nh\u1ea1c",
                    "image": "2a35ebb61be56c8fcd09b85adc82a976",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108574,
                    "display_name": "S\u00e1ch N\u00f3i",
                    "image": "43db8dcca6825560b5f28a05a0cfa1f7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108575,
                    "display_name": "Kh\u00e1c",
                    "image": "8c9bd41a076195710f374f8220e7011a",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108576,
                "display_name": "G\u00f3i Qu\u00e0",
                "name": "Gift & Wrapping",
                "image": "db02d43c3a725b52836bdd505b6728b6",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108577,
                    "display_name": "Gi\u1ea5y G\u00f3i Qu\u00e0",
                    "image": "14eff76f7579d908fbe7bc928f06512a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108578,
                    "display_name": "H\u1ed9p Qu\u00e0",
                    "image": "38f9176f11047f5e13509cedbceda0bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108579,
                    "display_name": "T\u00fai Gi\u1ea5y",
                    "image": "8c3e18386973d53696fa425835e7a8b1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108580,
                    "display_name": "Ruy b\u0103ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108581,
                    "display_name": "Gi\u1ea5y Bong B\u00f3ng",
                    "image": "f2cff871ede38dacd847cbc3ba0856d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108582,
                    "display_name": "Th\u00f9ng Gi\u1ea5y",
                    "image": "3e788262dcac3b511426bd031377820b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108583,
                    "display_name": "Kh\u00e1c",
                    "image": "82015af59ec651b401f7f893bc6bf01b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108584,
                "display_name": "B\u00fat vi\u1ebft",
                "name": "Writing & Correction",
                "image": "0bdecfec51ab4144ac63374fb713414c",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108585,
                    "display_name": "Vi\u1ebft M\u00e1y & M\u1ef1c",
                    "image": "33b84687ce0b5913e24ba539decc104a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108586,
                    "display_name": "Vi\u1ebft Ch\u00ec",
                    "image": "75d7d0477d420ce6b315aa02ff5e00ea",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108587,
                    "display_name": "G\u00f4m, T\u1ea9y",
                    "image": "ecc88a2b3663e57bdfe0a151c90316d7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108588,
                    "display_name": "B\u00fat Maker",
                    "image": "ee5f60adbc81bd7069d41c2f49206d73",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108589,
                    "display_name": "Vi\u1ebft Ghi Ch\u00fa",
                    "image": "9c6fa004ffe8a051b31b5f5dd2f57836",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108590,
                    "display_name": "Kh\u00e1c",
                    "image": "e40245dadd59e1c88df9aa430c2c3d41",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108591,
                "display_name": "D\u1ee5ng c\u1ee5 h\u1ecdc sinh & v\u0103n ph\u00f2ng",
                "name": "School & Office Supplies",
                "image": "c19c80020e80f0793c75caf75c3070f1",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108592,
                    "display_name": "B\u1ea3ng Vi\u1ebft",
                    "image": "88896df66f91144adf5c04ca00f0e6ac",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108593,
                    "display_name": "M\u00e1y T\u00ednh",
                    "image": "c1d584c22f34e926b3f24d0cd6762bff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108594,
                    "display_name": "B\u00fat c\u1eaft gi\u1ea5y",
                    "image": "fc5411ccd0f5a3d5db8c7ad8a3ac3bf3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108595,
                    "display_name": "D\u00e2y & B\u0103ng Keo",
                    "image": "fbb91408ce15a796df84a3c9a9385dfd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108596,
                    "display_name": "Keo D\u00e1n",
                    "image": "5561b049dd77302c444d4ff17e4125da",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108597,
                    "display_name": "Gi\u1ea5y In Nh\u00e3n",
                    "image": "aace386c487d37a8d7108afc5e652a21",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108598,
                    "display_name": "B\u1ea3ng T\u00ean",
                    "image": "5088001876322fb574be4eddb52da84c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108599,
                    "display_name": "K\u1eb9p, Ghim B\u1ea5m C\u00e1c Lo\u1ea1i",
                    "image": "8be3742115f55afe6df614bbdd9f093b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108600,
                    "display_name": "M\u00e1y \u0110\u1ee5c L\u1ed7",
                    "image": "178d7c84f766d5539a965d3a2e6cc5a9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108601,
                    "display_name": "K\u00e9o",
                    "image": "4a01c25b7a1c8f6067b42607c83109b3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108602,
                    "display_name": "Stamp & M\u1ef1c",
                    "image": "59a6139783fe1c710c955c62af1e9877",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108603,
                    "display_name": "M\u00e1y B\u1ea5m",
                    "image": "2fda2b6b25a44675788658f40ed2a5c4",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108604,
                    "display_name": "L\u1ecbch C\u00e1c Lo\u1ea1i",
                    "image": "266b9bcbeae9ae7be6848b9f95f9c1a9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108605,
                    "display_name": "B\u00eca C\u00f2ng, B\u00eca L\u01b0u Tr\u1eef V\u00e0 Ph\u1ee5 Ki\u1ec7n",
                    "image": "e20e0a28dc45ca038fd76915a12fb8fd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108606,
                    "display_name": "Th\u01b0\u1edbc K\u1ebb, Th\u01b0\u1edbc \u0110o G\u00f3c & Gi\u1ea5y N\u1ebfn",
                    "image": "f003e8d0c9641bf1d72144bd4e4dad6a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108607,
                    "display_name": "\u0110\u1ed3 Chu\u1ed1t B\u00fat Ch\u00ec",
                    "image": "bdea5b3ab5aff40db1d2bc23c9d6f1c6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108608,
                    "display_name": "H\u1ed9p, T\u00fai \u0110\u1ef1ng B\u00fat",
                    "image": "cd35e4c20c7920c69f3c52dd45c0188f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108609,
                    "display_name": "Kh\u00e1c",
                    "image": "08671d4cc7f1470f9c72ed435f93b84f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108610,
                "display_name": "S\u1ed5 v\u00e0 Gi\u1ea5y C\u00e1c Lo\u1ea1i",
                "name": "Notebooks & Paper Products",
                "image": "59a370de55b043c24935acd9a14f869f",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108613,
                    "display_name": "Gi\u1ea5y In Nhi\u1ec7t & Gi\u1ea5y In Li\u00ean T\u1ee5c",
                    "image": "28ed9caf0a03f84ec0283c497948a115",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108611,
                    "display_name": "Bookmarks",
                    "image": "53ebd53a705c023b46fc10a2e4b202d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108612,
                    "display_name": "B\u00eca S\u00e1ch",
                    "image": "a6efe2742f82e7025e8a7b592518effb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108614,
                    "display_name": "Gi\u1ea5y In",
                    "image": "cb582a5d8056d3b439d797a8083c6267",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108615,
                    "display_name": "B\u00eca, Gi\u1ea5y \u0110\u1ee5t L\u1ed7",
                    "image": "059bd5564402928b0e8e657a60b73b00",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108616,
                    "display_name": "Gi\u1ea5y Note",
                    "image": "314058403fd5d0bed950fe0b68742457",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108617,
                    "display_name": "B\u00eca M\u00e0u",
                    "image": "27aa5d9e26979c385c9a4649f931e9ac",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108618,
                    "display_name": "S\u1ed5 Tay",
                    "image": "645fb8fbae1f2ce6a2944d4b44eefbe1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108619,
                    "display_name": "Nh\u00e3n",
                    "image": "b9071ac3f6554d42abd70a11340ef549",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108620,
                    "display_name": "Kh\u00e1c",
                    "image": "49b5f345cd8ead67927ce504e960b135",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108621,
                    "display_name": "B\u00eca Th\u01b0, Phong B\u00ec",
                    "image": "67c1f7c7d8eefed0ce4041b16f1abfe7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108622,
                    "display_name": "Post Cards",
                    "image": "f161ea6592c7c49bcafdaf68c0ac8684",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108623,
                    "display_name": "Tem",
                    "image": "69e5d7a34c994958e66a7fc69ed055f0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108624,
                "display_name": "Nh\u1ea1c c\u1ee5 v\u00e0 ph\u1ee5 ki\u1ec7n \u00e2m nh\u1ea1c",
                "name": "Music & Media",
                "image": "617101b45ca1034af2d35438c7fd375f",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108626,
                    "display_name": "\u0110\u00e0n Organ & Piano",
                    "image": "e71789f0703518a8c1d91954696327ff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108627,
                    "display_name": "Tr\u1ed1ng & B\u1ed9 G\u00f5",
                    "image": "ca0494ee667ef8b11e8a65057dad173e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108628,
                    "display_name": "Nh\u1ea1c C\u1ee5 Th\u1ed5i",
                    "image": "0d7011d96234f74dd23c42179106a11d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108629,
                    "display_name": "Ukuleles",
                    "image": "b68121c3cce913308d0651dc68fc8c9c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108630,
                    "display_name": "Guitars",
                    "image": "a47284eec276a182eae19f1738c023b0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108631,
                    "display_name": "Nh\u1ea1c C\u1ee5 Kh\u00e1c",
                    "image": "de91c34eba1b2a88af1e8a86d8233f19",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108632,
                    "display_name": "Ph\u1ee5 Ki\u1ec7n Ch\u01a1i Nh\u1ea1c",
                    "image": "33b56e5c5c880f3609982cd2dae14f7c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108633,
                    "display_name": "Nh\u1ea1c C\u1ee5 V\u00e0 Ph\u1ee5 Ki\u1ec7n \u00c2m Nh\u1ea1c Kh\u00e1c",
                    "image": "21ccad9dcbcfabb26124daeb340f8d0e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108634,
                    "display_name": "\u0110\u0129a Than",
                    "image": "757b9168de49fc2b8bb76450c356a564",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11108635,
                "display_name": "M\u00e0u, H\u1ecda C\u1ee5 v\u00e0 \u0110\u1ed3 Th\u1ee7 C\u00f4ng",
                "name": "Coloring & Arts",
                "image": "40a22299069292d956ff926227c08f19",
                "is_adult": null,
                "parent_category": 11036863,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11108636,
                    "display_name": "B\u00fat Ch\u00ec M\u00e0u",
                    "image": "9a5a6d6ce4acc0317db562e04ad1d90d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108637,
                    "display_name": "M\u00e0u S\u00e1p",
                    "image": "178159fe811d6c795a9357c6d6f495da",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108638,
                    "display_name": "M\u00e0u N\u01b0\u1edbc",
                    "image": "e04e3816e102ba23743373600297087f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108639,
                    "display_name": "M\u00e0u S\u01a1n D\u1ea7u",
                    "image": "17e5b3e3de5503ea8cf12e9f7d16df63",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108640,
                    "display_name": "M\u00e0u Acrylic",
                    "image": "d0e0568ce430a9ccfe7bde3def40ad06",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108641,
                    "display_name": "C\u1ecd V\u1ebd",
                    "image": "64e1b4287c2642494e8923da05fdaa24",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108642,
                    "display_name": "Khay \u0110\u1ef1ng M\u00e0u V\u1ebd",
                    "image": "49a2aafb5d0ada6d75dc4be6e120d355",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108643,
                    "display_name": "Gi\u00e1 V\u1ebd",
                    "image": "dce0b036ace692a6f6ffa041830c20f8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108644,
                    "display_name": "Gi\u1ea5y Ph\u00e1c Th\u1ea3o",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108645,
                    "display_name": "Kh\u00e1c",
                    "image": "de039f217669be8b08bfd824f0bec6d2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11108646,
                    "display_name": "May v\u00e1",
                    "image": "3f34b124186759ebf9a1aea42ba2ede9",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11035741,
                "display_name": "Balo & T\u00fai V\u00ed Nam",
                "name": "Men Bags",
                "image": "18fd9d878ad946db2f1bf4e33760c86f",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 315,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035742,
                "display_name": "Ba L\u00f4 Nam",
                "name": "Backpacks",
                "image": "3261974daea361895df269cf1b2452f1",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 314,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035743,
                "display_name": "Ba L\u00f4 Laptop Nam",
                "name": "Laptop Backpacks",
                "image": "3a35b90c32c620272807ad2602c15121",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 313,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035744,
                "display_name": "T\u00fai & C\u1eb7p \u0110\u1ef1ng Laptop",
                "name": "Laptop Bags & Cases",
                "image": "6c8273f9f37908ad8c8337bfac89617b",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 312,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035745,
                    "display_name": "T\u00fai & C\u1eb7p \u0110\u1ef1ng Laptop",
                    "image": "7fdbe7896369f3eb7bf4dbfbcf488bf6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035746,
                    "display_name": "Kh\u00e1c",
                    "image": "13d2c32abd7f9d8079002ffe2a4914f1",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035747,
                "display_name": "T\u00fai Ch\u1ed1ng S\u1ed1c Laptop Nam",
                "name": "Laptop Sleeves",
                "image": "2275e885d6f4501ce334737d3b96c195",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 309,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035748,
                "display_name": "T\u00fai Tote Nam",
                "name": "Tote Bags",
                "image": "8a1fcca022943a163ffe97ba7bca6e6a",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 308,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035749,
                "display_name": "C\u1eb7p X\u00e1ch C\u00f4ng S\u1edf Nam",
                "name": "Briefcases",
                "image": "3221d74f077d0a09d046ebaf57d1ef7f",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 307,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035750,
                "display_name": "V\u00ed C\u1ea7m Tay Nam",
                "name": "Clutches",
                "image": "0f3375a7ddf10d0b71f2557436213bce",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 306,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035751,
                "display_name": "T\u00fai \u0110eo H\u00f4ng & T\u00fai \u0110eo Ng\u1ef1c Nam",
                "name": "Waist Bags & Chest Bags",
                "image": "399ff8955ab366d2c088c5ac61ea3787",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 305,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035752,
                "display_name": "T\u00fai \u0110eo Ch\u00e9o Nam",
                "name": "Crossbody & Shoulder Bags",
                "image": "b2e96cc090445b775dd147a4b0cc6784",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 304,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035753,
                "display_name": "B\u00f3p/V\u00ed Nam",
                "name": "Wallets",
                "image": "4b3a105fad22ca3d9a868312b34fbaf1",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 303,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035754,
                    "display_name": "V\u00ed \u0111\u1ef1ng th\u1ebb",
                    "image": "7eef1ebf36c764cb1ebddfdf92ffa28e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035755,
                    "display_name": "V\u00ed \u0111\u1ef1ng ti\u1ec1n xu",
                    "image": "e758cada3ed56453a9fbb91d4ef91966",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035756,
                    "display_name": "V\u00ed \u0111\u1ef1ng \u0111i\u1ec7n tho\u1ea1i & ch\u00eca kh\u00f3a",
                    "image": "c425966b4337d9dc7ccd5c34f2afa5a5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035757,
                    "display_name": "V\u00ed g\u1eadp \u0111\u00f4i & g\u1eadp ba",
                    "image": "f6c4262172315a90be995f326b42d5be",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035758,
                    "display_name": "V\u00ed d\u00e0i",
                    "image": "a94f16db8e2bce3f29c46032e867219e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035759,
                    "display_name": "V\u00ed kh\u00e1c",
                    "image": "1d98b4274c5af0b1087002d611f53111",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035760,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "35eaa9bee2302fafe81d96178b14100a",
                "is_adult": null,
                "parent_category": 11035741,
                "sort_weight": 296,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11036382,
                "display_name": "Th\u1eddi Trang Tr\u1ebb Em",
                "name": "Kid Fashion",
                "image": "4540f87aa3cbe99db739f9e8dd2cdaf0",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 295,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036418,
                "display_name": "Trang ph\u1ee5c b\u00e9 trai",
                "name": "Boy Clothes",
                "image": "442309de4f1bdc2dea649cc7d7f2922c",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 294,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036419,
                    "display_name": "\u0110\u1ed3 h\u00f3a trang",
                    "image": "97c52c8bd881a8dece3aef2762f50ca0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036420,
                    "display_name": "\u0110\u1ed3 l\u00f3t",
                    "image": "8e8f93fb8c416e5881bb4915bcaefb73",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036421,
                    "display_name": "\u0110\u1ed3 ng\u1ee7",
                    "image": "a01df4dde6383a148e79aac08f458c05",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036422,
                    "display_name": "\u0110\u1ed3 b\u01a1i",
                    "image": "988a0f9f79ea84e1ad992059aafc758b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036423,
                    "display_name": "\u00c1o ph\u00f4ng",
                    "image": "bce0c321645460e2c0bb6a09b7b9255c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036424,
                    "display_name": "\u00c1o polo",
                    "image": "d3c675279420e95af98152538c4b66ba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036425,
                    "display_name": "\u00c1o s\u01a1 mi",
                    "image": "5fc194012a227ae2ae15ef51cb039144",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036426,
                    "display_name": "\u00c1o kho\u00e1c",
                    "image": "85d47b23370b5b02813e2ea6b97b5a8c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036427,
                    "display_name": "\u00c1o kho\u00e1c m\u00f9a \u0111\u00f4ng",
                    "image": "f945f8503ca296a02084341f566db1bb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036428,
                    "display_name": "Vest",
                    "image": "73ce3fdda500143e40f54c45835c502c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036429,
                    "display_name": "\u00c1o len chui \u0111\u1ea7u & \u00e1o len m\u1ecfng",
                    "image": "75a78ccce5e5c7f38f93c775e893813e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036430,
                    "display_name": "\u00c1o vest/blazer",
                    "image": "f9cc8bd4cd806869b8ae4338d42d3568",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036431,
                    "display_name": "\u00c1o n\u1ec9 c\u00f3 m\u0169",
                    "image": "be4634f12ea091a5f2a233f96cbb8a95",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036432,
                    "display_name": "Qu\u1ea7n b\u00f2",
                    "image": "0dce5472a82ba225411a7c38b88f129e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036433,
                    "display_name": "Qu\u1ea7n",
                    "image": "79c07d864e953822fa9eed247ffb20c0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036434,
                    "display_name": "Qu\u1ea7n \u0111\u00f9i",
                    "image": "e963d8aa50ddd001770f78c4e36517a2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036435,
                    "display_name": "Qu\u1ea7n y\u1ebfm",
                    "image": "d4829f667393e7de00984510ceeda076",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036436,
                    "display_name": "B\u1ed9 qu\u1ea7n \u00e1o",
                    "image": "ac053de807d51ab6872eae48759c917c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036437,
                    "display_name": "Kh\u00e1c",
                    "image": "dc454f4d99f0e37bfe4bf62db38ebea0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036438,
                "display_name": "Trang ph\u1ee5c b\u00e9 g\u00e1i",
                "name": "Girl Clothes",
                "image": "86c84665e3f77fe41aa65782202d1804",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 274,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036439,
                    "display_name": "\u0110\u1ed3 h\u00f3a trang",
                    "image": "0e72c8f18d2cb6291d7520b57546bab3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036440,
                    "display_name": "\u0110\u1ed3 l\u00f3t",
                    "image": "3b729f7dd9a20bb557d780389529e6ff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036441,
                    "display_name": "\u0110\u1ed3 ng\u1ee7",
                    "image": "f0f35a4d59fe9b4cf77b69ed9106e12e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036442,
                    "display_name": "\u0110\u1ed3 b\u01a1i",
                    "image": "20f18bad8bf03b2a997285ac936a3a39",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036443,
                    "display_name": "\u00c1o ph\u00f4ng",
                    "image": "855d96a10e79ceeb77bf79e217f4aec6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036444,
                    "display_name": "\u00c1o polo",
                    "image": "73c6652139b31bb50c9d6d07fd1a9138",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036445,
                    "display_name": "\u00c1o s\u01a1 mi",
                    "image": "09768d10c6c86ce5d08e61cb8504e7cf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036446,
                    "display_name": "\u00c1o kho\u00e1c nh\u1eb9",
                    "image": "325810d06e5017e7e0561c07297c174a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036447,
                    "display_name": "\u00c1o kho\u00e1c m\u00f9a \u0111\u00f4ng",
                    "image": "f945f8503ca296a02084341f566db1bb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036448,
                    "display_name": "Vest",
                    "image": "e003469c63f98f863bc1deee14e05c67",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036449,
                    "display_name": "\u00c1o len chui \u0111\u1ea7u & \u00e1o len m\u1ecfng",
                    "image": "d4e4d7d3f5c5030a11b5b8a284d1363a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036450,
                    "display_name": "\u00c1o blazer",
                    "image": "f9cc8bd4cd806869b8ae4338d42d3568",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036451,
                    "display_name": "\u00c1o n\u1ec9 c\u00f3 m\u0169",
                    "image": "be4634f12ea091a5f2a233f96cbb8a95",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036452,
                    "display_name": "Qu\u1ea7n b\u00f2",
                    "image": "f6e55dd5b88da95476c8602f7eb65152",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036453,
                    "display_name": "Qu\u1ea7n",
                    "image": "c8558537a9d270032fc8f5a7557afcaf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036454,
                    "display_name": "Qu\u1ea7n \u0111\u00f9i",
                    "image": "7acbaeb5b23051dbd8ae98cde5924e03",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036455,
                    "display_name": "Ch\u00e2n v\u00e1y",
                    "image": "63c389407eda4edcf25b7f53118e3ce3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036456,
                    "display_name": "Qu\u1ea7n b\u00f3",
                    "image": "aad1f74046f2c86076cf87e1c2b0e14d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036457,
                    "display_name": "\u0110\u1ed3 li\u1ec1n th\u00e2n",
                    "image": "35f903bd1832c2533c6107c3bf501b6c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036458,
                    "display_name": "V\u00e1y/\u0110\u1ea7m",
                    "image": "e37dc4ef0d469be2d704a7d46b6e0388",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036459,
                    "display_name": "B\u1ed9 qu\u1ea7n \u00e1o",
                    "image": "c86c9e36cdba861e08f2c664306b246a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036460,
                    "display_name": "Kh\u00e1c",
                    "image": "97c52c8bd881a8dece3aef2762f50ca0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036461,
                "display_name": "Gi\u00e0y d\u00e9p b\u00e9 trai",
                "name": "Boy Shoes",
                "image": "5410fc433223a804e31adfb6a2d761ff",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 251,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036462,
                    "display_name": "B\u1ed1t/\u1ee6ng",
                    "image": "01fc0597866b4952dd282c0cea356bf8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036463,
                    "display_name": "D\u00e9p c\u00f3 quai",
                    "image": "33b4e6b7fb73d04fd3d410dae2d0c445",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036464,
                    "display_name": "Gi\u00e0y th\u1ec3 thao",
                    "image": "70eae9f80855ce26d4adb83989fd45c8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036465,
                    "display_name": "D\u00e9p k\u1eb9p",
                    "image": "aefdb9576df3e7fcae6718e5d3f9efe1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036466,
                    "display_name": "Gi\u00e0y t\u00e2y",
                    "image": "85052b99a02115117aecc5504af85746",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036467,
                    "display_name": "Gi\u00e0y l\u01b0\u1eddi",
                    "image": "c82aa2c1c19c846491bc35da384bdad0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036468,
                    "display_name": "Kh\u00e1c",
                    "image": "9bc1d7157073c750df004d3e5298a333",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036469,
                "display_name": "Gi\u00e0y d\u00e9p b\u00e9 g\u00e1i",
                "name": "Girl Shoes",
                "image": "7fe047df98ce20f2b4baff33798fb7d5",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 243,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036470,
                    "display_name": "B\u1ed1t/\u1ee6ng",
                    "image": "8610881b89b20b02df38967cb5682441",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036471,
                    "display_name": "D\u00e9p c\u00f3 quai",
                    "image": "ef94b5c29481b75d546955575e2d0e59",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036472,
                    "display_name": "Gi\u00e0y th\u1ec3 thao",
                    "image": "f619eec3e9b751ab28cb5086fdaf4038",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036473,
                    "display_name": "Gi\u00e0y l\u01b0\u1eddi",
                    "image": "d32b14c84c0129bb38319d4a0ecd1759",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036474,
                    "display_name": "D\u00e9p k\u1eb9p",
                    "image": "ae529142d7cb9e398fc8f499f3b086dd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036475,
                    "display_name": "Gi\u00e0y b\u00fap b\u00ea",
                    "image": "8ec281e99f63e281bc2b4ea7c342fa7c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036476,
                    "display_name": "Kh\u00e1c",
                    "image": "fd38289106f5a9b3de342d787dd00bac",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036477,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "55b9b2b5bea2b656ce1298f351284195",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 235,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036383,
                "display_name": "Qu\u1ea7n \u00e1o em b\u00e9",
                "name": "Baby Clothes",
                "image": "259a34b30f088356dd393e50cc339c57",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 234,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036384,
                    "display_name": "\u00c1o kho\u00e1c nh\u1eb9",
                    "image": "76880eb562fbcea53eb56151ac5792b6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036385,
                    "display_name": "\u00c1o kho\u00e1c m\u00f9a \u0111\u00f4ng",
                    "image": "39bfb9acbc59f0d01815b4eeda5fe9bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036386,
                    "display_name": "V\u00e1y/\u0111\u1ea7m",
                    "image": "3e80f87dbefb2c771a5686681334471b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036387,
                    "display_name": "Qu\u1ea7n d\u00e0i & legging",
                    "image": "90f2032cdca896e502f9d4d4b27ee738",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036388,
                    "display_name": "Qu\u1ea7n ng\u1eafn",
                    "image": "18c13124ae9e57d1f3a0d2cd0a5ee3cc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036389,
                    "display_name": "Ch\u00e2n v\u00e1y",
                    "image": "5ddd63dfc8796869f8106f4575613b9c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036390,
                    "display_name": "\u0110\u1ed3 ng\u1ee7",
                    "image": "0c8cd376fac8c4f2ea1d91f24ef3607b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036391,
                    "display_name": "\u00c1o",
                    "image": "fca0b729c71fa31100f78d7c5303e984",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036392,
                    "display_name": "\u00c1o li\u1ec1n qu\u1ea7n",
                    "image": "210bff4e2bcf713c207879dedaf8151a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036393,
                    "display_name": "B\u1ed9 qu\u1ea7n \u00e1o",
                    "image": "472c5cdb2b39d8e0a0042b133e1cc432",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036394,
                    "display_name": "\u0110\u1ed3 b\u01a1i",
                    "image": "417fef2116bc20db2b9ae7afc7d08650",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036395,
                    "display_name": "Kh\u00e1c",
                    "image": "39bfb9acbc59f0d01815b4eeda5fe9bc",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036396,
                "display_name": "Gi\u00e0y t\u1eadp \u0111i & T\u1ea5t s\u01a1 sinh",
                "name": "Baby Mittens & Footwear",
                "image": "e5c0d22e5a0703f298e554e3d4a51d22",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 221,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11036397,
                "display_name": "Ph\u1ee5 ki\u1ec7n tr\u1ebb em",
                "name": "Baby & Kids Accessories",
                "image": "252cf0ea0e3713e03aeca4e3e74482f1",
                "is_adult": null,
                "parent_category": 11036382,
                "sort_weight": 220,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036416,
                    "display_name": "B\u1ecbt tai",
                    "image": "be1ee9e704e5af7783a52005a6c5cf1a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036417,
                    "display_name": "Kh\u00e1c",
                    "image": "4f836fabb9152f0438e084650a7d8bd7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036398,
                    "display_name": "Balo",
                    "image": "ce043d917f7d3a6a1d5ee6d0cb611124",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036399,
                    "display_name": "T\u00fai x\u00e1ch/T\u00fai \u0111eo ch\u00e9o",
                    "image": "14d9c9dd225474ef4d915d5a9c11252a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036400,
                    "display_name": "Vali & t\u00fai c\u00f3 b\u00e1nh xe",
                    "image": "22580785fa734143dba7d2ec97a81bd2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036401,
                    "display_name": "V\u00ed",
                    "image": "d97700b8bdd9bbd24329aa0eb8e4e4da",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036402,
                    "display_name": "M\u0169",
                    "image": "1e7e8ab11435541d3e9386066b5afa1c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036403,
                    "display_name": "K\u00ednh m\u1eaft",
                    "image": "c3029976611d6f4425b80756ac4dad21",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036404,
                    "display_name": "Ph\u1ee5 ki\u1ec7n t\u00f3c",
                    "image": "8d2498e4dd4af36efc6d33fe56c2727c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036405,
                    "display_name": "G\u0103ng tay",
                    "image": "79f2856398df8a1bee8c17012b640057",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036406,
                    "display_name": "Th\u1eaft l\u01b0ng/D\u00e2y n\u1ecbt",
                    "image": "40833a50a148866b290105da2fe5955c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036407,
                    "display_name": "T\u1ea5t",
                    "image": "a6341a292b7023564a307703f10200bc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036408,
                    "display_name": "Kh\u0103n",
                    "image": "645485b7347b7ea9a198625c85b2b4a8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036409,
                    "display_name": "\u0110\u1ed3ng h\u1ed3",
                    "image": "6bcebaf5e5d57c2e1ed291d9350a4936",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036410,
                    "display_name": "V\u00f2ng tay",
                    "image": "a54b7b2b0019bbc70aae9f9996241242",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036411,
                    "display_name": "Khuy\u00ean tai",
                    "image": "8e133a3902075432042998cdcacb6cdd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036412,
                    "display_name": "V\u00f2ng c\u1ed5",
                    "image": "6e70f9cb8a460595f71f06e65575dafc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036413,
                    "display_name": "Nh\u1eabn",
                    "image": "dcb7b27b1cf4c0cdeac3c24ba901d402",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036414,
                    "display_name": "\u00c1o m\u01b0a",
                    "image": "dc20f3e1b81905ee1b1cd85050a23910",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036415,
                    "display_name": "\u1ee6ng \u0111i m\u01b0a",
                    "image": "01fc0597866b4952dd282c0cea356bf8",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036932,
                "display_name": "\u0110\u1ed3 Ch\u01a1i",
                "name": "Toys",
                "image": "ce8f8abc726cafff671d0e5311caa684",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 199,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036939,
                "display_name": "\u0110\u1ed3 ch\u01a1i gi\u1ea3i tr\u00ed",
                "name": "Game Zone",
                "image": "4d10f34faaef7987b7aa4f6c3e64b1fb",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 192,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036940,
                    "display_name": "\u0110\u1ed3 ch\u01a1i con xoay",
                    "image": "e657612dd9290d811269c3eacc5d3a44",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036941,
                    "display_name": "\u0110\u1ed3 ch\u01a1i \u0111i\u1ec1u khi\u1ec3n t\u1eeb xa",
                    "image": "cc4a4f56e757188c7ab7ec61b421e3d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036942,
                    "display_name": "\u0110\u1ed3 ch\u01a1i th\u1ebb b\u00e0i, c\u1edd b\u00e0n",
                    "image": "c2b8dc556c00aa3b41bbb25f04b085ed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036943,
                    "display_name": "\u0110\u1ed3 ch\u01a1i trong nh\u00e0",
                    "image": "2089de608a61ebec125e508e241b7364",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036944,
                    "display_name": "\u0110\u1ed3 ch\u01a1i \u0111i\u1ec7n t\u1eed & ph\u1ee5 ki\u1ec7n",
                    "image": "32a34f3ed59e6176ddc103d80ebf0721",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036945,
                    "display_name": "\u0110\u1ed3 ch\u01a1i b\u1ea3ng phi ti\u00eau",
                    "image": "fdd680e064eae69349cd2289116d20e3",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036946,
                "display_name": "\u0110\u1ed3 ch\u01a1i gi\u00e1o d\u1ee5c",
                "name": "Educational Toys",
                "image": "de7fd24ef0e894da4cb1761c75934611",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 185,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036947,
                    "display_name": "\u0110\u1ed3 ch\u01a1i th\u1ee7 c\u00f4ng m\u1ef9 thu\u1eadt",
                    "image": "b98ed011810cb99dc1c100772ca42db6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036948,
                    "display_name": "\u0110\u1ed3 ch\u01a1i t\u00ednh to\u00e1n v\u00e0 s\u1ed1 h\u1ecdc",
                    "image": "99506003d93fe4397996ce1eba51e298",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036949,
                    "display_name": "\u0110\u1ed3 ch\u01a1i khoa h\u1ecdc",
                    "image": "db08c74705c0e90b7e44c8ee39cda40e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036950,
                    "display_name": "\u0110\u1ed3 ch\u01a1i h\u1ecdc t\u1eadp c\u01a1 b\u1ea3n",
                    "image": "538d410922b4127b86198e8b46767f03",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036951,
                    "display_name": "\u0110\u1ed3 ch\u01a1i x\u1ebfp h\u00ecnh & x\u00e2y d\u1ef1ng",
                    "image": "5abaf42a83e6b49c5cd5202c40d5d3ba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036952,
                    "display_name": "\u0110\u1ed3 ch\u01a1i nh\u1ea1c c\u1ee5",
                    "image": "50d85ca667756c19806b77d4bc588c07",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036953,
                    "display_name": "\u0110\u1ed3 ch\u01a1i nh\u1eadp vai",
                    "image": "33b05908e197dc952450e81fd87cc9af",
                    "block_buyer_platform": null
                }, {"catid": 11108536, "display_name": "S\u00e1ch V\u1ea3i", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11036954,
                "display_name": "\u0110\u1ed3 ch\u01a1i cho tr\u1ebb s\u01a1 sinh & tr\u1ebb nh\u1ecf",
                "name": "Baby & Toddler Toys",
                "image": "f965229d351717c4f5ccacabbd576e1c",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 177,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036956,
                    "display_name": "\u0110\u1ed3 ch\u01a1i l\u1ee5c l\u1ea1c",
                    "image": "bdca577725c30e0d4fa60e99cc6f03d5",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036957,
                    "display_name": "\u0110\u1ed3 ch\u01a1i th\u1ea3m nh\u1ea1c",
                    "image": "f95cb01e8cc7e7f395bd1e5c7cebbbe3",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036958,
                    "display_name": "\u0110\u1ed3 ch\u01a1i nh\u00e0 t\u1eafm",
                    "image": "7dc020bc2e2f176c9e91b830ec6b1e90",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036959,
                    "display_name": "\u0110\u1ed3 ch\u01a1i l\u1eafp r\u00e1p",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036960,
                "display_name": "\u0110\u1ed3 ch\u01a1i v\u1eadn \u0111\u1ed9ng & ngo\u00e0i tr\u1eddi",
                "name": "Action & Outdoor Toys",
                "image": "25779cc2ea10f0b0a547aebd03ae9188",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 172,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036961,
                    "display_name": "Xe scooter, xe oto \u0111i\u1ec7n",
                    "image": "9a3ab04bd0f629b5d76c8e3f925d60fb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036962,
                    "display_name": "B\u1ec3 b\u01a1i, phao b\u01a1i, h\u1ed3 b\u01a1i",
                    "image": "dd420848558773105969c75518db1b3d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036963,
                    "display_name": "L\u1ec1u b\u00f3ng, nh\u00e0 banh",
                    "image": "d1781f5cd8d8b4f90bb5c506e16e7ce9",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036964,
                    "display_name": "\u0110\u1ed3 ch\u01a1i th\u1ec3 thao",
                    "image": "6ade8ceb91b8e0b569e77a6703eccaaa",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036965,
                    "display_name": "\u0110\u1ed3 ch\u01a1i h\u00e0nh \u0111\u1ed9ng",
                    "image": "a4d638351c44183e7f1742679133ec1c",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036966,
                "display_name": "B\u00fap b\u00ea & \u0110\u1ed3 ch\u01a1i nh\u1ed3i b\u00f4ng",
                "name": "Dolls & Stuffed Toys",
                "image": "db2b3b2cbba455997fc7a02374d399a7",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 166,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036967,
                    "display_name": "B\u00fap b\u00ea, ph\u1ee5 ki\u1ec7n",
                    "image": "f5378cd488dcd8397217499b6253822b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036968,
                    "display_name": "\u0110\u1ed3 ch\u01a1i nh\u00e0 b\u00fap b\u00ea",
                    "image": "608938f17c46feb10a1dc535a7d5c75d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036969,
                    "display_name": "G\u1ea5u b\u00f4ng",
                    "image": "c2508a38ec0c8d072bde088e62b15914",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036970,
                    "display_name": "Kh\u00e1c",
                    "image": "126c57bd22d4c410ba88c8702f8ea2d0",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036933,
                "display_name": "S\u1edf th\u00edch & S\u01b0u t\u1ea7m",
                "name": "Hobbies & Collectibles",
                "image": "",
                "is_adult": null,
                "parent_category": 11036932,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036934,
                    "display_name": "M\u00f4 h\u00ecnh nh\u00e2n v\u1eadt",
                    "image": "b7346d08c7708ba741a89d44b9ad2de0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036935,
                    "display_name": "Gundam",
                    "image": "acfab7c601c41458eed5bf8625173532",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036936,
                    "display_name": "M\u00f4 h\u00ecnh t\u0129nh",
                    "image": "3d61b6b5cd1496d4d821a8777098e65f",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036937,
                    "display_name": "Kh\u00e1c",
                    "image": "2a8231bb5384488be9fad58a18337e62",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036938,
                    "display_name": "\u0110\u1ed3 ch\u01a1i h\u00f3a trang",
                    "image": "4254574d031b1c305ed0a878732f5d1b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116726,
                    "display_name": "Th\u1ea7n t\u01b0\u1ee3ng, Kpop",
                    "image": "vn-50009109-f7815ed2e464e2daee91239e3f222c21",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036624,
                "display_name": "Gi\u1eb7t Gi\u0169 & Ch\u0103m S\u00f3c Nh\u00e0 C\u1eeda",
                "name": "Home care",
                "image": "cd8e0d2e6c14c4904058ae20821d0763",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 161,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036625,
                "display_name": "Gi\u1eb7t gi\u0169 & Ch\u0103m s\u00f3c nh\u00e0 c\u1eeda",
                "name": "Laundry",
                "image": "efd8413bc4f66755671036fbefe993a9",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 160,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11053125,
                    "display_name": "Gi\u1ecf Gi\u1eb7t \u1ee7i",
                    "image": "4ff72354d39dacc08c9b540711ac9f83",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053126,
                    "display_name": "T\u00fai Gi\u1eb7t & B\u00f3ng Gi\u1eb7t",
                    "image": "063ce36eb2390bfb3bac868e6c472001",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053127,
                    "display_name": "Gi\u00e1 ph\u01a1i qu\u1ea7n \u00e1o",
                    "image": "baabe433c43a2661ec3efdf2c4fd9654",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053128,
                    "display_name": "M\u00f3c treo & K\u1eb9p qu\u1ea7n \u00e1o",
                    "image": "2a5ecdfad6b1a8372e90a87b170e215b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053129,
                    "display_name": "C\u1ea7u l\u00e0 qu\u1ea7n \u00e1o",
                    "image": "7c38526dc35d28e05478c5b73ea630f1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036626,
                    "display_name": "Kh\u00e1c",
                    "image": "6768668de251ae11b6661ca6cbd79b3c",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036629,
                    "display_name": "Vi\u00ean gi\u1eb7t",
                    "image": "1fe415d98e0e8559d580307c459a93bd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036630,
                    "display_name": "Ch\u1ea5t l\u00e0m m\u1ec1m qu\u1ea7n \u00e1o",
                    "image": "dd280e5e9429d6553b3187c6610cefcf",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036631,
                    "display_name": "Ch\u1ea5t t\u1ea9y qu\u1ea7n \u00e1o",
                    "image": "b89b14ee3faa02dc149c54ab9e3eb1b8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036632,
                    "display_name": "Ch\u1ea5t l\u00e0m s\u1ea1ch m\u00e1y gi\u1eb7t",
                    "image": "aaa6732922024354990b89f0b6da3cef",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036633,
                    "display_name": "N\u01b0\u1edbc \u1ee7i qu\u1ea7n \u00e1o",
                    "image": "8404345a5c861fede51deb2aa92b7c36",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036628,
                    "display_name": "N\u01b0\u1edbc gi\u1eb7t",
                    "image": "",
                    "block_buyer_platform": null
                }, {"catid": 11036627, "display_name": "B\u1ed9t gi\u1eb7t", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11036634,
                "display_name": "Gi\u1ea5y v\u1ec7 sinh, kh\u0103n gi\u1ea5y",
                "name": "Toilet Paper",
                "image": "f51ffcf198ab7fbc5053eaf5db94b88c",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 146,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036635,
                    "display_name": "Kh\u00e1c",
                    "image": "7be27e0440f9ea10afa68b4e174ab277",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036636,
                    "display_name": "Gi\u1ea5y v\u1ec7 sinh cu\u1ed9n",
                    "image": "288b05baa4dc3fa8443ac8cf7e2199fb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036637,
                    "display_name": "Gi\u1ea5y \u0103n",
                    "image": "ddcb2b1d4790ea76cd526d355ae64894",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036638,
                    "display_name": "Kh\u0103n gi\u1ea5y \u01b0\u1edbt",
                    "image": "de1c90f30c7d5514383a237f3f418892",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036639,
                "display_name": "V\u1ec7 sinh nh\u00e0 c\u1eeda",
                "name": "Household Cleaning",
                "image": "007e188dd263ae5f336771b79c94ab13",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 141,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036640,
                    "display_name": "Kh\u00e1c",
                    "image": "297b9f066da691e366d16fdfc0dfaf78",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036641,
                    "display_name": "Ch\u1ea5t t\u1ea9y \u0111a n\u0103ng",
                    "image": "5e036b3452d052470d056e9ffd781ce1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036642,
                    "display_name": "Ch\u1ea5t t\u1ea9y v\u00e0 Kh\u1eed m\u00f9i b\u1ed3n c\u1ea7u",
                    "image": "871a9730a239eaa3da68b5bc2e92a8db",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036643,
                    "display_name": "N\u01b0\u1edbc lau s\u00e0n",
                    "image": "08b84505a5153d6b1e71babad2f6921d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036644,
                    "display_name": "N\u01b0\u1edbc lau k\u00ednh",
                    "image": "9f553d8551810b7738bbdf7fc4c7b628",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036645,
                    "display_name": "N\u01b0\u1edbc lau b\u1ebfp",
                    "image": "c519784e62caf38a828d0a77eedadb4b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036646,
                    "display_name": "Ch\u1ea5t l\u00e0m s\u1ea1ch v\u00e0 kh\u1eed m\u00f9i th\u1ea3m",
                    "image": "e7040cf2b492d42909f73ada2cda424f",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036647,
                "display_name": "V\u1ec7 sinh b\u00e1t \u0111\u0129a",
                "name": "Dishwashing",
                "image": "284e7c48e09adbb998dc1e2c52ad400a",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 133,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11053130,
                    "display_name": "N\u01b0\u1edbc R\u1eeda Ch\u00e9n Cho M\u00e1y",
                    "image": "0e48f107f71d5ca464c42a1dc3258c04",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053131,
                    "display_name": "N\u01b0\u1edbc R\u1eeda B\u00e1t H\u1eefu C\u01a1",
                    "image": "55b34d5f18bb4d6c2ac141edf8feb9a7",
                    "block_buyer_platform": null
                }, {
                    "catid": 11053132,
                    "display_name": "N\u01b0\u1edbc R\u1eeda Ch\u00e9n B\u1eb1ng Tay",
                    "image": "626b9c03382afdefd9b2bde0d96d633e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036648,
                    "display_name": "Kh\u00e1c",
                    "image": "da49ffee07ad53ccb9cf9ecc32315bc5",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036649,
                "display_name": "D\u1ee5ng c\u1ee5 v\u1ec7 sinh",
                "name": "Cleaning Tools",
                "image": "7f64b16f8fbc4854c5e003435b9602ae",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 128,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036650,
                    "display_name": "Kh\u00e1c",
                    "image": "5a30fe375cda8b47c92f1f4cc41c975e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036653,
                    "display_name": "Mi\u1ebfng c\u1ecd r\u1eeda, G\u1eady c\u1ecd r\u1eeda",
                    "image": "6e62bdef26caf642d7fc9091d43eda0d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036654,
                "display_name": "Ch\u1ea5t kh\u1eed m\u00f9i, l\u00e0m th\u01a1m",
                "name": "Air Fresheners",
                "image": "eb492afed24081599f13aa23f44bce12",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 123,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036655,
                    "display_name": "Kh\u00e1c",
                    "image": "a3e77a722e238c26da7f5ab4a1c44b37",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036656,
                    "display_name": "S\u00e1p th\u01a1m",
                    "image": "578f2d572c16a2bbb2a22787669a8df8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036657,
                    "display_name": "X\u1ecbt th\u01a1m",
                    "image": "24a95c4459facea8a73b1256de0624ba",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036658,
                    "display_name": "T\u00fai th\u01a1m",
                    "image": "ddbc8719e94655d0994280971f477960",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036659,
                    "display_name": "Gi\u1ea5y th\u01a1m ph\u00f2ng, qu\u1ea7n \u00e1o",
                    "image": "f7e89941ca36430cc0b74eec9ae567ce",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036660,
                "display_name": "Thu\u1ed1c di\u1ec7t c\u00f4n tr\u00f9ng",
                "name": "Insect Killer",
                "image": "e42180830be8f28088d6068c6f76c6b8",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 117,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036661,
                    "display_name": "Kh\u00e1c",
                    "image": "e33a1d0c68b69b16a10e69ae04b15c34",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036662,
                    "display_name": "B\u00ecnh x\u1ecbt di\u1ec7t c\u00f4n tr\u00f9ng",
                    "image": "846891f68c10943332ad94ed6138e9fb",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036663,
                    "display_name": "H\u00f3a ch\u1ea5t di\u1ec7t c\u00f4n tr\u00f9ng",
                    "image": "f2c7de01d98aba6cca6c72c619dec8fb",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036668,
                "display_name": "Bao b\u00ec, t\u00fai \u0111\u1ef1ng r\u00e1c",
                "name": "Trash Bags",
                "image": "7ad4a27ebc3838c365cd50d144f51002",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 109,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036669,
                    "display_name": "Kh\u00e1c",
                    "image": "8b1cdc12b1f4865c8867387cc6280292",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036664,
                "display_name": "T\u00fai, m\u00e0ng b\u1ecdc th\u1ef1c ph\u1ea9m",
                "name": "Food preservation",
                "image": "",
                "is_adult": null,
                "parent_category": 11036624,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036667,
                    "display_name": "M\u00e0ng b\u1ecdc th\u1ef1c ph\u1ea9m",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11036478,
                "display_name": "Ch\u0103m S\u00f3c Th\u00fa C\u01b0ng",
                "name": "Pets",
                "image": "cdf21b1bf4bfff257efe29054ecea1ec",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 107,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11036479,
                "display_name": "Th\u1ee9c \u0103n cho th\u00fa c\u01b0ng",
                "name": "Pet Food",
                "image": "1f4ecf5cbd05ac1ee06a4be19e24f880",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 106,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036480,
                    "display_name": "Th\u1ee9c \u0103n cho ch\u00f3",
                    "image": "6168598018dae7508211e4510beba4ed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036481,
                    "display_name": "Snack cho ch\u00f3",
                    "image": "67296608aa11e4b5f584670116ef7aff",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036482,
                    "display_name": "Th\u1ee9c \u0103n cho m\u00e8o",
                    "image": "77c00103f9fee62577736d1755edc243",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036483,
                    "display_name": "Snack cho m\u00e8o",
                    "image": "01d210251366bc02a65bc3fbb8639a93",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036484,
                    "display_name": "Th\u1ee9c \u0103n cho th\u00fa nh\u1ecf",
                    "image": "3ea80af26cd22bbeb9906e35ae36ff70",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036485,
                    "display_name": "Snack cho th\u00fa nh\u1ecf",
                    "image": "dd3ad63d0ae7c06ca1c9fb076746f3cd",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036486,
                    "display_name": "Th\u1ee9c \u0103n cho c\u00e1",
                    "image": "b6331434ef4e4d627c89bd91488ec011",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036487,
                    "display_name": "Th\u1ee9c \u0103n cho chim",
                    "image": "ad541e489dc38c3fbc91ccdb1ad970e0",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036488,
                    "display_name": "Th\u1ee9c \u0103n cho b\u00f2 s\u00e1t",
                    "image": "609d287554db4631ddd760e8984bff5d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036489,
                    "display_name": "Kh\u00e1c",
                    "image": "88db62683006474218e387423fac3e3d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036490,
                "display_name": "Ph\u1ee5 ki\u1ec7n cho th\u00fa c\u01b0ng",
                "name": "Pet Accessories",
                "image": "379271c2d983f2c16ef41b7f8b564415",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 95,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036491,
                    "display_name": "B\u00e1t & d\u1ee5ng c\u1ee5 \u0103n",
                    "image": "0187dd729bbbda8b4f6a41cb2d9d2c87",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036492,
                    "display_name": "Thi\u1ebft b\u1ecb du l\u1ecbch",
                    "image": "f5ebdf9cd3c83d68d0c9147fe6d93f91",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036493,
                    "display_name": "V\u00f2ng c\u1ed5, d\u00e2y d\u1eaft & r\u1ecd m\u00f5m",
                    "image": "8669da2b7cc274764bb92a7e585b32a2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036494,
                    "display_name": "\u0110\u1ed3 ch\u01a1i",
                    "image": "3a4c597ee412256dbd369fbbd925ec4e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036495,
                    "display_name": "N\u1ed9i th\u1ea5t cho th\u00fa c\u01b0ng",
                    "image": "1dac06cca69351fb60450d7296f0492b",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036496,
                    "display_name": "Ph\u1ee5 ki\u1ec7n th\u1ee7y sinh",
                    "image": "d9f2419c9f41679e33ca6a26ba62085d",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036497,
                    "display_name": "Kh\u00e1c",
                    "image": "b09500fbaf5aa5c071af6779b68f176d",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036498,
                "display_name": "V\u1ec7 sinh cho th\u00fa c\u01b0ng",
                "name": "Litter & Toilet",
                "image": "b2c05b4fa41fc65e5aab1b55f59adf0c",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 87,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036499,
                    "display_name": "Khay & B\u1ed3n v\u1ec7 sinh cho m\u00e8o",
                    "image": "b3f3ac0697a9902d1a438aabfe2f9872",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036500,
                    "display_name": "L\u00f3t chu\u1ed3ng cho th\u00fa nh\u1ecf",
                    "image": "76104d43ef11331e61cc406ed7676020",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036501,
                    "display_name": "T\u00e3 cho th\u00fa c\u01b0ng",
                    "image": "f40a3d3a5724c55e699a8f4f168e794e",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036502,
                    "display_name": "Khay hu\u1ea5n luy\u1ec7n v\u1ec7 sinh cho ch\u00f3",
                    "image": "fad39aac68b947a638d5990ad817b936",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036503,
                    "display_name": "T\u00fai & X\u1ebbng d\u1ecdn v\u1ec7 sinh",
                    "image": "5a16929a573e0636923b2b72cefbe4cc",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036504,
                    "display_name": "Kh\u00e1c",
                    "image": "e91e5f3c2ffa97c56d940651fc72bd38",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036510,
                "display_name": "Qu\u1ea7n \u00e1o th\u00fa c\u01b0ng",
                "name": "Pet Clothing & Accessories",
                "image": "d6d6137d38d917511cb1ebc89d03f8ca",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 77,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036511,
                    "display_name": "Qu\u1ea7n \u00e1o th\u00fa c\u01b0ng",
                    "image": "b07c0c65b8d98ef844aaa25f2eddbf61",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036512,
                    "display_name": "\u00c1o m\u01b0a ch\u00f3 m\u00e8o",
                    "image": "55e5d8c25a96aa39d663217146330c1a",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036513,
                    "display_name": "Gi\u00e0y, t\u1ea5t & b\u1ea3o v\u1ec7 m\u00f3ng",
                    "image": "caf84adcb51e4beab65f1ebf43f19647",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036514,
                    "display_name": "Ph\u1ee5 ki\u1ec7n \u0111eo c\u1ed5",
                    "image": "38dcb09154272689d56e1954868ef4ed",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036515,
                    "display_name": "K\u00ednh m\u1eaft",
                    "image": "7603c7a9b6c39f2d9e316ea832ed9c27",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036516,
                    "display_name": "Ph\u1ee5 ki\u1ec7n l\u00f4ng",
                    "image": "aae406ad277aafdc7c1f6e3d309885f2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036517,
                    "display_name": "M\u0169 n\u00f3n th\u00fa c\u01b0ng",
                    "image": "fa8535c96593ef264f95a8df4387fff6",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036518,
                    "display_name": "Kh\u00e1c",
                    "image": "a8c787e63c2ba856574fa070aa0a6906",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036519,
                "display_name": "Ch\u0103m s\u00f3c s\u1ee9c kh\u1ecfe",
                "name": "Pet Healthcare",
                "image": "ce7baeab34604200b0ab12d2b17cf52f",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 68,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036520,
                    "display_name": "T\u1ea9y giun & di\u1ec7t b\u1ecd ch\u00e9t",
                    "image": "93152214df26834bfa00ef4430753851",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036521,
                    "display_name": "D\u01b0\u1ee3c ph\u1ea9m",
                    "image": "cee6f32c020bd63735e7836dcbb20b64",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036522,
                    "display_name": "Kh\u00e1c",
                    "image": "f8b263e82e8fa4ad36f68c1d2143b9e1",
                    "block_buyer_platform": null
                }, {
                    "catid": 11036523,
                    "display_name": "Vitamin & ch\u1ea5t b\u1ed5 sung dinh d\u01b0\u1ee1ng",
                    "image": "89ba7a21d9c5b14caa20ba2896adbf90",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11036524,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "998d0fc4b808406657d4b95b53eb1c04",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 63,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11116223,
                "display_name": "L\u00e0m \u0111\u1eb9p cho th\u00fa c\u01b0ng",
                "name": "Pet Grooming",
                "image": "32c6df2d02d238f7c4899f7af16fb4b2",
                "is_adult": null,
                "parent_category": 11036478,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11036505,
                    "display_name": "Ch\u0103m s\u00f3c l\u00f4ng",
                    "image": "8c02fe66f2a4e677cd767c52208ec9b8",
                    "block_buyer_platform": null
                }, {
                    "catid": 11040423,
                    "display_name": "Ch\u0103m s\u00f3c r\u0103ng mi\u1ec7ng",
                    "image": "c3a9fa4aaba275f1bc244acfcfc26087",
                    "block_buyer_platform": null
                }, {
                    "catid": 11040424,
                    "display_name": "Ch\u0103m s\u00f3c m\u00f3ng",
                    "image": "6034a542cfba0033493e3dbcaa7185a2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116224,
                    "display_name": "Kh\u00e1c",
                    "image": "72fbcc111643b0a4c61ee157beb53336",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11082137,
                "display_name": "Deal G\u1ea7n B\u1ea1n",
                "name": "Deals Near Me",
                "image": "05a94dadbddcf5414668f1ebabf9d33c",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 62,
                "block_buyer_platform": [3, 1, 5, 4, 2]
            },
            "sub": [{
                "catid": 11082138,
                "display_name": "Scan & Pay Voucher",
                "name": "Scan & Pay Voucher",
                "image": "b6df4a9fe9c2c25d0ce605e4c1796a87",
                "is_adult": null,
                "parent_category": 11082137,
                "sort_weight": 61,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11082140,
                    "display_name": "Scan & Pay Voucher",
                    "image": "c99664cc9eb3fee8919884968e96285b",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11082139,
                "display_name": "Deals",
                "name": "Deals",
                "image": "20d3d80a7f39f3097378036862eb4742",
                "is_adult": null,
                "parent_category": 11082137,
                "sort_weight": 59,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11082141,
                    "display_name": "Deals",
                    "image": "920d287468f531bb36e8093d042a8d70",
                    "block_buyer_platform": null
                }]
            }]
        }, {
            "main": {
                "catid": 11035898,
                "display_name": "Voucher & D\u1ecbch V\u1ee5",
                "name": "Tickets, Vouchers & Services",
                "image": "b0f78c3136d2d78d49af71dd1c3f38c1",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 57,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11035905,
                "display_name": "Nh\u00e0 h\u00e0ng & \u0102n u\u1ed1ng",
                "name": "F&B",
                "image": "093fda5d8f004b041e956b068a724f16",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 56,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035906,
                    "display_name": "\u0102n t\u1ea1i ch\u1ed7 & Mang \u0111i",
                    "image": "86e53182e80be450901020582645abb2",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035907,
                    "display_name": "Giao th\u1ee9c \u0103n",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035908,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035899,
                "display_name": "S\u1ef1 ki\u1ec7n & Gi\u1ea3i tr\u00ed",
                "name": "Events & Attractions",
                "image": "f9a15d23a1bcefcfed2b9de61aeccab1",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 52,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035904,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035900,
                    "display_name": "C\u00f4ng vi\u00ean gi\u1ea3i tr\u00ed",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035901,
                    "display_name": "S\u1ef1 ki\u1ec7n & H\u1ed9i th\u1ea3o",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035902,
                    "display_name": "V\u00e9 xem phim - K\u1ecbch",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035903,
                    "display_name": "H\u00f2a nh\u1ea1c & Tri\u1ec3n l\u00e3m",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035931,
                "display_name": "N\u1ea1p ti\u1ec1n t\u00e0i kho\u1ea3n",
                "name": "Telco",
                "image": "59c4f9c996eb1f96198a36f104431e88",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 46,
                "block_buyer_platform": [1, 2],
                "sub_sub": [{
                    "catid": 11035932,
                    "display_name": "Internet & Truy\u1ec1n h\u00ecnh c\u00e1p",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035933,
                    "display_name": "G\u00f3i data 3G/4G",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": [1, 2]
                }, {
                    "catid": 11035934,
                    "display_name": "N\u1ea1p tr\u1ef1c ti\u1ebfp & Mua m\u00e3 th\u1ebb",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": [1, 2]
                }, {
                    "catid": 11035935,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": [1, 2]
                }]
            }, {
                "catid": 11035922,
                "display_name": "S\u1ee9c kh\u1ecfe & L\u00e0m \u0111\u1eb9p",
                "name": "Beauty & Wellness",
                "image": "1b734a1b353460b284aa740f80871fcb",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 41,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035923,
                    "display_name": "Ch\u0103m s\u00f3c s\u1ee9c kh\u1ecfe",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035924,
                    "display_name": "Nha khoa",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035925,
                    "display_name": "Gym & Yoga",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035926,
                    "display_name": "Salon t\u00f3c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035927,
                    "display_name": "Spa & Massage",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035928,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035929,
                "display_name": "G\u1ecdi xe",
                "name": "Transport",
                "image": "2c9bd264d89d2b8aba183814f53ed545",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 34,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035930,
                "display_name": "Kh\u00f3a h\u1ecdc",
                "name": "Lessons & Workshops",
                "image": "87595e935bbc6e436afba0a83b8e18d0",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 33,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035936,
                "display_name": "Du l\u1ecbch & Kh\u00e1ch s\u1ea1n",
                "name": "Travel",
                "image": "8b57fa895a34ed7772a7e50bd5ae6142",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 32,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035937,
                    "display_name": "\u0110\u1eb7t ph\u00f2ng",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035938,
                    "display_name": "Su\u1ed1i n\u01b0\u1edbc n\u00f3ng",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035939,
                    "display_name": "V\u00e9 m\u00e1y bay",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035940,
                    "display_name": "V\u00e9 t\u00e0u l\u1eeda",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035941,
                    "display_name": "V\u00e9 xe bu\u00fdt",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035942,
                    "display_name": "Thu\u00ea ph\u01b0\u01a1ng ti\u1ec7n",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035943,
                    "display_name": "Tour du l\u1ecbch",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035944,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035909,
                "display_name": "Mua s\u1eafm",
                "name": "Shopping",
                "image": "7656175c75f5f62ce82e1b526083b80e",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 23,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035910,
                    "display_name": "Trung t\u00e2m th\u01b0\u01a1ng m\u1ea1i",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035911,
                    "display_name": "Si\u00eau th\u1ecb",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035912,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035949,
                "display_name": "M\u00e3 qu\u00e0 t\u1eb7ng Shopee",
                "name": "Shopee",
                "image": "d033ba5e567a2c1559de88dac94719da",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 19,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035950,
                    "display_name": "Shopee Official",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": [1, 2]
                }, {
                    "catid": 11035951,
                    "display_name": "Ph\u00ed qu\u1ea3ng c\u00e1o Shopee",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035952,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035913,
                "display_name": "Thanh to\u00e1n h\u00f3a \u0111\u01a1n",
                "name": "Utilities",
                "image": "c50a8983a31f5c9aed8d876403db12b9",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 15,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11035914,
                "display_name": "D\u1ecbch v\u1ee5 kh\u00e1c",
                "name": "Services",
                "image": "680c03454d4a8e6510cde78faa437224",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 14,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11035915,
                    "display_name": "D\u1ecdn d\u1eb9p nh\u00e0 c\u1eeda",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035916,
                    "display_name": "Giao & V\u1eadn chuy\u1ec3n h\u00e0ng h\u00f3a",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035917,
                    "display_name": "B\u1ea3o hi\u1ec3m",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035918,
                    "display_name": "L\u1eafp \u0111\u1eb7t s\u1eeda ch\u1eefa m\u00e1y l\u1ea1nh",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035919,
                    "display_name": "G\u00f3i ch\u1ee5p h\u00ecnh",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035920,
                    "display_name": "Thi\u1ebft k\u1ebf",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }, {
                    "catid": 11035921,
                    "display_name": "Kh\u00e1c",
                    "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11035945,
                "display_name": "Ti\u1ec1n \u0111i\u1ec7n t\u1eed",
                "name": "E-Money",
                "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 6,
                "block_buyer_platform": [1, 2, 3, 4, 5],
                "sub_sub": []
            }, {
                "catid": 11035947,
                "display_name": "Th\u1ebb game",
                "name": "Gaming & App Stores",
                "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 4,
                "block_buyer_platform": [1, 2, 3, 4, 5],
                "sub_sub": []
            }, {
                "catid": 11035948,
                "display_name": "Streaming",
                "name": "Streaming",
                "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 3,
                "block_buyer_platform": [1, 2, 3, 4, 5],
                "sub_sub": []
            }, {
                "catid": 11035953,
                "display_name": "Kh\u00e1c",
                "name": "Others",
                "image": "bb3c3e8c201fe452a285a71fd27b2f60",
                "is_adult": null,
                "parent_category": 11035898,
                "sort_weight": 2,
                "block_buyer_platform": [1, 2, 3, 4, 5],
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11116421,
                "display_name": "N\u1ea1p Ti\u1ec1n, H\u00f3a \u0110\u01a1n, Phim & Kh\u00e1c",
                "name": "Digital Products",
                "image": "",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 0,
                "block_buyer_platform": null
            },
            "sub": [{
                "catid": 11116422,
                "display_name": "N\u1ea1p \u0110i\u1ec7n Tho\u1ea1i",
                "name": "Phone Credit Top-Up",
                "image": "",
                "is_adult": null,
                "parent_category": 11116421,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11116423,
                "display_name": "N\u1ea1p Data 3G/4G",
                "name": "Data Package Top-Up",
                "image": "",
                "is_adult": null,
                "parent_category": 11116421,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11116424,
                "display_name": "Th\u1ebb \u0110i\u1ec7n Tho\u1ea1i",
                "name": "Cash Card EPIN",
                "image": "",
                "is_adult": null,
                "parent_category": 11116421,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11116425,
                "display_name": "G\u00f3i Data 3G/4G",
                "name": "Data Package EPIN",
                "image": "",
                "is_adult": null,
                "parent_category": 11116421,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }, {
                "catid": 11116426,
                "display_name": "M\u00e3 \u01afu \u0110\u00e3i",
                "name": "E-Voucher",
                "image": "",
                "is_adult": null,
                "parent_category": 11116421,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": []
            }]
        }, {
            "main": {
                "catid": 11116484,
                "display_name": "D\u1ee5ng c\u1ee5 v\u00e0 thi\u1ebft b\u1ecb ti\u1ec7n \u00edch",
                "name": "Tools & Home Improvement",
                "image": "e4fbccba5e1189d1141b9d6188af79c0",
                "is_adult": null,
                "parent_category": 0,
                "sort_weight": 0,
                "block_buyer_platform": null
            }, "sub": [{
                "catid": 11116485,
                "display_name": "D\u1ee5ng c\u1ee5 \u0111i\u1ec7n v\u00e0 thi\u1ebft b\u1ecb l\u1edbn",
                "name": "Large tools and equipment",
                "image": "4e2ddf616cedf5f1f5e5439976adb33e",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116516,
                    "display_name": "M\u00e1y b\u01a1m kh\u00ed & ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116517,
                    "display_name": "C\u01b0a, m\u00e1y c\u1eaft v\u00e0 m\u00e1y m\u00e0i",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116518,
                    "display_name": "M\u00e1y r\u1eeda \u00e1p l\u1ef1c n\u01b0\u1edbc",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116519,
                    "display_name": "M\u00e1y ph\u00e1t \u0111i\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116520,
                    "display_name": "M\u00e1y \u0111o \u0111i\u1ec7n & \u0111\u1ed3ng h\u1ed3 v\u1ea1n n\u0103ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116521,
                    "display_name": "\u1ed0ng th\u0103ng b\u1eb1ng & b\u00e1nh xe \u0111o",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116522,
                    "display_name": "M\u00e1y \u0111o kho\u1ea3ng c\u00e1ch",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116523,
                    "display_name": "M\u00e1y n\u00e9n kh\u00ed",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116524,
                    "display_name": "D\u1ee5ng c\u1ee5 h\u00e0n \u0111i\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116525,
                    "display_name": "M\u00e1y th\u1ed5i",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116526,
                    "display_name": "M\u00e1y b\u01a1m n\u01b0\u1edbc & ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116527,
                    "display_name": "Thi\u1ebft b\u1ecb kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11116486,
                "display_name": "Thi\u1ebft b\u1ecb v\u00e0 ph\u1ee5 ki\u1ec7n x\u00e2y d\u1ef1ng",
                "name": "Accessories",
                "image": "7605a30bf19b0fceb4a01863d4188a40",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116490,
                    "display_name": "G\u0103ng tay, k\u00ednh b\u1ea3o h\u1ed9 & m\u1eb7t n\u1ea1",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116491,
                    "display_name": "Keo & ch\u1ea5t k\u1ebft d\u00ednh c\u00f4ng nghi\u1ec7p",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116492,
                    "display_name": "D\u1ee5ng c\u1ee5 \u0111o l\u01b0\u1eddng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116493,
                    "display_name": "H\u1ed9p d\u1ee5ng c\u1ee5 c\u1ea7m tay",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116494,
                    "display_name": "Gi\u1ea5y nh\u00e1m, m\u00e1y ch\u00e0 nh\u00e1m v\u00e0 ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {"catid": 11116605, "display_name": "Pin", "image": "", "block_buyer_platform": null}]
            }, {
                "catid": 11116487,
                "display_name": "D\u1ee5ng c\u1ee5 c\u1ea7m tay",
                "name": "Handtool",
                "image": "e5bbe88d50fa708aaabf6bab0a6641b2",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116510,
                    "display_name": "M\u00e1y khoan, m\u00e1y v\u1eb7n v\u00edt & ph\u1ee5 ki\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116511,
                    "display_name": "B\u1ed9 c\u1edd l\u00ea",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116512,
                    "display_name": "B\u00faa",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116513,
                    "display_name": "K\u00ecm",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116514,
                    "display_name": "\u0110inh, v\u00edt & ch\u1ed1t",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116515,
                    "display_name": "D\u1ee5ng c\u1ee5 c\u1ea7m tay kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11116488,
                "display_name": "V\u1eadt li\u1ec7u x\u00e2y d\u1ef1ng",
                "name": "Building and construction",
                "image": "985efb4f0eadd25649b1f6ae1efcb371",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116495,
                    "display_name": "Xe \u0111\u1ea9y",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116496,
                    "display_name": "Ch\u1eadu r\u1eeda & v\u00f2i n\u01b0\u1edbc",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116497,
                    "display_name": "M\u00e1i & s\u00e0n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116498,
                    "display_name": "S\u01a1n & ch\u1ea5t ch\u1ed1ng th\u1ea5m t\u01b0\u1eddng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116499,
                    "display_name": "Thang",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116500,
                    "display_name": "M\u00e1i hi\u00ean, b\u1ea1t ph\u1ee7",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116501,
                    "display_name": "V\u1eadt li\u1ec7u x\u00e2y d\u1ef1ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116502,
                    "display_name": "C\u1eeda & c\u1eeda s\u1ed5",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11116489,
                "display_name": "Thi\u1ebft b\u1ecb m\u1ea1ch \u0111i\u1ec7n",
                "name": "Electrical Circuitry & Parts",
                "image": "eb200b37152ed3e6b0dcbb8169536f90",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116503,
                    "display_name": "\u1ed4 \u0111i\u1ec7n v\u00e0 d\u00e2y n\u1ed1i",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116504,
                    "display_name": "\u1ed4 chuy\u1ec3n \u0111\u1ed5i",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116505,
                    "display_name": "Chu\u00f4ng b\u00e1o \u0111\u1ed9ng",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116506,
                    "display_name": "Chu\u00f4ng c\u1eeda",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116507,
                    "display_name": "Thi\u1ebft b\u1ecb ch\u1ed1ng s\u00e9t",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116508,
                    "display_name": "Thi\u1ebft b\u1ecb an to\u00e0n \u0111i\u1ec7n",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116509,
                    "display_name": "Thi\u1ebft b\u1ecb m\u1ea1ch \u0111i\u1ec7n kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }, {
                "catid": 11116607,
                "display_name": "Thi\u1ebft b\u1ecb an to\u00e0n",
                "name": "Safety and security",
                "image": "a362166bb26dc6eb8f1c6081e58295ba",
                "is_adult": null,
                "parent_category": 11116484,
                "sort_weight": 0,
                "block_buyer_platform": null,
                "sub_sub": [{
                    "catid": 11116608,
                    "display_name": "K\u00e9t s\u1eaft",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116609,
                    "display_name": "Thi\u1ebft b\u1ecb ch\u1eefa ch\u00e1y",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116610,
                    "display_name": "Kh\u00f3a, \u1ed5 kh\u00f3a",
                    "image": "",
                    "block_buyer_platform": null
                }, {
                    "catid": 11116611,
                    "display_name": "Thi\u1ebft b\u1ecb kh\u00e1c",
                    "image": "",
                    "block_buyer_platform": null
                }]
            }]
        }], "error": null, "error_msg": null, "__raw": {}
    },
    "extra_data": null,
    "path": "/api/v1/worker/12347857-f4f3-474a-888a-f41ef1099628",
    "status_code": 200,
    "ip": "127.0.0.1"
}


// WEBPACK FOOTER //
// ./src/addon/shopee_data.js